var BD = Object.defineProperty;
var GD = (e, n, i) => n in e ? BD(e, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[n] = i;
var zf = (e, n, i) => (GD(e, typeof n != "symbol" ? n + "" : n, i), i);
import * as X from "react";
import Wa, { useRef as Vo, useEffect as oc, useCallback as $f } from "react";
import nr from "classnames";
import { Tooltip as VD, tableFilters as Hr, DefaultCell as HD, Badge as zD, Anchor as Ml, Table as $D, Text as rn, Surface as kR, LabeledSelect as jD, InformationPanel as KD, InformationPanelHeader as WD, InformationPanelBody as XD, Label as ln, InformationPanelWrapper as qD, Button as JD, ThemeProvider as QD } from "@itwin/itwinui-react";
import ZD from "@tippyjs/react";
var Qn = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function UR(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vu = { exports: {} }, Ot = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ac, jf;
function YR() {
  if (jf)
    return ac;
  jf = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function t() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch (l) {
      return !1;
    }
  }
  return ac = t() ? Object.assign : function(a, o) {
    for (var s, u = r(a), c, l = 1; l < arguments.length; l++) {
      s = Object(arguments[l]);
      for (var g in s)
        n.call(s, g) && (u[g] = s[g]);
      if (e) {
        c = e(s);
        for (var R = 0; R < c.length; R++)
          i.call(s, c[R]) && (u[c[R]] = s[c[R]]);
      }
    }
    return u;
  }, ac;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kf;
function ep() {
  if (Kf)
    return Ot;
  Kf = 1, YR();
  var e = Wa, n = 60103;
  if (Ot.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var i = Symbol.for;
    n = i("react.element"), Ot.Fragment = i("react.fragment");
  }
  var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, t = Object.prototype.hasOwnProperty, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, u, c) {
    var l, g = {}, R = null, v = null;
    c !== void 0 && (R = "" + c), u.key !== void 0 && (R = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (l in u)
      t.call(u, l) && !a.hasOwnProperty(l) && (g[l] = u[l]);
    if (s && s.defaultProps)
      for (l in u = s.defaultProps, u)
        g[l] === void 0 && (g[l] = u[l]);
    return { $$typeof: n, type: s, key: R, ref: v, props: g, _owner: r.current };
  }
  return Ot.jsx = o, Ot.jsxs = o, Ot;
}
var sc = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wf;
function np() {
  return Wf || (Wf = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = Wa, i = YR(), r = 60103, t = 60106;
      e.Fragment = 60107;
      var a = 60108, o = 60114, s = 60109, u = 60110, c = 60112, l = 60113, g = 60120, R = 60115, v = 60116, f = 60121, p = 60122, D = 60117, C = 60129, _ = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var E = Symbol.for;
        r = E("react.element"), t = E("react.portal"), e.Fragment = E("react.fragment"), a = E("react.strict_mode"), o = E("react.profiler"), s = E("react.provider"), u = E("react.context"), c = E("react.forward_ref"), l = E("react.suspense"), g = E("react.suspense_list"), R = E("react.memo"), v = E("react.lazy"), f = E("react.block"), p = E("react.server.block"), D = E("react.fundamental"), E("react.scope"), E("react.opaque.id"), C = E("react.debug_trace_mode"), E("react.offscreen"), _ = E("react.legacy_hidden");
      }
      var N = typeof Symbol == "function" && Symbol.iterator, O = "@@iterator";
      function d(h) {
        if (h === null || typeof h != "object")
          return null;
        var $ = N && h[N] || h[O];
        return typeof $ == "function" ? $ : null;
      }
      var m = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function y(h) {
        {
          for (var $ = arguments.length, ne = new Array($ > 1 ? $ - 1 : 0), we = 1; we < $; we++)
            ne[we - 1] = arguments[we];
          Y("error", h, ne);
        }
      }
      function Y(h, $, ne) {
        {
          var we = m.ReactDebugCurrentFrame, ze = we.getStackAddendum();
          ze !== "" && ($ += "%s", ne = ne.concat([ze]));
          var $e = ne.map(function(Oe) {
            return "" + Oe;
          });
          $e.unshift("Warning: " + $), Function.prototype.apply.call(console[h], console, $e);
        }
      }
      var k = !1;
      function J(h) {
        return !!(typeof h == "string" || typeof h == "function" || h === e.Fragment || h === o || h === C || h === a || h === l || h === g || h === _ || k || typeof h == "object" && h !== null && (h.$$typeof === v || h.$$typeof === R || h.$$typeof === s || h.$$typeof === u || h.$$typeof === c || h.$$typeof === D || h.$$typeof === f || h[0] === p));
      }
      function te(h, $, ne) {
        var we = $.displayName || $.name || "";
        return h.displayName || (we !== "" ? ne + "(" + we + ")" : ne);
      }
      function I(h) {
        return h.displayName || "Context";
      }
      function T(h) {
        if (h == null)
          return null;
        if (typeof h.tag == "number" && y("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof h == "function")
          return h.displayName || h.name || null;
        if (typeof h == "string")
          return h;
        switch (h) {
          case e.Fragment:
            return "Fragment";
          case t:
            return "Portal";
          case o:
            return "Profiler";
          case a:
            return "StrictMode";
          case l:
            return "Suspense";
          case g:
            return "SuspenseList";
        }
        if (typeof h == "object")
          switch (h.$$typeof) {
            case u:
              var $ = h;
              return I($) + ".Consumer";
            case s:
              var ne = h;
              return I(ne._context) + ".Provider";
            case c:
              return te(h, h.render, "ForwardRef");
            case R:
              return T(h.type);
            case f:
              return T(h._render);
            case v: {
              var we = h, ze = we._payload, $e = we._init;
              try {
                return T($e(ze));
              } catch (Oe) {
                return null;
              }
            }
          }
        return null;
      }
      var j = 0, oe, B, Ce, P, S, M, L;
      function V() {
      }
      V.__reactDisabledLog = !0;
      function ie() {
        {
          if (j === 0) {
            oe = console.log, B = console.info, Ce = console.warn, P = console.error, S = console.group, M = console.groupCollapsed, L = console.groupEnd;
            var h = {
              configurable: !0,
              enumerable: !0,
              value: V,
              writable: !0
            };
            Object.defineProperties(console, {
              info: h,
              log: h,
              warn: h,
              error: h,
              group: h,
              groupCollapsed: h,
              groupEnd: h
            });
          }
          j++;
        }
      }
      function pe() {
        {
          if (j--, j === 0) {
            var h = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: i({}, h, {
                value: oe
              }),
              info: i({}, h, {
                value: B
              }),
              warn: i({}, h, {
                value: Ce
              }),
              error: i({}, h, {
                value: P
              }),
              group: i({}, h, {
                value: S
              }),
              groupCollapsed: i({}, h, {
                value: M
              }),
              groupEnd: i({}, h, {
                value: L
              })
            });
          }
          j < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Se = m.ReactCurrentDispatcher, Ie;
      function ke(h, $, ne) {
        {
          if (Ie === void 0)
            try {
              throw Error();
            } catch (ze) {
              var we = ze.stack.trim().match(/\n( *(at )?)/);
              Ie = we && we[1] || "";
            }
          return `
` + Ie + h;
        }
      }
      var Qe = !1, F;
      {
        var Z = typeof WeakMap == "function" ? WeakMap : Map;
        F = new Z();
      }
      function ge(h, $) {
        if (!h || Qe)
          return "";
        {
          var ne = F.get(h);
          if (ne !== void 0)
            return ne;
        }
        var we;
        Qe = !0;
        var ze = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var $e;
        $e = Se.current, Se.current = null, ie();
        try {
          if ($) {
            var Oe = function() {
              throw Error();
            };
            if (Object.defineProperty(Oe.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Oe, []);
              } catch (Ui) {
                we = Ui;
              }
              Reflect.construct(h, [], Oe);
            } else {
              try {
                Oe.call();
              } catch (Ui) {
                we = Ui;
              }
              h.call(Oe.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Ui) {
              we = Ui;
            }
            h();
          }
        } catch (Ui) {
          if (Ui && we && typeof Ui.stack == "string") {
            for (var Fe = Ui.stack.split(`
`), In = we.stack.split(`
`), on = Fe.length - 1, un = In.length - 1; on >= 1 && un >= 0 && Fe[on] !== In[un]; )
              un--;
            for (; on >= 1 && un >= 0; on--, un--)
              if (Fe[on] !== In[un]) {
                if (on !== 1 || un !== 1)
                  do
                    if (on--, un--, un < 0 || Fe[on] !== In[un]) {
                      var ki = `
` + Fe[on].replace(" at new ", " at ");
                      return typeof h == "function" && F.set(h, ki), ki;
                    }
                  while (on >= 1 && un >= 0);
                break;
              }
          }
        } finally {
          Qe = !1, Se.current = $e, pe(), Error.prepareStackTrace = ze;
        }
        var Lt = h ? h.displayName || h.name : "", Hf = Lt ? ke(Lt) : "";
        return typeof h == "function" && F.set(h, Hf), Hf;
      }
      function ce(h, $, ne) {
        return ge(h, !1);
      }
      function Re(h) {
        var $ = h.prototype;
        return !!($ && $.isReactComponent);
      }
      function Pe(h, $, ne) {
        if (h == null)
          return "";
        if (typeof h == "function")
          return ge(h, Re(h));
        if (typeof h == "string")
          return ke(h);
        switch (h) {
          case l:
            return ke("Suspense");
          case g:
            return ke("SuspenseList");
        }
        if (typeof h == "object")
          switch (h.$$typeof) {
            case c:
              return ce(h.render);
            case R:
              return Pe(h.type, $, ne);
            case f:
              return ce(h._render);
            case v: {
              var we = h, ze = we._payload, $e = we._init;
              try {
                return Pe($e(ze), $, ne);
              } catch (Oe) {
              }
            }
          }
        return "";
      }
      var be = {}, Ve = m.ReactDebugCurrentFrame;
      function Ge(h) {
        if (h) {
          var $ = h._owner, ne = Pe(h.type, h._source, $ ? $.type : null);
          Ve.setExtraStackFrame(ne);
        } else
          Ve.setExtraStackFrame(null);
      }
      function Cn(h, $, ne, we, ze) {
        {
          var $e = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Oe in h)
            if ($e(h, Oe)) {
              var Fe = void 0;
              try {
                if (typeof h[Oe] != "function") {
                  var In = Error((we || "React class") + ": " + ne + " type `" + Oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[Oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw In.name = "Invariant Violation", In;
                }
                Fe = h[Oe]($, Oe, we, ne, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (on) {
                Fe = on;
              }
              Fe && !(Fe instanceof Error) && (Ge(ze), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", we || "React class", ne, Oe, typeof Fe), Ge(null)), Fe instanceof Error && !(Fe.message in be) && (be[Fe.message] = !0, Ge(ze), y("Failed %s type: %s", ne, Fe.message), Ge(null));
            }
        }
      }
      var Dn = m.ReactCurrentOwner, On = Object.prototype.hasOwnProperty, A = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, x, q, H;
      H = {};
      function W(h) {
        if (On.call(h, "ref")) {
          var $ = Object.getOwnPropertyDescriptor(h, "ref").get;
          if ($ && $.isReactWarning)
            return !1;
        }
        return h.ref !== void 0;
      }
      function le(h) {
        if (On.call(h, "key")) {
          var $ = Object.getOwnPropertyDescriptor(h, "key").get;
          if ($ && $.isReactWarning)
            return !1;
        }
        return h.key !== void 0;
      }
      function de(h, $) {
        if (typeof h.ref == "string" && Dn.current && $ && Dn.current.stateNode !== $) {
          var ne = T(Dn.current.type);
          H[ne] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(Dn.current.type), h.ref), H[ne] = !0);
        }
      }
      function Ee(h, $) {
        {
          var ne = function() {
            x || (x = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $));
          };
          ne.isReactWarning = !0, Object.defineProperty(h, "key", {
            get: ne,
            configurable: !0
          });
        }
      }
      function w(h, $) {
        {
          var ne = function() {
            q || (q = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", $));
          };
          ne.isReactWarning = !0, Object.defineProperty(h, "ref", {
            get: ne,
            configurable: !0
          });
        }
      }
      var b = function(h, $, ne, we, ze, $e, Oe) {
        var Fe = {
          $$typeof: r,
          type: h,
          key: $,
          ref: ne,
          props: Oe,
          _owner: $e
        };
        return Fe._store = {}, Object.defineProperty(Fe._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Fe, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: we
        }), Object.defineProperty(Fe, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ze
        }), Object.freeze && (Object.freeze(Fe.props), Object.freeze(Fe)), Fe;
      };
      function G(h, $, ne, we, ze) {
        {
          var $e, Oe = {}, Fe = null, In = null;
          ne !== void 0 && (Fe = "" + ne), le($) && (Fe = "" + $.key), W($) && (In = $.ref, de($, ze));
          for ($e in $)
            On.call($, $e) && !A.hasOwnProperty($e) && (Oe[$e] = $[$e]);
          if (h && h.defaultProps) {
            var on = h.defaultProps;
            for ($e in on)
              Oe[$e] === void 0 && (Oe[$e] = on[$e]);
          }
          if (Fe || In) {
            var un = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
            Fe && Ee(Oe, un), In && w(Oe, un);
          }
          return b(h, Fe, In, ze, we, Dn.current, Oe);
        }
      }
      var K = m.ReactCurrentOwner, re = m.ReactDebugCurrentFrame;
      function ee(h) {
        if (h) {
          var $ = h._owner, ne = Pe(h.type, h._source, $ ? $.type : null);
          re.setExtraStackFrame(ne);
        } else
          re.setExtraStackFrame(null);
      }
      var ve;
      ve = !1;
      function De(h) {
        return typeof h == "object" && h !== null && h.$$typeof === r;
      }
      function He() {
        {
          if (K.current) {
            var h = T(K.current.type);
            if (h)
              return `

Check the render method of \`` + h + "`.";
          }
          return "";
        }
      }
      function fe(h) {
        {
          if (h !== void 0) {
            var $ = h.fileName.replace(/^.*[\\\/]/, ""), ne = h.lineNumber;
            return `

Check your code at ` + $ + ":" + ne + ".";
          }
          return "";
        }
      }
      var kn = {};
      function Kn(h) {
        {
          var $ = He();
          if (!$) {
            var ne = typeof h == "string" ? h : h.displayName || h.name;
            ne && ($ = `

Check the top-level render call using <` + ne + ">.");
          }
          return $;
        }
      }
      function Li(h, $) {
        {
          if (!h._store || h._store.validated || h.key != null)
            return;
          h._store.validated = !0;
          var ne = Kn($);
          if (kn[ne])
            return;
          kn[ne] = !0;
          var we = "";
          h && h._owner && h._owner !== K.current && (we = " It was passed a child from " + T(h._owner.type) + "."), ee(h), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ne, we), ee(null);
        }
      }
      function Vr(h, $) {
        {
          if (typeof h != "object")
            return;
          if (Array.isArray(h))
            for (var ne = 0; ne < h.length; ne++) {
              var we = h[ne];
              De(we) && Li(we, $);
            }
          else if (De(h))
            h._store && (h._store.validated = !0);
          else if (h) {
            var ze = d(h);
            if (typeof ze == "function" && ze !== h.entries)
              for (var $e = ze.call(h), Oe; !(Oe = $e.next()).done; )
                De(Oe.value) && Li(Oe.value, $);
          }
        }
      }
      function Wn(h) {
        {
          var $ = h.type;
          if ($ == null || typeof $ == "string")
            return;
          var ne;
          if (typeof $ == "function")
            ne = $.propTypes;
          else if (typeof $ == "object" && ($.$$typeof === c || $.$$typeof === R))
            ne = $.propTypes;
          else
            return;
          if (ne) {
            var we = T($);
            Cn(ne, h.props, "prop", we, h);
          } else if ($.PropTypes !== void 0 && !ve) {
            ve = !0;
            var ze = T($);
            y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ze || "Unknown");
          }
          typeof $.getDefaultProps == "function" && !$.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function pi(h) {
        {
          for (var $ = Object.keys(h.props), ne = 0; ne < $.length; ne++) {
            var we = $[ne];
            if (we !== "children" && we !== "key") {
              ee(h), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", we), ee(null);
              break;
            }
          }
          h.ref !== null && (ee(h), y("Invalid attribute `ref` supplied to `React.Fragment`."), ee(null));
        }
      }
      function Oi(h, $, ne, we, ze, $e) {
        {
          var Oe = J(h);
          if (!Oe) {
            var Fe = "";
            (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (Fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var In = fe(ze);
            In ? Fe += In : Fe += He();
            var on;
            h === null ? on = "null" : Array.isArray(h) ? on = "array" : h !== void 0 && h.$$typeof === r ? (on = "<" + (T(h.type) || "Unknown") + " />", Fe = " Did you accidentally export a JSX literal instead of a component?") : on = typeof h, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", on, Fe);
          }
          var un = G(h, $, ne, ze, $e);
          if (un == null)
            return un;
          if (Oe) {
            var ki = $.children;
            if (ki !== void 0)
              if (we)
                if (Array.isArray(ki)) {
                  for (var Lt = 0; Lt < ki.length; Lt++)
                    Vr(ki[Lt], h);
                  Object.freeze && Object.freeze(ki);
                } else
                  y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Vr(ki, h);
          }
          return h === e.Fragment ? pi(un) : Wn(un), un;
        }
      }
      function sn(h, $, ne) {
        return Oi(h, $, ne, !0);
      }
      function Ke(h, $, ne) {
        return Oi(h, $, ne, !1);
      }
      var ti = Ke, is = sn;
      e.jsx = ti, e.jsxs = is;
    }();
  }(sc)), sc;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = ep() : e.exports = np();
})(Vu);
const U = Vu.exports.jsx, ye = Vu.exports.jsxs, Sr = Vu.exports.Fragment, ip = ({
  children: e,
  className: n,
  ...i
}) => /* @__PURE__ */ U(VD, {
  content: e,
  appendTo: () => document.body,
  children: /* @__PURE__ */ U("span", {
    className: nr("isr-line-clamp", n),
    ...i,
    children: e
  })
});
const rs = (e) => {
  const {
    icon: n,
    children: i,
    selected: r,
    className: t,
    ...a
  } = e;
  return /* @__PURE__ */ ye("div", {
    ...a,
    className: nr("isr-banner-tile-item", {
      "isr-banner-tile-item-selected": r,
      "isr-banner-tile-item-on-click": !!a.onClick
    }, t),
    children: [n && /* @__PURE__ */ U("div", {
      className: "isr-banner-tile-icon",
      children: n
    }), /* @__PURE__ */ U("span", {
      className: "isr-banner-tile-body",
      children: i[0]
    }), /* @__PURE__ */ U("span", {
      className: "isr-banner-tile-footer",
      children: i[1]
    })]
  });
}, rp = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...e },
  X.createElement("path", { d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zM6.65 12L3 8.59l1.4-1.3 2.36 2.2L11.59 5 13 6.29z" })
), tp = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...e },
  X.createElement("path", { d: "M9 12H7v-2h2v2zm0-3H7V4h2v5zm2.314-9H4.686L0 4.686v6.628L4.686 16h6.628L16 11.314V4.686L11.314 0z" })
), op = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...e },
  X.createElement("path", { d: "M15.868 13.267l-6.77-11.62a1.15 1.15 0 00-1.1-.67 1.17 1.17 0 00-1.1.69l-6.77 11.59a1.2 1.2 0 001.1 1.72h13.45a1.19 1.19 0 001.19-1.71zm-6.87-.29h-2v-2h2zm0-3h-2v-5h2z" })
), ap = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...e },
  X.createElement("path", { d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zm1.2 3.2a.923.923 0 01.997.843l.003.057a1.31 1.31 0 01-1.3 1.2.945.945 0 01-1-1 1.228 1.228 0 011.3-1.1zm-2 9.6c-.5 0-.9-.3-.5-1.7l.6-2.4c.1-.4.1-.5 0-.5-.2-.1-.9.2-1.3.5l-.2-.5a6.497 6.497 0 013.3-1.6c.5 0 .6.6.3 1.6l-.7 2.6c-.1.5-.1.6.1.6a2.003 2.003 0 001.1-.6l.3.4a5.769 5.769 0 01-3 1.6z" })
);
const sp = {
  success: rp,
  error: tp,
  warning: op,
  informational: ap
}, gt = ({
  status: e,
  className: n,
  ...i
}) => {
  const r = sp[e];
  return /* @__PURE__ */ U(r, {
    className: nr("isr-status-icon", `isr-status-icon-${e}`, n),
    ...i
  });
};
const up = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...e },
  X.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#00aeff" }),
  X.createElement("path", { d: "M10.602 12.548l1.367-.122L7.435 5H6.082l-.513 8 1.54-.138.042-1.587 2.646-.114zm-3.416-2.467L7.271 6.9l1.807 3.115z", fill: "#fff" }),
  X.createElement("path", { d: "M14 3h-3V0z", fill: "#0079b2" })
), cp = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...e },
  X.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#a6afb7" }),
  X.createElement("path", { d: "M11 0l3 3h-3z", fill: "#747a80" })
), lp = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...e },
  X.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#a6afb7" }),
  X.createElement("path", { d: "M7.5 5a.5.5 0 11-.5.5.5.5 0 01.5-.5zM10 5V3H8V0H7v3H5v2H2v1h3v2h2v8h1V8h2V6h4V5zm-.75 2.25h-3.5v-3.5h3.5z", fill: "#fff" }),
  X.createElement("path", { d: "M11 0l3 3h-3z", fill: "#747a80" })
), Xf = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...e },
  X.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#548ec7" }),
  X.createElement("path", { d: "M10.747 12.35a6.255 6.255 0 01-1.35-3.402C7.856 11.32 6.7 11.526 6.025 10.392L5.253 14H4l2.024-8.866 1.06-.206c.097 0-.867 3.917.29 4.33S10.071 4 10.071 4l1.253.206c-.867 2.371-.964 4.742.675 6.907z", fill: "#fff" }),
  X.createElement("path", { d: "M11 0l3 3h-3z", fill: "#3d648a" })
), vp = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...e },
  X.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#005a92" }),
  X.createElement("path", { d: "M7.6 9.4l2.72 3.12 1.68-.08-3.2-3.68c1.297-.344.96-2.16.96-2.16a3.062 3.062 0 00-2.8-2.56L4 4.12 6.48 13l1.6-.16-1.04-3.68a.744.744 0 01.56.24zm-.96-1.52L6 5.56a3.183 3.183 0 01.88-.08 1.424 1.424 0 011.44 1.28.765.765 0 01-.64 1.04z", fill: "#fff", fillRule: "evenodd" }),
  X.createElement("path", { d: "M11 0l3 3h-3z", fill: "#003f66" })
), fp = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...e },
  X.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#e72b2d" }),
  X.createElement("path", { d: "M9.292 4L4 4.692l.725 4.553 1.114 3.434 5.581-1.588.58-4.956zM5.95 10.448l-.297-.88 1.555-.336.442.804zM7.565 8.48l-.464-.771-1.71.35-.29-.824 3.136-.547 1.147 1.397zm1.852-1.89L8.205 5.354l-3.394.477-.257-.737L9.14 4.5l.778.613 1.456 1.13z", fill: "#fff" }),
  X.createElement("path", { d: "M11 0l3 3h-3z", fill: "#a11e1f" })
), gp = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", ...e },
  X.createElement("path", { d: "M11 3V0H2v16h12V3z", fill: "#39b468" }),
  X.createElement("path", { d: "M11.694 5h-2.14L8.025 7.2 6.497 5h-2.14l2.547 3.8L4 13h4.178v-1.45H7.21l.815-1.15L9.81 13H12L9.096 8.8z", fill: "#fff" }),
  X.createElement("path", { d: "M11 0l3 3h-3z", fill: "#287e49" })
), Rp = (e) => /* @__PURE__ */ X.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ X.createElement("path", { fill: "#9f116e", d: "m6.5 6.4l-.3-.2c-.6-.5-1.6-.5-2.2 0l-3.2 3.2c-.6.6-.6 1.6 0 2.2l3.9 3.9c.6.6 1.5.6 2.1 0l1.3-1.3.1-.1-1.3-1.3-1.1 1.1-3.4-3.4m4.4-1.1l3 3 .2-.2c.6-.6.6-1.5 0-2.1-.6-.7-1.3-1.3-2-2" }), /* @__PURE__ */ X.createElement("path", { fill: "#18879c", d: "m14.3 7.9l-1.3 1.3.1.1.9.9c.1.1.1.1 0 .2l-3.2 3.2c-.1.1-.1.1-.2 0l-3.7-3.8c-.1 0-.2-.2-.3-.2-.1 0-.2.1-.2.2-.6.6-.6 1.5 0 2.1l3.2 3.2c.6.6 1.6.6 2.1 0l3.9-3.9.1-.1c.5-.6.4-1.5-.1-2.1l-1.3-1.1m-4.7 1.3l3-3-.3-.3c-.6-.5-1.4-.5-2 .1l-1.9 1.8-.1.1 1.3 1.3" }), /* @__PURE__ */ X.createElement("path", { fill: "#d41726", d: "m10.5 1.9l3.4 3.4-4.1 4.1.2.2c.6.6 1.6.6 2.2 0l3.2-3.2c.6-.6.6-1.6 0-2.2l-3.8-3.8c-.6-.6-1.5-.6-2.1 0-.5.4-1 .8-1.4 1.3l1.3 1.3m-1.3 4.7l1.3-1.3-3-3-.2.2c-.6.6-.7 1.6-.1 2.2 0 0 0 0 .1.1l1.9 1.8" }), /* @__PURE__ */ X.createElement("path", { fill: "#0b4386", d: "m9.6 6.3l.3-.4c.5-.6.5-1.5-.1-2.1l-3.2-3.2c-.6-.6-1.5-.6-2.1 0-1.4 1.3-2.7 2.6-4 3.9-.6.6-.6 1.5 0 2.1.5.4 1 .9 1.4 1.3l1.3-1.3-1.1-1.1.1-.1 3.2-3.2c.1-.1.1-.1.2 0l3.9 3.9c0 .1.1.1.1.2m-6 3.3l.3.3c.4.4.9.5 1.4.4.3-.1.6-.2.8-.5l1.8-1.8-1.3-1.4-3 3" })), ue = "https://bentleysystems.service-now.com/community?id=kb_article_view&sysparm_article=", xR = {
  C3d_0022: `${ue}KB0098355#C3d_0022`,
  Civil_0004: `${ue}KB0098314#Civil_0004`,
  Civil_0010: `${ue}KB0098314#Civil_0010`,
  Civil_0002: `${ue}KB0098355#Civil_0002`,
  Civil_0003: `${ue}KB0098314#Civil_0003`,
  Dgn_0000: `${ue}KB0098314#Dgn_0000`,
  Dgn_0203: `${ue}KB0098322#Dgn_0203`,
  Dgn_0204: `${ue}KB0098322#Dgn_0204`,
  Dgn_0066: `${ue}KB0098331#Dgn_0066`,
  Dgn_0199: `${ue}KB0098331#dgn_0199`,
  Dgn_0205: `${ue}KB0098322#OutlierElements`,
  Dgn_0214: `${ue}KB0098314#Dgn_0214`,
  Dgn_0215: `${ue}KB0098322#Dgn_0215`,
  Dgn_0060: `${ue}KB0098355#Dgn_0060`,
  Dgn_0188: `${ue}KB0098314#Dgn_0188`,
  Dgn_0200: `${ue}KB0098322#Dgn_0200`,
  DgnV8_0005: `${ue}KB0098329#DgnV8_0005`,
  DgnV8_0044: `${ue}KB0098329#DgnV8_0044`,
  DgnV8_0126: `${ue}KB0098314#DgnV8_0126`,
  DgnV8_0132: `${ue}KB0098314#Dgn_0214`,
  DgnV8_0191: `${ue}KB0098322#DgnV8_0191`,
  DgnV8_0164: `${ue}KB0098327#DgnV8_0164`,
  DgnV8_0142: `${ue}KB0098331#Dgn_0066`,
  DgnV8_0141: `${ue}KB0098331#Dgn_0066`,
  DgnV8_0133: `${ue}KB0098314#DgnV8_0133`,
  DgnV8_0068: `${ue}KB0098314#DgnV8_0068`,
  DgnV8_0046: `${ue}KB0098314#DgnV8_0046`,
  DgnV8_0057: `${ue}KB0098329#DgnV8_0057`,
  DgnV8_0000: `${ue}KB0098322#DgnV8_0000`,
  DgnV8_0030: `${ue}KB0098325#DgnV8_0030`,
  DgnV8_0158: `${ue}KB0098327#DgnV8_0158`,
  DgnV8_01344: `${ue}KB0098320#DgnV8_01344`,
  Dwg_0203: `${ue}KB0098356#Dwg_0203`,
  Dwg_0103: `${ue}KB0098314#Dwg_0103`,
  Dwg_0199: `${ue}KB0098320#Dwg_0199`,
  Dwg_0163: `${ue}KB0098356#Dwg_0163`,
  Dwg_0162: `${ue}KB0098356#Dwg_0162`,
  Dwg_0089: `${ue}KB0098329#Dwg_0089`,
  EC_0001: `${ue}KB0098327#EC_0001`,
  ifc_0020: `${ue}KB0098331#ifc_0020`,
  Ifc_0021: `${ue}KB0098331#ifc_0020`,
  Ifc_0048: `${ue}KB0098331#Ifc_0048`,
  Ifc_0027: `${ue}KB0098314#Ifc_0027`,
  Ifc_0010: `${ue}KB0098322#Ifc_0010`,
  Ifc_0034: `${ue}KB0098314#Ifc_0034`,
  Ifc_0042: `${ue}KB0098331#Ifc_0042`,
  Ifc_0038: `${ue}KB0098314#Ifc_0038`,
  Nwd_0010: `${ue}KB0098325#Nwd_0010`,
  NWD_0012: `${ue}KB0098314#NWD_0012`,
  Revit_0002: `${ue}KB0098314#Revit0002`,
  Revit_0025: `${ue}KB0098314#Revit0025`,
  Revit_0021: `${ue}KB0098322#Revit_0021`,
  Revit_0031: `${ue}KB0098325#Revit_0031`,
  Revit_0014: `${ue}KB0098320#Revit_0014`,
  Revit_0016: `${ue}KB0098322#Revit_0016`,
  Revit_0030: `${ue}KB0098327#Revit_0030`,
  Revit_0023: `${ue}KB0098322#Revit_0023`,
  SPPID_0001: `${ue}KB0098320#SPPID_0001`,
  SPPID_0002: `${ue}KB0098320#SPPID_0002`,
  SPx_0002: `${ue}KB0098322#SPx_0002`,
  SPPID_0015: `${ue}KB0098350#SPPID_0015`
};
function qv(e) {
  return e ? xR[e] !== void 0 : !1;
}
function BR(e) {
  return xR[e];
}
const Ho = {
  Files: "files",
  Categories: "categories",
  Problems: "problems",
  IssueId: "issueId"
}, Yi = {
  problems: "problems",
  files: "fileId",
  categories: "category",
  issueId: "issueid"
}, dp = {
  Fatal: "Fatal Error",
  Error: "Error",
  Critical: "Critical Warning",
  Warning: "Warning",
  Info: "Info",
  fileName: "File name",
  level: "Severity",
  category: "Category",
  type: "Type",
  message: "Message",
  mainFile: "master",
  issueId: "ID",
  details: "Details"
}, Cp = {
  Error: "Errors",
  Warning: "Warnings",
  Info: "Info",
  All: "Issues"
}, Dp = {
  dgn: /* @__PURE__ */ U(Xf, {}),
  dgnlib: /* @__PURE__ */ U(Xf, {}),
  rvt: /* @__PURE__ */ U(vp, {}),
  skp: /* @__PURE__ */ U(fp, {}),
  xls: /* @__PURE__ */ U(gp, {}),
  dwg: /* @__PURE__ */ U(lp, {}),
  dxf: /* @__PURE__ */ U(up, {}),
  ifc: /* @__PURE__ */ U(Rp, {})
}, pp = ({
  fileRecords: e,
  displayStrings: n,
  fileTypeIcons: i,
  sourceFilesInfo: r,
  className: t,
  onIssueArticleOpened: a,
  ...o
}) => {
  const s = X.useContext(Gr), u = s == null ? void 0 : s.workflowMapping, c = X.useMemo(() => ({
    ...Dp,
    ...i
  }), [i]), l = X.useCallback((d) => {
    var y, Y;
    const m = r || (s == null ? void 0 : s.reportData.sourceFilesInfo);
    return (m == null ? void 0 : m.fileId) === d ? m == null ? void 0 : m.fileName : (Y = (y = m == null ? void 0 : m.Files) == null ? void 0 : y.find((k) => k.fileId === d)) == null ? void 0 : Y.fileName;
  }, [r, s == null ? void 0 : s.reportData.sourceFilesInfo]), g = X.useMemo(() => {
    const d = r || (s == null ? void 0 : s.reportData.sourceFilesInfo);
    return [{
      ...d,
      mainFile: !0
    }, ...d && d.Files ? d.Files.filter((m) => m.state !== "Hidden") : []];
  }, [r, s == null ? void 0 : s.reportData.sourceFilesInfo]), R = X.useMemo(() => g.reduce((d, m) => ({
    ...d,
    [m.fileId]: m
  }), {}), [g]), v = X.useCallback((d) => {
    const m = s == null ? void 0 : s.currentTable, y = m ? Yi[m] : void 0, Y = y === "fileId";
    if (!y || (s == null ? void 0 : s.currentTable) === Ho.Problems)
      return d;
    const k = {};
    d.forEach((te) => {
      const I = te[y];
      I ? (Object.hasOwn(k, I) || (k[I] = []), k[I].push(te)) : (Object.hasOwn(k, "Others") || (k.Others = []), k.Others.push(te));
    });
    const J = [];
    for (const te of Object.keys(k)) {
      let I = {
        [y]: `${te} (${k[te].length})`,
        subRows: k[te]
      };
      Y && (I = {
        ...I,
        ...R[te]
      }), J.push(I);
    }
    if (Y) {
      const te = J.map((I) => I.fileName);
      g.forEach((I) => {
        I.fileName && !te.includes(I.fileName) && J.push(I);
      });
    }
    return J;
  }, [s == null ? void 0 : s.currentTable, g, R]), f = X.useMemo(() => {
    const d = g.filter((m) => !!m.fileId).map(({
      fileId: m
    }) => {
      const y = e == null ? void 0 : e.filter(({
        file: Y
      }) => (Y == null ? void 0 : Y.identifier) === m).flatMap(({
        auditrecords: Y
      }) => Y != null ? Y : []).some(({
        auditinfo: Y
      }) => {
        var k;
        return ["Critical", "Fatal", "Warning", "Error"].includes((k = Y == null ? void 0 : Y.level) != null ? k : "");
      });
      return [m, y];
    });
    return Object.fromEntries(d);
  }, [g, e]), p = X.useMemo(() => {
    const m = (e || (s == null ? void 0 : s.reportData.filerecords) || []).flatMap(({
      file: y,
      auditrecords: Y
    }) => (Y != null ? Y : []).flatMap(({
      auditinfo: k
    }) => {
      const J = y == null ? void 0 : y.identifier, te = J ? R[J] : {}, I = {
        fileId: J,
        ...te,
        ...k
      };
      return u && (k == null ? void 0 : k.category) && k.type && Object.hasOwn(u, k.category) && Object.hasOwn(u[k.category], k.type) ? u[k.category][k.type].some((T) => s.focusedWorkflows.includes(T)) ? I : [] : s != null && s.focusedWorkflows.includes("Unorganized") ? I : [];
    })).filter((y) => {
      const Y = y.level;
      let k = "Info";
      return Y === "Error" || Y === "Fatal" ? k = "Error" : (Y === "Warning" || Y === "Critical") && (k = "Warning"), (s == null ? void 0 : s.focusedIssue) === k || (s == null ? void 0 : s.focusedIssue) === "All";
    });
    return v(m);
  }, [e, s == null ? void 0 : s.reportData.filerecords, s == null ? void 0 : s.focusedWorkflows, s == null ? void 0 : s.focusedIssue, R, v, u]), D = X.useMemo(() => ({
    ...dp,
    ...n
  }), [n]), C = X.useCallback((d, m) => {
    const y = ["Fatal", "Error", "Critical", "Warning", "Info"], Y = y.indexOf(d.original.level || ""), k = y.indexOf(m.original.level || "");
    return Y > k ? 1 : -1;
  }, []), _ = X.useMemo(() => [{
    id: "issueid",
    accessor: "issueid",
    Header: D.issueId,
    Filter: Hr.TextFilter(),
    minWidth: 50,
    maxWidth: 170,
    Cell: (d) => /* @__PURE__ */ U("div", {
      children: d.value
    })
  }, {
    id: "category",
    accessor: "category",
    Header: D.category,
    Filter: Hr.TextFilter(),
    minWidth: 75,
    maxWidth: 250,
    Cell: (d) => /* @__PURE__ */ U("div", {
      children: d.row.subRows.length === 0 && (s == null ? void 0 : s.currentTable) && Yi[s == null ? void 0 : s.currentTable] === Yi.categories ? "" : d.value
    })
  }, {
    id: "type",
    accessor: "type",
    Header: D.type,
    Filter: Hr.TextFilter(),
    minWidth: 50,
    maxWidth: 170,
    Cell: (d) => /* @__PURE__ */ U("div", {
      children: d.value
    })
  }, {
    id: "level",
    accessor: "level",
    Header: D.level,
    Filter: Hr.TextFilter(),
    minWidth: 50,
    maxWidth: 170,
    sortType: C,
    cellRenderer: ({
      cellElementProps: d,
      cellProps: m
    }) => {
      const y = m.row.original.level;
      return /* @__PURE__ */ U(HD, {
        cellElementProps: d,
        cellProps: m,
        startIcon: y === "Error" || y === "Fatal" || y === "Critical" ? /* @__PURE__ */ U(gt, {
          status: "error"
        }) : y === "Warning" ? /* @__PURE__ */ U(gt, {
          status: "warning"
        }) : y ? /* @__PURE__ */ U(gt, {
          status: "informational"
        }) : void 0,
        children: y
      });
    }
  }, {
    id: "fileName",
    accessor: ({
      fileName: d,
      fileId: m
    }) => d != null ? d : l(m),
    Header: D.fileName,
    Filter: Hr.TextFilter(),
    minWidth: 150,
    Cell: (d) => {
      var y;
      const m = (y = d.value) == null ? void 0 : y.substring(d.value.lastIndexOf(".") + 1);
      return d.row.depth != 0 && (s == null ? void 0 : s.currentTable) && Yi[s == null ? void 0 : s.currentTable] === Yi.files ? /* @__PURE__ */ U("div", {}) : /* @__PURE__ */ ye(Sr, {
        children: [/* @__PURE__ */ U("div", {
          className: "isr-table-cell-start-icon",
          children: m && m in c ? c[m] : d.row.subRows ? void 0 : /* @__PURE__ */ U(cp, {})
        }), /* @__PURE__ */ ye("div", {
          className: "isr-file-name",
          children: [d.value, (s == null ? void 0 : s.currentTable) === Ho.Files && d.row.original.mainFile && /* @__PURE__ */ U(zD, {
            backgroundColor: "primary",
            children: D.mainFile
          })]
        })]
      });
    }
  }, {
    id: "message",
    accessor: "message",
    Header: D.message,
    Filter: Hr.TextFilter(),
    minWidth: 200,
    cellClassName: "isr-problems-message",
    Cell: ({
      value: d
    }) => /* @__PURE__ */ U(ip, {
      children: d
    })
  }, {
    id: "details",
    Header: D.details,
    Filter: Hr.TextFilter(),
    minWidth: 50,
    maxWidth: 170,
    Cell: (d) => {
      const [m] = d.row.original.issueid ? d.row.original.issueid.split(" ", 2) : [void 0];
      return /* @__PURE__ */ U("div", {
        children: d.row.subRows.length === 0 && (s == null ? void 0 : s.currentTable) && Yi[s == null ? void 0 : s.currentTable] === Yi.issueId || !m || !qv(m) ? /* @__PURE__ */ U(Sr, {}) : /* @__PURE__ */ U(Ml, {
          href: BR(m),
          target: "_blank",
          onClick: () => {
            var y;
            return (y = s == null ? void 0 : s.onIssueArticleOpened) == null ? void 0 : y.call(s, m);
          },
          children: "Learn More..."
        })
      });
    }
  }], [s, D, c, l, C]), E = X.useCallback((d) => {
    const m = s == null ? void 0 : s.currentTable;
    let y = m ? Yi[m] : void 0;
    if (!y || m === Ho.Problems)
      return d;
    y === Yi.files && (y = "fileName");
    const Y = d.findIndex((J) => J.id === y), k = d.splice(Y, 1);
    return d.unshift(k[0]), d;
  }, [s == null ? void 0 : s.currentTable]), N = X.useCallback(({
    id: d,
    original: {
      level: m,
      fileExists: y,
      bimFileExists: Y
    }
  }) => {
    if ((s == null ? void 0 : s.currentTable) === Ho.Problems) {
      const k = d === (s == null ? void 0 : s.activeRow);
      let J;
      switch (m) {
        case "Critical":
        case "Error":
        case "Fatal":
          J = "negative";
          break;
        case "Warning":
          J = "warning";
          break;
      }
      return {
        status: J,
        className: `isr-table-row table-row__${k ? "active" : "inactive"}`
      };
    } else if ((s == null ? void 0 : s.currentTable) === Ho.Files)
      return !y && !Y ? {
        status: "negative"
      } : {};
    return {
      status: void 0
    };
  }, [s == null ? void 0 : s.activeRow, s == null ? void 0 : s.currentTable]), O = X.useCallback(
    (d, m) => {
      var y;
      m.subRows.length ? m.toggleRowExpanded() : (s == null || s.setCurrentAuditInfo({
        ...m.original,
        fileName: (y = m.original.fileName) != null ? y : l(m.original.fileId)
      }), s == null || s.setActiveRow(m.id));
    },
    [s, l, f]
  );
  return /* @__PURE__ */ U(Sr, {
    children: /* @__PURE__ */ U($D, {
      onRowClick: O,
      selectRowOnClick: !0,
      className: nr("isr-problems-table", t),
      columns: E(_),
      data: p,
      emptyTableContent: `No ${s ? Cp[s == null ? void 0 : s.focusedIssue] : "Data"}`,
      emptyFilteredTableContent: "No results found. Clear or try another filter.",
      isSortable: !0,
      initialState: {
        sortBy: [{
          id: "level"
        }]
      },
      rowProps: N,
      ...o
    })
  });
}, qf = {
  synchronizationReport: "Synchronization Report",
  unknown: "unknown"
}, hp = ({
  fileName: e,
  displayStrings: n,
  ...i
}) => {
  var a;
  const r = X.useContext(Gr);
  if (!e) {
    if (!r)
      throw new Error("fileName must be specified or ReportTitle must be used inside Report");
    e = (a = r.reportData.sourceFilesInfo) == null ? void 0 : a.fileName;
  }
  const t = X.useMemo(() => ({
    ...qf,
    ...n
  }), [n]);
  return /* @__PURE__ */ U(rn, {
    variant: "title",
    ...i,
    children: `${e != null ? e : qf.unknown} - ${t.synchronizationReport}`
  });
};
var GR = {};
(function(e) {
  var n = Qn && Qn.__createBinding || (Object.create ? function(o, s, u, c) {
    c === void 0 && (c = u);
    var l = Object.getOwnPropertyDescriptor(s, u);
    (!l || ("get" in l ? !s.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
      return s[u];
    } }), Object.defineProperty(o, c, l);
  } : function(o, s, u, c) {
    c === void 0 && (c = u), o[c] = s[u];
  }), i = Qn && Qn.__setModuleDefault || (Object.create ? function(o, s) {
    Object.defineProperty(o, "default", { enumerable: !0, value: s });
  } : function(o, s) {
    o.default = s;
  }), r = Qn && Qn.__importStar || function(o) {
    if (o && o.__esModule)
      return o;
    var s = {};
    if (o != null)
      for (var u in o)
        u !== "default" && Object.prototype.hasOwnProperty.call(o, u) && n(s, o, u);
    return i(s, o), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SvgClock = void 0;
  const t = r(Wa), a = (o) => t.createElement(
    "svg",
    { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...o },
    t.createElement("path", { d: "M8.6 9h-.2l-5-1.5a.486.486 0 01-.3-.6.42.42 0 01.6-.3L8 7.9V5.5a.5.5 0 011 0v3a.758.758 0 01-.2.4.35.35 0 01-.2.1M8 1.5A6.5 6.5 0 111.5 8 6.487 6.487 0 018 1.5M8 0a8 8 0 108 8 8.024 8.024 0 00-8-8z" })
  );
  e.SvgClock = a, e.default = e.SvgClock;
})(GR);
const wp = /* @__PURE__ */ UR(GR);
var VR = {};
(function(e) {
  var n = Qn && Qn.__createBinding || (Object.create ? function(o, s, u, c) {
    c === void 0 && (c = u);
    var l = Object.getOwnPropertyDescriptor(s, u);
    (!l || ("get" in l ? !s.__esModule : l.writable || l.configurable)) && (l = { enumerable: !0, get: function() {
      return s[u];
    } }), Object.defineProperty(o, c, l);
  } : function(o, s, u, c) {
    c === void 0 && (c = u), o[c] = s[u];
  }), i = Qn && Qn.__setModuleDefault || (Object.create ? function(o, s) {
    Object.defineProperty(o, "default", { enumerable: !0, value: s });
  } : function(o, s) {
    o.default = s;
  }), r = Qn && Qn.__importStar || function(o) {
    if (o && o.__esModule)
      return o;
    var s = {};
    if (o != null)
      for (var u in o)
        u !== "default" && Object.prototype.hasOwnProperty.call(o, u) && n(s, o, u);
    return i(s, o), s;
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.SvgDocument = void 0;
  const t = r(Wa), a = (o) => t.createElement(
    "svg",
    { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...o },
    t.createElement("path", { d: "M10 0H2v16h12V4h-4zm1 0v3h3z" })
  );
  e.SvgDocument = a, e.default = e.SvgDocument;
})(VR);
const _p = /* @__PURE__ */ UR(VR);
var HR = /* @__PURE__ */ ((e) => (e.TransformationReport = "TransformationUserReport", e.SynchronizationDetailReport = "detailReport", e.SynchronizationSummaryReport = "summaryReport", e))(HR || {});
const Ep = {
  syncTime: "Sync Time",
  files: "Files Processed"
}, mp = ({
  timestamp: e,
  filesCount: n,
  filesProcessed: i,
  displayStrings: r
}) => {
  var v, f, p, D;
  const t = X.useContext(Gr), a = (v = t == null ? void 0 : t.reportData.context) == null ? void 0 : v.reportType;
  if (!e && !n) {
    if (!t)
      throw new Error("timestamp and numberOfFiles must be specified or ReportTimestamp and list of files must be used inside Report");
    e = new Date((p = (f = t.reportData.context) == null ? void 0 : f.timestamp) != null ? p : ""), n = [t.reportData.sourceFilesInfo, ...((D = t.reportData.sourceFilesInfo) == null ? void 0 : D.Files) || []].length;
  }
  const o = X.useMemo(() => ({
    ...Ep,
    ...r
  }), [r]), [s, u] = X.useState(""), [c, l] = X.useState("");
  X.useEffect(() => {
    var _, E;
    let C = {
      year: "numeric",
      month: "short",
      day: "numeric"
    };
    u((_ = e == null ? void 0 : e.toLocaleDateString(void 0, C)) != null ? _ : ""), C = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: !1
    }, l((E = e == null ? void 0 : e.toLocaleTimeString([], C)) != null ? E : "");
  }, [e]);
  const R = X.useMemo(() => {
    var C;
    return i ? [...i] : (C = t == null ? void 0 : t.reportData.sourceFilesInfo) != null && C.Files ? [t.reportData.sourceFilesInfo, ...t.reportData.sourceFilesInfo.Files] : [];
  }, [t == null ? void 0 : t.reportData.sourceFilesInfo, i]).filter((C) => C.fileExists && C.bimFileExists).length;
  return /* @__PURE__ */ U("div", {
    className: "isr-timestamp-container",
    children: /* @__PURE__ */ U("span", {
      children: /* @__PURE__ */ ye(rn, {
        children: [" ", /* @__PURE__ */ U(wp, {}), " ", s, " ", c, " ", o.syncTime, a !== HR.TransformationReport ? /* @__PURE__ */ ye(Sr, {
          children: ["| ", /* @__PURE__ */ U(_p, {}), " ", R, "/", n, " ", o.files]
        }) : null]
      })
    })
  });
};
const Sp = (e) => X.createElement(
  "svg",
  { viewBox: "0 0 16 16", width: "1rem", height: "1rem", fill: "var(--iui-color-icon-muted, currentColor)", ...e },
  X.createElement("path", { d: "M5.472 15.978a.616.616 0 01-.756-.466L1.521 2.845a.66.66 0 01.437-.803.615.615 0 01.755.465l3.194 12.667a.662.662 0 01-.435.804zm7.159-8.09a6.694 6.694 0 01-1.834.183c-.602-.009-1.197-.05-1.8-.057a6.743 6.743 0 00-1.831.184 3.595 3.595 0 00-1.871 1.156l-.592-2.345-.516-2.043c-.175-.699-.365-1.446-.59-2.344a3.6 3.6 0 011.87-1.157 6.645 6.645 0 011.834-.18c.601.006 1.196.047 1.798.053a6.608 6.608 0 001.833-.181A3.606 3.606 0 0012.803 0l.592 2.343c.175.699.34 1.347.516 2.044l.589 2.346a3.616 3.616 0 01-1.87 1.156z", fillRule: "evenodd" })
), Tp = {
  errors: "Errors",
  warnings: "Warnings",
  otherIssues: "Info",
  totalIssues: "Total Issues",
  unorganized: "Unorganized"
}, yp = (e) => {
  const n = X.useContext(Gr), i = X.useMemo(() => ({
    ...Tp,
    ...e.displayStrings
  }), [e.displayStrings]), r = X.useMemo(() => e.fileRecords || (n == null ? void 0 : n.reportData.filerecords) || [], [n == null ? void 0 : n.reportData.filerecords, e.fileRecords]), t = X.useMemo(() => {
    var f;
    return e.filesProcessed ? [...t] : (f = n == null ? void 0 : n.reportData.sourceFilesInfo) != null && f.Files ? [n.reportData.sourceFilesInfo, ...n.reportData.sourceFilesInfo.Files] : [];
  }, [n == null ? void 0 : n.reportData.sourceFilesInfo, e.filesProcessed]), [a, o] = X.useState(0), [s, u] = X.useState(0), [c, l] = X.useState(0), [g, R] = X.useState(0);
  X.useEffect(() => {
    let f = 0, p = 0, D = 0, C = [];
    n != null && n.workflowMapping && (C = Array.from(new Set(Object.values(n == null ? void 0 : n.workflowMapping).flatMap((E) => Object.values(E).flatMap((N) => N)))));
    const _ = new Map(C.map((E) => [E, 0]));
    r == null || r.forEach((E) => {
      var N;
      (N = E.auditrecords) == null || N.forEach((O) => {
        var y, Y, k;
        const d = (y = O.auditinfo) == null ? void 0 : y.level;
        let m = "Info";
        if (d === "Error" || d === "Fatal" ? m = "Error" : (d === "Warning" || d === "Critical") && (m = "Warning"), (n == null ? void 0 : n.workflowMapping) && ((Y = O.auditinfo) == null ? void 0 : Y.category) && O.auditinfo.type && Object.hasOwn(n.workflowMapping, O.auditinfo.category) && Object.hasOwn(n.workflowMapping[O.auditinfo.category], O.auditinfo.type) && (n == null ? void 0 : n.focusedIssue) === m && n.workflowMapping[O.auditinfo.category][O.auditinfo.type].forEach((te) => {
          const I = _.get(te), T = I != null ? I : 0;
          _.set(te, T + 1);
        }), (n == null ? void 0 : n.workflowMapping) && ((k = O.auditinfo) == null ? void 0 : k.category) && O.auditinfo.type && Object.hasOwn(n.workflowMapping, O.auditinfo.category) && Object.hasOwn(n.workflowMapping[O.auditinfo.category], O.auditinfo.type)) {
          if (!n.workflowMapping[O.auditinfo.category][O.auditinfo.type].some((te) => n.focusedWorkflows.includes(te)))
            return;
        } else if (!(n != null && n.focusedWorkflows.includes("Unorganized")))
          return;
        d === "Error" || d === "Fatal" ? f++ : d === "Warning" || d === "Critical" ? p++ : d === "Info" && D++;
      });
    }), o(f), u(p), l(D), R(f + p + D);
  }, [n == null ? void 0 : n.focusedIssue, n == null ? void 0 : n.focusedWorkflows, n == null ? void 0 : n.workflowMapping, r]);
  const v = X.useCallback((f) => n == null ? void 0 : n.setFocusedIssue(f), [n]);
  return /* @__PURE__ */ U(kR, {
    elevation: 1,
    className: "isr-banner-container",
    children: /* @__PURE__ */ ye(Sr, {
      children: [/* @__PURE__ */ ye(rs, {
        icon: /* @__PURE__ */ U(Sp, {}),
        onClick: () => v("All"),
        selected: (n == null ? void 0 : n.focusedIssue) === "All",
        children: [/* @__PURE__ */ U(rn, {
          variant: "title",
          style: {
            fontWeight: "bold"
          },
          children: g
        }), /* @__PURE__ */ U(rn, {
          variant: "small",
          children: i.totalIssues
        })]
      }), /* @__PURE__ */ ye(rs, {
        onClick: () => v("Error"),
        selected: (n == null ? void 0 : n.focusedIssue) === "Error",
        icon: /* @__PURE__ */ U(gt, {
          status: "error"
        }),
        children: [/* @__PURE__ */ U(rn, {
          variant: "title",
          style: {
            fontWeight: "bold"
          },
          children: a
        }), /* @__PURE__ */ U(rn, {
          variant: "small",
          children: i.errors
        })]
      }), /* @__PURE__ */ ye(rs, {
        onClick: () => v("Warning"),
        selected: (n == null ? void 0 : n.focusedIssue) === "Warning",
        icon: /* @__PURE__ */ U(gt, {
          status: "warning"
        }),
        children: [/* @__PURE__ */ U(rn, {
          variant: "title",
          style: {
            fontWeight: "bold"
          },
          children: s
        }), /* @__PURE__ */ U(rn, {
          variant: "small",
          children: i.warnings
        })]
      }), /* @__PURE__ */ ye(rs, {
        onClick: () => v("Info"),
        selected: (n == null ? void 0 : n.focusedIssue) === "Info",
        icon: /* @__PURE__ */ U(gt, {
          status: "informational"
        }),
        children: [/* @__PURE__ */ U(rn, {
          variant: "title",
          style: {
            fontWeight: "bold"
          },
          children: c
        }), /* @__PURE__ */ U(rn, {
          variant: "small",
          children: i.otherIssues
        })]
      })]
    })
  });
}, Np = {
  files: "Files",
  problems: "Issues",
  categories: "Category",
  issueId: "ID"
}, Ip = ({
  displayStrings: e,
  options: n,
  className: i,
  ...r
}) => {
  const t = X.useContext(Gr);
  if (!t)
    throw new Error("ReportTableSelect must be used inside the Report component");
  const {
    currentTable: a,
    setCurrentTable: o
  } = t, s = {
    ...Np,
    ...e
  };
  return /* @__PURE__ */ U(jD, {
    label: "Show by:",
    displayStyle: "inline",
    options: n != null ? n : [{
      value: "categories",
      label: s.categories
    }, {
      value: "files",
      label: s.files
    }, {
      value: "issueId",
      label: s.issueId
    }, {
      value: "problems",
      label: s.problems
    }],
    onChange: o,
    value: a,
    className: i,
    ...r
  });
};
const bp = ({
  children: e,
  className: n,
  ...i
}) => /* @__PURE__ */ U("div", {
  className: nr("isr-table-select-wrapper", n),
  ...i,
  children: e
});
const Mp = {
  status: "Severity",
  issueType: "Type",
  category: "Category",
  impactedWorkflows: "Impacted Workflows",
  fileName: "File Name",
  message: "Message",
  metadata: "Metadata",
  filePath: "File Path",
  fileId: "File ID",
  dataSource: "Data Source",
  failed: "Failed",
  processedWithIssues: "Processed with issues",
  processed: "Processed",
  learnMore: "Learn more about this issue"
}, Pp = ({
  displayStrings: e,
  onIssueArticleOpened: n,
  className: i,
  ...r
}) => {
  var l, g;
  const t = Wa.useContext(Gr);
  if (!t)
    throw new Error("ReportInfoPanel must be used inside the Report component");
  const a = {
    ...Mp,
    ...e
  }, {
    currentAuditInfo: o,
    setCurrentAuditInfo: s,
    setActiveRow: u
  } = t;
  return /* @__PURE__ */ ye(KD, {
    className: i,
    isOpen: !!o,
    ...r,
    children: [/* @__PURE__ */ U(WD, {
      onClose: () => {
        s(void 0), u("");
      },
      children: /* @__PURE__ */ U(rn, {
        variant: "subheading",
        children: (l = o == null ? void 0 : o.issueid) != null ? l : a.metadata
      })
    }), /* @__PURE__ */ ye(XD, {
      className: "isr-info-panel-body",
      children: [(o == null ? void 0 : o.category) && /* @__PURE__ */ ye("span", {
        children: [/* @__PURE__ */ U(ln, {
          as: "span",
          children: a.category
        }), o.category]
      }), (o == null ? void 0 : o.type) && /* @__PURE__ */ ye("span", {
        children: [/* @__PURE__ */ U(ln, {
          as: "span",
          children: a.issueType
        }), (g = o == null ? void 0 : o.type) != null ? g : ""]
      }), /* @__PURE__ */ U("span", {
        children: (o == null ? void 0 : o.level) && /* @__PURE__ */ ye(Sr, {
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: a.status
          }), /* @__PURE__ */ ye("span", {
            className: "isr-icon-inline",
            children: [/* @__PURE__ */ U(gt, {
              status: ["Error", "Fatal", "Critical"].some((R) => R === o.level) ? "error" : o.level === "Warning" ? "warning" : "informational"
            }), o.level]
          })]
        })
      }), (o == null ? void 0 : o.message) && /* @__PURE__ */ ye("span", {
        children: [/* @__PURE__ */ U(ln, {
          as: "span",
          children: a.message
        }), o == null ? void 0 : o.message, qv(o == null ? void 0 : o.issueid) && /* @__PURE__ */ ye(Sr, {
          children: [/* @__PURE__ */ U("br", {}), " ", /* @__PURE__ */ U(Ml, {
            href: BR((o == null ? void 0 : o.issueid) || ""),
            onClick: () => {
              var R;
              return (o == null ? void 0 : o.issueid) && ((R = t == null ? void 0 : t.onIssueArticleOpened) == null ? void 0 : R.call(t, o.issueid));
            },
            target: "_blank",
            children: a.learnMore
          })]
        })]
      }), (o == null ? void 0 : o.fileName) && /* @__PURE__ */ ye("span", {
        children: [/* @__PURE__ */ U(ln, {
          as: "span",
          children: a.fileName
        }), o.fileName]
      }), (o == null ? void 0 : o.path) && /* @__PURE__ */ ye("span", {
        children: [/* @__PURE__ */ U(ln, {
          as: "span",
          children: a.filePath
        }), /* @__PURE__ */ U(Ml, {
          href: o == null ? void 0 : o.path,
          target: "_blank",
          children: o == null ? void 0 : o.path
        })]
      }), (o == null ? void 0 : o.fileId) && /* @__PURE__ */ ye("span", {
        children: [/* @__PURE__ */ U(ln, {
          as: "span",
          children: a.fileId
        }), o == null ? void 0 : o.fileId]
      }), (o == null ? void 0 : o.dataSource) && /* @__PURE__ */ ye("span", {
        children: [/* @__PURE__ */ U(ln, {
          as: "span",
          children: a.dataSource
        }), o == null ? void 0 : o.dataSource]
      })]
    })]
  });
};
const Ap = ({
  className: e,
  children: n,
  ...i
}) => /* @__PURE__ */ U(qD, {
  className: nr("isr-info-panel-wrapper", e),
  ...i,
  children: n
});
const Fp = ({
  children: e,
  className: n,
  ...i
}) => /* @__PURE__ */ U("div", {
  className: nr("isr-report-header-banner", n),
  ...i,
  children: e
});
const Lp = {
  activityid: "Activity Id",
  briefcaseid: "Briefcase Id",
  contextid: "Context Id",
  contextName: "Ctx. Name",
  jobDefID: "Job Def. Id",
  jobid: "Job Id",
  jobRunID: "Job Run Id",
  modelid: "Model Id",
  modelName: "Model Name",
  organizationName: "Org. Name",
  userEmail: "User Email",
  idsForTechSupport: "IDs for Tech Support"
}, Op = (e) => {
  var o;
  const {
    data: n
  } = e, i = X.useContext(Gr), r = ((o = e.data) == null ? void 0 : o.reportData) || (i == null ? void 0 : i.reportData.context), t = X.useMemo(() => ({
    ...Lp,
    ...e.displayStrings
  }), [e.displayStrings]), a = {
    "Activity Id": (r == null ? void 0 : r.activityid) === "" ? "No Activity Id" : r == null ? void 0 : r.activityid,
    "Briefcase Id": (r == null ? void 0 : r.briefcaseid) === "" ? "No Briefcase Id" : r == null ? void 0 : r.briefcaseid,
    "Context Id": (r == null ? void 0 : r.contextid) === "" ? "No Context Id" : r == null ? void 0 : r.contextid,
    "Ctx. Name": (n == null ? void 0 : n.contextName) === "" ? "No Context Name" : n == null ? void 0 : n.contextName,
    "Job Def. Id": (n == null ? void 0 : n.jobDefID) === "" ? "No Job Definition Id" : n == null ? void 0 : n.jobDefID,
    "Job Id": (r == null ? void 0 : r.jobid) === "" ? "No Job Id" : r == null ? void 0 : r.jobid,
    "Job Run Id": (n == null ? void 0 : n.jobRunID) === "" ? "No Job Run Id" : n == null ? void 0 : n.jobRunID,
    "iModel Id": (r == null ? void 0 : r.imodelid) === "" ? "No iModel Id" : r == null ? void 0 : r.imodelid,
    "iModel Name": (n == null ? void 0 : n.modelName) === "" ? "No Model Name" : n == null ? void 0 : n.modelName,
    "Org. Name": (n == null ? void 0 : n.organizationName) === "" ? "No Organization Name" : n == null ? void 0 : n.organizationName,
    "User Email": (n == null ? void 0 : n.userEmail) === "" ? "No User Email" : n == null ? void 0 : n.userEmail
  };
  return /* @__PURE__ */ U("div", {
    className: e.className,
    children: /* @__PURE__ */ U(ZD, {
      content: /* @__PURE__ */ ye(kR, {
        elevation: 1,
        className: "isr-support-debugIDWrapper",
        children: [a["Activity Id"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.activityid}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["Activity Id"]
          })]
        }), a["Briefcase Id"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.briefcaseid}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["Briefcase Id"]
          })]
        }), a["Context Id"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.contextid}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["Context Id"]
          })]
        }), a["Ctx. Name"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.contextName}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["Ctx. Name"]
          })]
        }), a["Job Def. Id"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.jobDefID}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["Job Def. Id"]
          })]
        }), a["Job Id"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.jobid}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["Job Id"]
          })]
        }), a["Job Run Id"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ ye(ln, {
            as: "span",
            children: ["`$", t.jobRunID, ":`"]
          }), /* @__PURE__ */ U(rn, {
            children: a["Job Run Id"]
          })]
        }), a["iModel Id"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.modelid}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["iModel Id"]
          })]
        }), a["iModel Name"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.modelName}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["iModel Name"]
          })]
        }), a["Org. Name"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.organizationName}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["Org. Name"]
          })]
        }), a["User Email"] && /* @__PURE__ */ ye("div", {
          className: "isr-support-debugID",
          children: [/* @__PURE__ */ U(ln, {
            as: "span",
            children: `${t.userEmail}:`
          }), /* @__PURE__ */ U(rn, {
            children: a["User Email"]
          })]
        }), e.children]
      }),
      trigger: "click",
      interactive: !0,
      placement: "auto-start",
      children: /* @__PURE__ */ U(JD, {
        className: "isr-support-open",
        styleType: "borderless",
        size: "small",
        children: t.idsForTechSupport
      })
    })
  });
};
const kp = ({
  children: e,
  className: n,
  ...i
}) => /* @__PURE__ */ U("div", {
  className: nr("isr-report-title-wrapper", n),
  ...i,
  children: e
}), Up = {
  Authorization: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  BriefcaseToiModel: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  BusinessProperties: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Compatibility: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  CorruptData: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  DigitalRights: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  DiskIO: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Filtering: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  IModel: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  InconsistentData: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  InputFiles: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  MissingData: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Synchronization: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  ToolkitError: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  UnexpectedData: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Unknown: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  Unsupported: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  },
  VisualFidelity: {
    Attachment: ["Design Review"],
    Alert: ["Design Review", "Reporting", "Clash", "Construction"],
    "BRep-Surface": ["Design Review"],
    Briefcase: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigXMLFile: ["Design Review"],
    Config: ["Design Review", "Reporting", "Clash", "Construction"],
    ConfigVariable: ["Design Review", "Reporting", "Clash", "Construction"],
    DefinitionFile: ["Design Review", "Reporting", "Clash", "Construction"],
    Document: ["Design Review", "Reporting", "Clash", "Construction"],
    DataSource: ["Design Review", "Reporting", "Clash", "Construction"],
    DuplicateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ECClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    ECInstance: ["Design Review", "Reporting", "Clash", "Construction"],
    ECRelationshipClass: ["Design Review", "Reporting", "Clash", "Construction"],
    ECProperty: ["Design Review", "Reporting", "Construction"],
    ECCustomAttribute: ["Design Review", "Reporting", "Construction"],
    Element: ["Design Review", "Reporting", "Clash", "Construction"],
    ECSQL: ["Design Review", "Reporting", "Construction"],
    ECDB: ["Design Review", "Reporting", "Clash", "Construction"],
    EmbeddedFile: ["Design Review", "Reporting", "Clash", "Construction"],
    FileHandler: ["Design Review", "Reporting", "Clash", "Construction"],
    Font: ["Design Review"],
    FileNotFound: ["Design Review", "Reporting", "Clash", "Construction"],
    FileStatus: ["Design Review"],
    GeometryElement: ["Design Review", "Reporting", "Clash", "Construction"],
    GroupElements: ["Design Review"],
    Geometry: ["Design Review", "Reporting", "Clash", "Construction"],
    GCS: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportGroup: ["Design Review", "Reporting", "Clash", "Construction"],
    InvisibleElement: ["Design Review"],
    Instance: ["Design Review", "Reporting", "Clash", "Construction"],
    InconsistentTransformsForEmbeddedReference: ["Design Review", "Reporting", "Clash", "Construction"],
    iModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportXData: ["Design Review"],
    JobDefinitionModel: ["Design Review", "Reporting", "Clash", "Construction"],
    LineStyle: ["Design Review"],
    Level: ["Design Review"],
    Link: ["Design Review"],
    LargeBRep: ["Design Review"],
    Material: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingSoftwareDependency: ["Design Review", "Reporting", "Clash", "Construction"],
    Model: ["Design Review", "Reporting", "Clash", "Construction"],
    NonSupportedImageFile: ["Design Review"],
    NamedGroup: ["Design Review"],
    NotADgnDb: ["Design Review"],
    PointCloudConversionError: ["Design Review"],
    PointCloudFile: ["Design Review"],
    ProjectExtentsAdjusted: ["Design Review"],
    Raster: ["Design Review"],
    Range: ["Design Review"],
    RealityModelTileSets: ["Design Review"],
    RootModel: ["Design Review"],
    ReferenceFile: ["Design Review", "Reporting", "Clash", "Construction"],
    References: ["Design Review", "Reporting", "Clash", "Construction"],
    RepositoryLink: ["Design Review"],
    SupplementalECSchema: ["Design Review", "Reporting", "Clash", "Construction"],
    Sheet: ["Design Review"],
    SyncInfo: ["Design Review"],
    ThreeMx: ["Design Review"],
    Undefined: ["Design Review", "Reporting", "Clash", "Construction"],
    Units: ["Design Review", "Reporting", "Clash", "Construction"],
    View: ["Design Review"],
    MissingGeometry: ["Design Review", "Reporting", "Clash", "Construction"],
    InvalidInputData: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGroupMember: ["Design Review", "Reporting", "Clash", "Construction"],
    MaterialNoFile: ["Design Review", "Reporting"],
    UpdateDoesNotChangeClass: ["Design Review", "Reporting", "Clash", "Construction"],
    Parasolid: ["Design Review", "Reporting", "Clash", "Construction"],
    Layer: ["Design Review"],
    Lights: ["Design Review"],
    LineType: ["Design Review"],
    Text: ["Design Review"],
    ViewPort: ["Design Review"],
    CircularReferenceFileBreak: ["Design Review", "Reporting", "Clash", "Construction"],
    ECDbIssue: ["Design Review", "Reporting", "Clash", "Construction"],
    GeometricModel: ["Design Review", "Reporting", "Clash", "Construction"],
    ImportFailure: ["Design Review", "Reporting", "Clash", "Construction"],
    CantCreateModel: ["Design Review", "Reporting", "Clash", "Construction"],
    Error: ["Design Review", "Reporting", "Clash", "Construction"],
    MissingGCS: ["Design Review", "Reporting", "Clash", "Construction"],
    IllegalUnits: ["Design Review", "Reporting"],
    RootModelMustBePhysical: ["Design Review"],
    LinkProcessingError: ["Design Review"]
  }
};
var li = void 0, Sn = null, Jv = "", zR = "boolean", Hu = "function", $R = "number", Xa = "object", Ki = "prototype", Pl = "__proto__", jR = "string", ut = "undefined", Al = "constructor", Qv = "Symbol", Yp = "_polyfill", KR = "indexOf", WR = "lastIndexOf", Fa = "length", Jf = "done", XR = "value", Zv = "name", ef = "slice", Vn = Object, qR = Vn[Ki], JR = String, Ri = JR[Ki], xp = Math, QR = Array, Uo = QR[Ki];
function ZR(e, n) {
  var i = n;
  try {
    i = e();
  } catch (r) {
  }
  return i;
}
var Bp = [jR, $R, zR, ut, "symbol", "bigint"];
function zu(e) {
  return function(n) {
    return typeof n === e;
  };
}
function ed(e) {
  var n = "[object " + e + "]";
  return function(i) {
    return !!(i && nf(i) === n);
  };
}
function nf(e) {
  return qR.toString.call(e);
}
function qe(e) {
  return typeof e === ut || e === ut;
}
function z(e) {
  return e === Sn || qe(e);
}
function Gp(e) {
  return e === Sn || !nd(e);
}
function nd(e) {
  return !!e || e !== li;
}
var Vp = function(e) {
  return e !== Xa && Bp.indexOf(e) !== -1;
}, he = zu(jR), _e = zu(Hu);
function Ln(e) {
  return !e && z(e) ? !1 : !!e && typeof e === Xa;
}
var Me = QR.isArray, Hp = ed("Date"), $u = zu($R), id = zu(zR), ju = ed("Error");
function Zs(e) {
  return !!e && _e(e.then);
}
function eu(e) {
  return !(!e || ZR(function() {
    return !(e && 0 + e);
  }, !e));
}
var rf = Vn.getOwnPropertyDescriptor;
function ni(e, n) {
  return e && qR.hasOwnProperty.call(e, n);
}
var Tr = Vn.hasOwn || zp;
function zp(e, n) {
  return ni(e, n) || !!rf(e, n);
}
function Te(e, n, i) {
  if (e && Ln(e)) {
    for (var r in e)
      if (Tr(e, r) && n.call(i || e, r, e[r]) === -1)
        break;
  }
}
function rd(e, n, i, r) {
  var t = {};
  return Te(e, function(a, o) {
    t[a] = n ? o : a, t[o] = i ? o : a;
  }), r(t);
}
function $n(e) {
  throw new Error(e);
}
function Mi(e) {
  throw new TypeError(e);
}
function $p(e) {
  var n = [];
  return Te(e, function(i, r) {
    n.push([i, r]);
  }), n;
}
function jp(e) {
  var n = [];
  return Te(e, function(i, r) {
    n.push(r);
  }), n;
}
var Fl = Vn.freeze, td = function(e) {
  return e;
}, Kp = function(e) {
  return e[Pl] || Sn;
}, Ll = Vn.assign;
function Ar(e) {
  return (!Ln(e) || e === Sn) && Mi("objKeys called on non-object"), Vn.keys(e);
}
function ir(e) {
  return Fl && Te(e, function(n, i) {
    (Me(i) || Ln(i)) && Fl(i);
  }), Mo(e);
}
var Mo = Fl || td;
Vn.seal;
var Ol = Vn.getPrototypeOf || Kp;
Vn.entries;
Vn.values;
function Wp(e) {
  return rd(e, 1, 0, ir);
}
function Xp(e) {
  return rd(e, 0, 0, ir);
}
function qp(e) {
  var n = {};
  return Te(e, function(i, r) {
    n[i] = r[1], n[r[0]] = r[1];
  }), ir(n);
}
function Jp(e) {
  return qp(e);
}
var od = Xp({
  asyncIterator: 0,
  hasInstance: 1,
  isConcatSpreadable: 2,
  iterator: 3,
  match: 4,
  matchAll: 5,
  replace: 6,
  search: 7,
  species: 8,
  split: 9,
  toPrimitive: 10,
  toStringTag: 11,
  unscopables: 12
}), Pi = JR, Qf = "__tsUtils$gblCfg", uc;
function ad() {
  var e;
  return typeof globalThis !== ut && (e = globalThis), !e && typeof self !== ut && (e = self), !e && typeof window !== ut && (e = window), !e && typeof global !== ut && (e = global), e;
}
function sd() {
  if (!uc) {
    var e = ad() || {};
    uc = e[Qf] = e[Qf] || {};
  }
  return uc;
}
function ae(e, n) {
  var i = Jv;
  if (ju(e))
    i = "{ stack: '" + e.stack + "', message: '" + e.message + "', name: '" + e.name + "'";
  else
    try {
      i = JSON.stringify(e, Sn, n ? $u(n) ? n : 4 : li);
    } catch (r) {
      i = " - " + ae(r, n);
    }
  return nf(e) + ": " + i;
}
var tf = Uo[ef], ud = function(e, n) {
  Mi("'" + Pi(e) + "' not defined for " + ae(n));
}, cd = function(e) {
  return function(n) {
    return n[e].apply(n, tf.call(arguments, 1));
  };
}, di = function(e, n) {
  var i = n && n[e];
  return function(r) {
    var t = r && r[e] || i;
    if (t)
      return t.apply(r, tf.call(arguments, 1));
    ud(e, r);
  };
}, qa = function(e, n, i) {
  var r = n && n[e];
  return function(t) {
    var a = t && t[e] || r;
    if (a || i) {
      var o = arguments;
      return (a || i).apply(t, a ? tf.call(o, 1) : o);
    }
    ud(e, t);
  };
};
function Qp(e) {
  return function(n) {
    return n[e];
  };
}
var Zp = xp.max, Zf = di(ef, Ri), Ci = di("substring", Ri), gr = qa("substr", Ri, eh);
function eh(e, n, i) {
  return z(e) && Mi("'polyStrSubstr called with invalid " + ae(e)), i < 0 ? Jv : (n = n || 0, n < 0 && (n = Zp(n + e[Fa], 0)), qe(i) ? Zf(e, n) : Zf(e, n, n + i));
}
function of(e, n) {
  return Ci(e, 0, n);
}
var eg = "_urid", cc;
function nh() {
  if (!cc) {
    var e = sd();
    cc = e.gblSym = e.gblSym || { k: {}, s: {} };
  }
  return cc;
}
var ng = {};
function af(e) {
  var n = {
    description: Pi(e),
    toString: function() {
      return Qv + "(" + e + ")";
    }
  };
  return n[Yp] = !0, n;
}
function ih(e) {
  var n = nh();
  if (!Tr(n.k, e)) {
    var i = af(e), r = Ar(n.s).length;
    i[eg] = function() {
      return r + "_" + i.toString();
    }, n.k[e] = i, n.s[i[eg]()] = Pi(e);
  }
  return n.k[e];
}
function rh(e) {
  var n, i = od[e];
  return i && (n = ng[i] = ng[i] || af(Qv + "." + i)), n;
}
var ts = {
  e: "enumerable",
  c: "configurable",
  v: XR,
  w: "writable",
  g: "get",
  s: "set"
};
function ld(e) {
  var n = {};
  if (n[ts.c] = !0, n[ts.e] = !0, e.l) {
    n.get = function() {
      return e.l.v;
    };
    var i = rf(e.l, "v");
    i && i.set && (n.set = function(r) {
      e.l.v = r;
    });
  }
  return Te(e, function(r, t) {
    n[ts[r]] = qe(t) ? n[ts[r]] : t;
  }), n;
}
var ci = Vn.defineProperty;
function th(e, n, i, r, t, a) {
  var o = {
    e: a,
    c: t
  };
  return i && (o.g = i), r && (o.s = r), ci(e, n, ld(o));
}
function xe(e, n, i) {
  return ci(e, n, ld(i));
}
var Ze, kl = function() {
  Ze = sd(), kl = Sn;
};
function Ja(e) {
  var n = {};
  return kl && kl(), n.b = Ze.lzy, ci(n, "v", {
    configurable: !0,
    get: function() {
      var i = e();
      return Ze.lzy || (ci(n, "v", {
        value: i
      }), n.b && delete n.b), Ze.lzy && n.b !== Ze.lzy && (n.b = Ze.lzy), i;
    }
  }), n;
}
function Yo(e, n) {
  return Ja(function() {
    return ZR(e, n);
  });
}
var vd = "window", io, ro, os, as, ss, lc, vc, Yr = function(e) {
  return Yo(function() {
    return yn(e) || li;
  }, li);
}, ei = function(e) {
  return (!io || e === !1 || Ze && Ze.lzy && !io.b) && (io = Yo(ad, Sn)), io.v;
}, yn = function(e, n) {
  var i = !io || n === !1 ? ei(n) : io.v;
  return i && i[e] ? i[e] : e === vd && ro ? ro.v : Sn;
}, fd = function() {
  return !!Tn();
}, Tn = function() {
  return (!os || Ze && Ze.lzy && !os.b) && (os = Yr("document")), os.v;
}, Ku = function() {
  return !!jn();
}, jn = function() {
  return (!ro || Ze && Ze.lzy && !ro.b) && (ro = Yr(vd)), ro.v;
}, oh = function() {
  return !!Ai();
}, Ai = function() {
  return (!as || Ze && Ze.lzy && !as.b) && (as = Yr("navigator")), as.v;
}, ah = function() {
  return !!gd();
}, gd = function() {
  return (!ss || Ze && Ze.lzy && !ss.b) && (ss = Yr("history")), ss.v;
}, sh = function() {
  return !vc && (vc = Yo(function() {
    return !!(process && (process.versions || {}).node);
  }, !1)), vc.v;
}, Rd = function() {
  return !lc && (lc = Yo(function() {
    return !!(self && self instanceof WorkerGlobalScope);
  }, !1)), lc.v;
}, Pn, nu, ig;
function rg(e) {
  return Yo(function() {
    return Pn.v ? Pn.v[e] : li;
  }, li);
}
function dd() {
  return !!Wu();
}
function Wu() {
  var e = !Pn || Ze && Ze.lzy && !Pn.b;
  return e && (Pn = Yr(Qv)), (!nu || e) && (nu = rg("for")), (!ig || e) && (ig = rg("keyFor")), Pn.v;
}
function Xu(e, n) {
  var i = od[e];
  return (!Pn || Ze.lzy && !Pn.b) && Wu(), Pn.v ? Pn.v[i || e] : n ? li : rh(e);
}
function zo(e, n) {
  return (!Pn || Ze.lzy && !Pn.b) && Wu(), Pn.v ? Pn.v(e) : n ? Sn : af(e);
}
function sf(e) {
  return (!nu || Ze.lzy && !Pn.b) && Wu(), (nu.v || ih)(e);
}
function Ul(e) {
  return !!e && _e(e.next);
}
function uh(e) {
  return !Gp(e) && _e(e[Xu(3)]);
}
var us;
function ch(e, n, i) {
  if (e && (Ul(e) || (!us && (us = Ja(function() {
    return Xu(3);
  })), e = e[us.v] ? e[us.v]() : null), Ul(e))) {
    var r = void 0, t = void 0;
    try {
      for (var a = 0; !(t = e.next())[Jf] && n.call(i || e, t[XR], a, e) !== -1; )
        a++;
    } catch (o) {
      r = { e: o }, e.throw && (t = null, e.throw(r));
    } finally {
      try {
        t && !t[Jf] && e.return && e.return(t);
      } finally {
        if (r)
          throw r.e;
      }
    }
  }
}
var to = cd("apply");
function oo(e, n) {
  return !qe(n) && e && (Me(n) ? to(e.push, e, n) : Ul(n) || uh(n) ? ch(n, function(i) {
    e.push(i);
  }) : e.push(n)), e;
}
function se(e, n, i) {
  if (e)
    for (var r = e[Fa] >>> 0, t = 0; t < r && !(t in e && n.call(i || e, e[t], t, e) === -1); t++)
      ;
}
var Nn = di(KR, Uo);
di(WR, Uo);
var Ea = di("map", Uo), rr = di(ef, Uo), Yl = cd("call"), lh = di("reduce", Uo), vh = Vn.create, Cd = vh || fh;
function fh(e) {
  if (!e)
    return {};
  var n = typeof e;
  if (n !== Xa && n !== Hu)
    throw new TypeError("Prototype must be an Object or function: " + ae(e));
  function i() {
  }
  return i[Ki] = e, new i();
}
var fc;
function Dd(e, n) {
  var i = Vn.setPrototypeOf || function(r, t) {
    !fc && (fc = Ja(function() {
      var a;
      return a = {}, a[Pl] = [], a instanceof Array;
    })), fc.v ? r[Pl] = t : Te(t, function(a, o) {
      return r[a] = o;
    });
  };
  return i(e, n);
}
var gh = function(e, n, i) {
  og(n, e), n = Dd(n, i);
  function r() {
    this.constructor = n, og(this, e);
  }
  return n[Ki] = i === Sn ? Cd(i) : (r[Ki] = i[Ki], new r()), n;
}, tg = function(e, n) {
  try {
    n && (e[Zv] = n);
  } catch (i) {
  }
}, og = function(e, n) {
  try {
    xe(e, Zv, { v: n, c: !0, e: !1 });
  } catch (i) {
  }
};
function pd(e, n, i) {
  var r = i || Error, t = r[Ki][Zv], a = Error.captureStackTrace;
  return gh(e, function() {
    var o = this;
    try {
      tg(r, e);
      var s = to(r, o, rr(arguments)) || o;
      if (s !== o) {
        var u = Ol(o);
        u !== Ol(s) && Dd(s, u);
      }
      return a && a(s, o[Al]), n && n(s, arguments), s;
    } finally {
      tg(r, t);
    }
  }, r);
}
var gc;
function Rh(e) {
  throw gc || (gc = pd("UnsupportedError")), new gc(e);
}
function Ni() {
  return (Date.now || dh)();
}
function dh() {
  return new Date().getTime();
}
function uf(e) {
  return function(i) {
    return z(i) && Mi("strTrim called [" + ae(i) + "]"), i && i.replace && (i = i.replace(e, Jv)), i;
  };
}
var Ch = uf(/^\s+|(?=\s)\s+$/g), Dh = uf(/^\s+/g), ph = uf(/(?=\s)\s+$/g), An = qa("trim", Ri, Ch);
qa("trimStart", Ri, Dh);
qa("trimEnd", Ri, ph);
var Rc, dc, Cc;
function Bn(e) {
  if (!e || typeof e !== Xa)
    return !1;
  Cc || (Cc = Ku() ? jn() : !0);
  var n = !1;
  if (e !== Cc) {
    dc || (Rc = Function[Ki].toString, dc = Yl(Rc, Vn));
    try {
      var i = Ol(e);
      n = !i, n || (ni(i, Al) && (i = i[Al]), n = i && typeof i === Hu && Rc.call(i) === dc);
    } catch (r) {
    }
  }
  return n;
}
var hh = function(e) {
  return e.value && wd(e), !0;
}, ag = [
  mh,
  wd,
  Th,
  Sh
];
function wh(e, n, i, r) {
  var t;
  return se(e, function(a) {
    if (a.k === n)
      return t = a, -1;
  }), t || (t = { k: n, v: n }, e.push(t), r(t)), t.v;
}
function cf(e, n, i, r) {
  var t = i.handler, a = i.path ? r ? i.path.concat(r) : i.path : [], o = {
    handler: i.handler,
    src: i.src,
    path: a
  }, s = typeof n, u = !1, c = !1;
  n && s === Xa ? u = Bn(n) : c = n === Sn || Vp(s);
  var l = {
    type: s,
    isPrim: c,
    isPlain: u,
    value: n,
    result: n,
    path: a,
    origin: i.src,
    copy: function(g, R) {
      return cf(e, g, R ? o : i, R);
    },
    copyTo: function(g, R) {
      return hd(e, g, R, o);
    }
  };
  return l.isPrim ? t && Yl(t, i, l) ? l.result : n : wh(e, n, a, function(g) {
    xe(l, "result", {
      g: function() {
        return g.v;
      },
      s: function(f) {
        g.v = f;
      }
    });
    for (var R = 0, v = t; !Yl(v || (R < ag.length ? ag[R++] : hh), i, l); )
      v = Sn;
  });
}
function hd(e, n, i, r) {
  if (!z(i))
    for (var t in i)
      n[t] = cf(e, i[t], r, t);
  return n;
}
function _h(e, n, i) {
  var r = {
    handler: i,
    src: n,
    path: []
  };
  return hd([], e, n, r);
}
function Eh(e, n) {
  var i = {
    handler: n,
    src: e
  };
  return cf([], e, i);
}
function mh(e) {
  var n = e.value;
  if (Me(n)) {
    var i = e.result = [];
    return i.length = n.length, e.copyTo(i, n), !0;
  }
  return !1;
}
function Sh(e) {
  var n = e.value;
  return Hp(n) ? (e.result = new Date(n.getTime()), !0) : !1;
}
function Th(e) {
  return e.type === Hu;
}
function wd(e) {
  var n = e.value;
  if (n && e.isPlain) {
    var i = e.result = {};
    return e.copyTo(i, n), !0;
  }
  return !1;
}
function _d(e, n) {
  return se(n, function(i) {
    _h(e, i);
  }), e;
}
function sg(e, n, i, r, t, a, o) {
  return _d(Eh(e) || {}, rr(arguments));
}
function yh(e, n, i, r, t, a, o) {
  return _d(e || {}, rr(arguments));
}
var Nh = Qp(Fa), cs;
function Zi() {
  return (!cs || !cs.b && Ze && Ze.lzy) && (cs = Yr("performance")), cs.v;
}
function Ih(e, n, i) {
  var r = n && n[Xu(9)];
  return r ? r(e, i) : [e];
}
var Ed = di("split", Ri);
dd() && di("split", Ri);
function md(e, n, i) {
  if (e && n) {
    var r = Ed(n, "."), t = r.pop();
    se(r, function(a) {
      z(e[a]) && (e[a] = {}), e = e[a];
    }), e[t] = i;
  }
}
var Sd = qa("endsWith", Ri, bh);
function bh(e, n, i) {
  he(e) || Mi("'" + ae(e) + "' is not a string");
  var r = he(n) ? n : Pi(n), t = r[Fa], a = e[Fa], o = !qe(i) && i < a ? i : a;
  return Ci(e, o - t, o) === r;
}
var Gn = di(KR, Ri);
di(WR, Ri);
var Fs = "ref", Dc = "un" + Fs, pc = "hasRef", ug = "enabled";
function Mh(e, n, i) {
  var r, t = !0, a = e ? n(Sn) : Sn, o, s = function() {
    return t = !1, a && a[Dc] && a[Dc](), o;
  }, u = function() {
    return t = !0, a && a[Fs] && a[Fs](), o;
  }, c = function() {
    return a && a[pc] ? a[pc]() : t;
  }, l = function() {
    return a = n(a), t || s(), o;
  }, g = function() {
    a && i(a), a = Sn;
  }, R = function(v) {
    !v && a && g(), v && !a && l();
  };
  return o = (r = {
    cancel: g,
    refresh: l
  }, r[pc] = c, r[Fs] = u, r[Dc] = s, r[ug] = !1, r), ci(o, ug, {
    get: function() {
      return !!a;
    },
    set: R
  }), {
    h: o,
    dn: function() {
      a = Sn;
    }
  };
}
function Td(e, n, i, r) {
  var t = Me(i), a = t ? i.length : 0, o = (a > 0 ? i[0] : t ? li : i) || setTimeout, s = (a > 1 ? i[1] : li) || clearTimeout, u = r[0];
  r[0] = function() {
    c.dn(), to(u, e, rr(arguments));
  };
  var c = Mh(n, function(l) {
    if (l) {
      if (l.refresh)
        return l.refresh(), l;
      to(s, e, [l]);
    }
    return to(o, e, r);
  }, function(l) {
    to(s, e, [l]);
  });
  return c.h;
}
function Di(e, n) {
  return Td(this, !0, li, rr(arguments));
}
function Ph(e, n) {
  return Td(this, !1, li, rr(arguments));
}
var ls, iu = "constructor", Fr = "prototype", ru = "function", tu = "_dynInstFuncs", xl = "_isDynProxy", vo = "_dynClass", Ah = "_dynCls$", Bl = "_dynInstChk", La = Bl, yd = "_dfOpts", cg = "_unknown_", Nd = "__proto__", vs = "_dyn" + Nd, lg = "__dynProto$Gbl", hc = "_dynInstProto", Ls = "useBaseInst", Gl = "setInstFuncs", lf = Object, Oa = lf.getPrototypeOf, vg = lf.getOwnPropertyNames, fg = ei(), Vl = fg[lg] || (fg[lg] = {
  o: (ls = {}, ls[Gl] = !0, ls[Ls] = !0, ls),
  n: 1e3
});
function Id(e) {
  return e && (e === lf[Fr] || e === Array[Fr]);
}
function vf(e) {
  return Id(e) || e === Function[Fr];
}
function wt(e) {
  var n;
  if (e) {
    if (Oa)
      return Oa(e);
    var i = e[Nd] || e[Fr] || (e[iu] ? e[iu][Fr] : null);
    n = e[vs] || i, ni(e, vs) || (delete e[hc], n = e[vs] = e[hc] || e[vs], e[hc] = i);
  }
  return n;
}
function ou(e, n) {
  var i = [];
  if (vg)
    i = vg(e);
  else
    for (var r in e)
      typeof r == "string" && ni(e, r) && i.push(r);
  if (i && i.length > 0)
    for (var t = 0; t < i.length; t++)
      n(i[t]);
}
function ff(e, n, i) {
  return n !== iu && typeof e[n] === ru && (i || ni(e, n));
}
function au(e) {
  Mi("DynamicProto: " + e);
}
function Fh(e) {
  var n = {};
  return ou(e, function(i) {
    !n[i] && ff(e, i, !1) && (n[i] = e[i]);
  }), n;
}
function gf(e, n) {
  for (var i = e.length - 1; i >= 0; i--)
    if (e[i] === n)
      return !0;
  return !1;
}
function Lh(e, n, i, r) {
  function t(u, c, l) {
    var g = c[l];
    if (g[xl] && r) {
      var R = u[tu] || {};
      R[La] !== !1 && (g = (R[c[vo]] || {})[l] || g);
    }
    return function() {
      return g.apply(u, arguments);
    };
  }
  var a = {};
  ou(i, function(u) {
    a[u] = t(n, i, u);
  });
  for (var o = wt(e), s = []; o && !vf(o) && !gf(s, o); )
    ou(o, function(u) {
      !a[u] && ff(o, u, !Oa) && (a[u] = t(n, o, u));
    }), s.push(o), o = wt(o);
  return a;
}
function Oh(e, n, i, r) {
  var t = null;
  if (e && ni(i, vo)) {
    var a = e[tu] || {};
    if (t = (a[i[vo]] || {})[n], t || au("Missing [" + n + "] " + ru), !t[Bl] && a[La] !== !1) {
      for (var o = !ni(e, n), s = wt(e), u = []; o && s && !vf(s) && !gf(u, s); ) {
        var c = s[n];
        if (c) {
          o = c === r;
          break;
        }
        u.push(s), s = wt(s);
      }
      try {
        o && (e[n] = t), t[Bl] = 1;
      } catch (l) {
        a[La] = !1;
      }
    }
  }
  return t;
}
function kh(e, n, i) {
  var r = n[e];
  return r === i && (r = wt(n)[e]), typeof r !== ru && au("[" + e + "] is not a " + ru), r;
}
function Uh(e, n, i, r, t) {
  function a(u, c) {
    var l = function() {
      var g = Oh(this, c, u, l) || kh(c, u, l);
      return g.apply(this, arguments);
    };
    return l[xl] = 1, l;
  }
  if (!Id(e)) {
    var o = i[tu] = i[tu] || {}, s = o[n] = o[n] || {};
    o[La] !== !1 && (o[La] = !!t), ou(i, function(u) {
      ff(i, u, !1) && i[u] !== r[u] && (s[u] = i[u], delete i[u], (!ni(e, u) || e[u] && !e[u][xl]) && (e[u] = a(e, u)));
    });
  }
}
function Yh(e, n) {
  if (Oa) {
    for (var i = [], r = wt(n); r && !vf(r) && !gf(i, r); ) {
      if (r === e)
        return !0;
      i.push(r), r = wt(r);
    }
    return !1;
  }
  return !0;
}
function wc(e, n) {
  return ni(e, Fr) ? e.name || n || cg : ((e || {})[iu] || {}).name || n || cg;
}
function We(e, n, i, r) {
  ni(e, Fr) || au("theClass is an invalid class definition.");
  var t = e[Fr];
  Yh(t, n) || au("[" + wc(e) + "] not in hierarchy of [" + wc(n) + "]");
  var a = null;
  ni(t, vo) ? a = t[vo] : (a = Ah + wc(e, "_") + "$" + Vl.n, Vl.n++, t[vo] = a);
  var o = We[yd], s = !!o[Ls];
  s && r && r[Ls] !== void 0 && (s = !!r[Ls]);
  var u = Fh(n), c = Lh(t, n, u, s);
  i(n, c);
  var l = !!Oa && !!o[Gl];
  l && r && (l = !!r[Gl]), Uh(t, a, n, u, l !== !1);
}
We[yd] = Vl.o;
var bd = "function", Md = "object", Rf = "undefined", mi = "prototype", df = Object, xh = df[mi];
(ei() || {}).Symbol;
(ei() || {}).Reflect;
var Pd = "hasOwnProperty", Bh = function(e) {
  for (var n, i = 1, r = arguments.length; i < r; i++) {
    n = arguments[i];
    for (var t in n)
      xh[Pd].call(n, t) && (e[t] = n[t]);
  }
  return e;
}, Fn = Ll || Bh, Hl = function(e, n) {
  return Hl = df.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, r) {
    i.__proto__ = r;
  } || function(i, r) {
    for (var t in r)
      r[Pd](t) && (i[t] = r[t]);
  }, Hl(e, n);
};
function Fi(e, n) {
  typeof n !== bd && n !== null && Mi("Class extends value " + String(n) + " is not a constructor or null"), Hl(e, n);
  function i() {
    this.constructor = e;
  }
  e[mi] = n === null ? Cd(n) : (i[mi] = n[mi], new i());
}
function gg(e, n) {
  for (var i = 0, r = n.length, t = e.length; i < r; i++, t++)
    e[t] = n[i];
  return e;
}
var Ad = Wp, Gh = Jp, su = "toLowerCase", uu = "blkVal", Ae = "length", cu = "rdOnly", lu = "notify", vu = "warnToConsole", Qa = "throwInternal", xo = "setDf", zi = "watch", an = "logger", _t = "apply", Be = "push", Bo = "splice", Fd = "hdlr", Ra = "cancel", qu = "initialize", Rr = "identifier", Ei = "isInitialized", ka = "getPlugin", Rg = "pollInternalLogs", yr = "name", fo = "time", Mn = "processNext", Ld = "getProcessTelContext", $o = "getNotifyMgr", Os = "addNotificationListener", ks = "removeNotificationListener", ao = "enabled", dg = "stopPollingInternalLogs", Lr = "unload", fs = "onComplete", fu = "version", Od = "loggingLevelConsole", Et = "createNew", Vi = "teardown", gu = "messageId", go = "message", Po = "isAsync", Wi = "diagLog", zl = "_doTeardown", Ua = "update", Si = "getNext", Ya = "setNextPlugin", $l = "userAgent", xa = "split", _c = "nodeType", Ro = "replace", kd = "logInternalMessage", Xi = "type", Cf = "handler", jl = "isChildEvt", Co = "getCtx", hi = "setCtx", Kl = "complete", Wl = "traceId", Xl = "spanId", ql = "traceFlags", Ec;
function Vh(e, n) {
  Ec || (Ec = pd("AggregationError", function(r, t) {
    t[Ae] > 1 && (r.errors = t[1]);
  }));
  var i = e || "One or more errors occurred.";
  throw se(n, function(r, t) {
    i += `
`.concat(t, " > ").concat(ae(r));
  }), new Ec(i, n || []);
}
function Ao(e, n) {
  return Ud(e, function(i) {
    n && n({
      value: i,
      rejected: !1
    });
  }, function(i) {
    n && n({
      rejected: !0,
      reason: i
    });
  });
}
function Ud(e, n, i, r) {
  var t = e;
  return Zs(e) ? (n || i) && (t = e.then(n, i)) : n && n(e), r && (t = Hh(t, r)), t;
}
function Hh(e, n) {
  var i = e;
  return n && (Zs(e) ? e.finally ? i = e.finally(n) : i = e.then(function(r) {
    return n(), r;
  }, function(r) {
    throw n(), r;
  }) : n()), i;
}
var mc, Sc, Tc, zh = !1;
function $h(e, n, i, r) {
  mc = mc || { toString: function() {
    return "[[PromiseState]]";
  } }, Sc = Sc || { toString: function() {
    return "[[PromiseResult]]";
  } }, Tc = Tc || { toString: function() {
    return "[[PromiseIsHandled]]";
  } }, ci(e, mc, { get: n }), ci(e, Sc, { get: i }), ci(e, Tc, { get: r });
}
var Yd = [
  "pending",
  "resolving",
  "resolved",
  "rejected"
], Cg = "dispatchEvent", gs;
function jh(e, n, i, r) {
  var t = Tn();
  !gs && (gs = Yo(function() {
    var u;
    return t && t.createEvent && (u = t.createEvent("Event")), !!u && u.initEvent;
  }, null));
  var a = gs.v ? t.createEvent("Event") : r ? new Event(n) : {};
  if (i && i(a), gs.v && a.initEvent(n, !1, !0), a && e[Cg])
    e[Cg](a);
  else {
    var o = e["on" + n];
    if (o)
      o(a);
    else {
      var s = yn("console");
      s && (s.error || s.log)(n, ae(a));
    }
  }
}
var Ru = "Promise", xd = "unhandledRejection", Kh = xd.toLowerCase(), Dg = [], Wh = 0, Xh = 10, yc;
function pg(e) {
  return _e(e) ? e.toString() : ae(e);
}
function qh(e, n, i) {
  var r = rr(arguments, 3), t = 0, a = !1, o, s = [], u = Wh++, c = !1, l = null, g;
  !yc && (yc = Yr(Ru + "RejectionEvent"));
  var R = function(N, O) {
    try {
      Dg.push(u), c = !0, l && l.cancel(), l = null;
      var d = e(function(m, y) {
        s.push(function() {
          try {
            var Y = t === 2 ? N : O, k = qe(Y) ? o : _e(Y) ? Y(o) : Y;
            Zs(k) ? k.then(m, y) : Y ? m(k) : t === 3 ? y(k) : m(k);
          } catch (J) {
            y(J);
          }
        }), a && D();
      }, r);
      return d;
    } finally {
      Dg.pop();
    }
  }, v = function(N) {
    return R(void 0, N);
  }, f = function(N) {
    var O = N, d = N;
    return _e(N) && (O = function(m) {
      return N && N(), m;
    }, d = function(m) {
      throw N && N(), m;
    }), R(O, d);
  }, p = function() {
    return Yd[t];
  }, D = function() {
    if (s.length > 0) {
      var N = s.slice();
      s = [], c = !0, n(N), l && l.cancel(), l = null;
    }
  }, C = function(N, O) {
    return function(d) {
      if (t === O) {
        if (N === 2 && Zs(d)) {
          t = 1, d.then(C(2, 1), C(3, 1));
          return;
        }
        t = N, a = !0, o = d, D(), !c && N === 3 && !l && (l = Di(_, Xh));
      }
    };
  }, _ = function() {
    if (!c)
      if (sh())
        process.emit(xd, o, g);
      else {
        var N = jn() || ei();
        jh(N, Kh, function(O) {
          return xe(O, "promise", { g: function() {
            return g;
          } }), O.reason = o, O;
        }, !!yc.v);
      }
  };
  g = {
    then: R,
    catch: v,
    finally: f
  }, ci(g, "state", {
    get: p
  }), zh && $h(g, p, function() {
    return nf(o);
  }, function() {
    return c;
  }), dd() && (g[Xu(11)] = "IPromise");
  var E = function() {
    return "IPromise " + p() + (a ? " - " + pg(o) : "");
  };
  return g.toString = E, function() {
    _e(i) || Mi(Ru + ": executor is not a function - " + pg(i));
    var O = C(3, 0);
    try {
      i.call(g, C(2, 0), O);
    } catch (d) {
      O(d);
    }
  }(), g;
}
function Jh(e) {
  return function(n) {
    var i = rr(arguments, 1);
    return e(function(r, t) {
      try {
        var a = [], o = 1;
        se(n, function(s, u) {
          s && (o++, Ud(s, function(c) {
            a[u] = c, --o === 0 && r(a);
          }, t));
        }), o--, o === 0 && r(a);
      } catch (s) {
        t(s);
      }
    }, i);
  };
}
var Qh = function(e) {
  se(e, function(n) {
    try {
      n();
    } catch (i) {
    }
  });
};
function Zh(e) {
  var n = $u(e) ? e : 0;
  return function(i) {
    Di(function() {
      Qh(i);
    }, n);
  };
}
function Bd(e, n) {
  return qh(Bd, Zh(n), e, n);
}
var Nc;
function ew(e, n) {
  !Nc && (Nc = Yr(Ru));
  var i = Nc.v;
  if (!i)
    return Bd(e);
  _e(e) || Mi(Ru + ": executor is not a function - " + ae(e));
  var r = 0;
  function t() {
    return Yd[r];
  }
  var a = new i(function(o, s) {
    function u(l) {
      r = 2, o(l);
    }
    function c(l) {
      r = 3, s(l);
    }
    e(u, c);
  });
  return ci(a, "state", {
    get: t
  }), a;
}
var Ic;
function Or(e, n) {
  return !Ic && (Ic = Ja(function() {
    return ew;
  })), Ic.v.call(this, e, n);
}
var nw = Jh(Or), _i = void 0, Le = "", it = "channels", Rn = "core", Jl = "createPerfMgr", Ql = "disabled", Do = "extensionConfig", Xt = "extensions", Ii = "processTelemetry", du = "priority", Us = "eventsSent", ma = "eventsDiscarded", Ys = "eventsSendRequest", ct = "perfEvent", Cu = "getPerfMgr", Zl = "domain", bc = "path", iw = "Not dynamic - ", rw = "getPrototypeOf", tw = /-([a-z])/g, ow = /([^\w\d_$])/g, aw = /^(\d+[\w\d_$])/, sw = Object[rw];
function po(e) {
  return !z(e);
}
function Du(e) {
  var n = e;
  return n && he(n) && (n = n[Ro](tw, function(i, r) {
    return r.toUpperCase();
  }), n = n[Ro](ow, "_"), n = n[Ro](aw, function(i, r) {
    return "_" + r;
  })), n;
}
function mn(e, n) {
  return e && n ? Gn(e, n) !== -1 : !1;
}
function Fo(e) {
  return e && e.toISOString() || "";
}
function Ue(e) {
  return ju(e) ? e[yr] : Le;
}
function je(e, n, i, r, t) {
  var a = i;
  return e && (a = e[n], a !== i && (!t || t(a)) && (!r || r(i)) && (a = i, e[n] = a)), a;
}
function bn(e, n, i) {
  var r;
  return e ? (r = e[n], !r && z(r) && (r = qe(i) ? {} : i, e[n] = r)) : r = qe(i) ? {} : i, r;
}
function Gd(e, n) {
  var i = null, r = null;
  return _e(e) ? i = e : r = e, function() {
    var t = arguments;
    if (i && (r = i()), r)
      return r[n][_t](r, t);
  };
}
function uw(e, n, i) {
  if (e && n && Ln(e) && Ln(n)) {
    var r = function(a) {
      if (he(a)) {
        var o = n[a];
        _e(o) ? (!i || i(a, !0, n, e)) && (e[a] = Gd(n, a)) : (!i || i(a, !1, n, e)) && (Tr(e, a) && delete e[a], xe(e, a, {
          g: function() {
            return n[a];
          },
          s: function(s) {
            n[a] = s;
          }
        }));
      }
    };
    for (var t in n)
      r(t);
  }
  return e;
}
function pu(e, n, i, r, t) {
  e && n && i && (t !== !1 || qe(e[n])) && (e[n] = Gd(i, r));
}
function so(e, n, i, r) {
  return e && n && Ln(e) && Me(i) && se(i, function(t) {
    he(t) && pu(e, t, n, t, r);
  }), e;
}
function cw(e) {
  return function() {
    function n() {
      var i = this;
      e && Te(e, function(r, t) {
        i[r] = t;
      });
    }
    return n;
  }();
}
function Vd(e) {
  return e && Ll && (e = df(Ll({}, e))), e;
}
function Hd(e, n, i, r, t, a) {
  var o = arguments, s = o[0] || {}, u = o[Ae], c = !1, l = 1;
  for (u > 0 && id(s) && (c = s, s = o[l] || {}, l++), Ln(s) || (s = {}); l < u; l++) {
    var g = o[l], R = Me(g), v = Ln(g);
    for (var f in g) {
      var p = R && f in g || v && Tr(g, f);
      if (!!p) {
        var D = g[f], C = void 0;
        if (c && D && ((C = Me(D)) || Bn(D))) {
          var _ = s[f];
          C ? Me(_) || (_ = []) : Bn(_) || (_ = {}), D = Hd(c, _, D);
        }
        D !== void 0 && (s[f] = D);
      }
    }
  }
  return s;
}
function Mc(e, n) {
  var i = !1, r = n && n.featureOptIn && n.featureOptIn[e];
  if (e && r) {
    var t = r.mode;
    i = t == 3 || t == 1;
  }
  return i;
}
var lw = "documentMode", vw = "location", fw = "console", zd = "JSON", gw = "crypto", Rw = "msCrypto", dw = "ReactNative", ev = "msie", nv = "trident/", $d = "XMLHttpRequest", Pc = null, Ac = null, Cw = !1, kt = null, Fc = null;
function jd(e, n) {
  var i = !1;
  if (e) {
    try {
      if (i = n in e, !i) {
        var r = e[mi];
        r && (i = n in r);
      }
    } catch (a) {
    }
    if (!i)
      try {
        var t = new e();
        i = !qe(t[n]);
      } catch (a) {
      }
  }
  return i;
}
function $i(e) {
  if (e && Cw) {
    var n = yn("__mockLocation");
    if (n)
      return n;
  }
  return typeof location === Md && location ? location : yn(vw);
}
function Dw() {
  return typeof console !== Rf ? console : yn(fw);
}
function Za() {
  return Boolean(typeof JSON === Md && JSON || yn(zd) !== null);
}
function vi() {
  return Za() ? JSON || yn(zd) : null;
}
function pw() {
  return yn(gw);
}
function hw() {
  return yn(Rw);
}
function ww() {
  var e = Ai();
  return e && e.product ? e.product === dw : !1;
}
function iv() {
  var e = Ai();
  if (e && (e[$l] !== Ac || Pc === null)) {
    Ac = e[$l];
    var n = (Ac || Le)[su]();
    Pc = mn(n, ev) || mn(n, nv);
  }
  return Pc;
}
function Kd(e) {
  if (e === void 0 && (e = null), !e) {
    var n = Ai() || {};
    e = n ? (n.userAgent || Le)[su]() : Le;
  }
  var i = (e || Le)[su]();
  if (mn(i, ev)) {
    var r = Tn() || {};
    return Math.max(parseInt(i[xa](ev)[1]), r[lw] || 0);
  } else if (mn(i, nv)) {
    var t = parseInt(i[xa](nv)[1]);
    if (t)
      return t + 4;
  }
  return null;
}
function Rs(e) {
  return (Fc === null || e === !1) && (Fc = oh() && Boolean(Ai().sendBeacon)), Fc;
}
function rv(e) {
  var n = !1;
  try {
    n = !!yn("fetch");
    var i = yn("Request");
    n && e && i && (n = jd(i, "keepalive"));
  } catch (r) {
  }
  return n;
}
function _w() {
  return kt === null && (kt = typeof XDomainRequest !== Rf, kt && Ju() && (kt = kt && !jd(yn($d), "withCredentials"))), kt;
}
function Ju() {
  var e = !1;
  try {
    var n = yn($d);
    e = !!n;
  } catch (i) {
  }
  return e;
}
function Ew(e, n) {
  return e && e.dispatchEvent && n ? (e.dispatchEvent(n), !0) : !1;
}
function mw(e, n) {
  var i = null, r = { detail: n || null };
  if (_e(CustomEvent))
    i = new CustomEvent(e, r);
  else {
    var t = Tn();
    t && t.createEvent && (i = t.createEvent("CustomEvent"), i.initCustomEvent(e, !0, !0, r));
  }
  return i;
}
function Sw(e, n, i) {
  var r = ei();
  if (r && r.CustomEvent)
    try {
      var t = { cfg: n || null, customDetails: i || null };
      return Ew(r, mw(e, t));
    } catch (a) {
    }
  return !1;
}
var Wd = 4294967296, Nr = 4294967295, Xd = 123456789, qd = 987654321, Jd = !1, da = Xd, Ca = qd;
function Tw(e) {
  e < 0 && (e >>>= 0), da = Xd + e & Nr, Ca = qd - e & Nr, Jd = !0;
}
function yw() {
  try {
    var e = Ni() & 2147483647;
    Tw((Math.random() * Wd ^ e) + e);
  } catch (n) {
  }
}
function Nw(e) {
  return e > 0 ? Math.floor(Ba() / Nr * (e + 1)) >>> 0 : 0;
}
function Ba(e) {
  var n = 0, i = pw() || hw();
  return i && i.getRandomValues && (n = i.getRandomValues(new Uint32Array(1))[0] & Nr), n === 0 && iv() && (Jd || yw(), n = Iw() & Nr), n === 0 && (n = Math.floor(Wd * Math.random() | 0)), e || (n >>>= 0), n;
}
function Iw(e) {
  Ca = 36969 * (Ca & 65535) + (Ca >> 16) & Nr, da = 18e3 * (da & 65535) + (da >> 16) & Nr;
  var n = (Ca << 16) + (da & 65535) >>> 0 & Nr | 0;
  return e || (n >>>= 0), n;
}
function Df(e) {
  e === void 0 && (e = 22);
  for (var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = Ba() >>> 0, r = 0, t = Le; t[Ae] < e; )
    r++, t += n.charAt(i & 63), i >>>= 6, r === 5 && (i = (Ba() << 2 & 4294967295 | i & 3) >>> 0, r = 0);
  return t;
}
var Qd = "3.0.6", bw = "." + Df(6), Mw = 0;
function Zd(e) {
  return e[_c] === 1 || e[_c] === 9 || !+e[_c];
}
function Pw(e, n) {
  var i = n[e.id];
  if (!i) {
    i = {};
    try {
      Zd(n) && xe(n, e.id, {
        e: !1,
        v: i
      });
    } catch (r) {
    }
  }
  return i;
}
function ii(e, n) {
  return n === void 0 && (n = !1), Du(e + Mw++ + (n ? "." + Qd : Le) + bw);
}
function eC(e) {
  var n = {
    id: ii("_aiData-" + (e || Le) + "." + Qd),
    accept: function(i) {
      return Zd(i);
    },
    get: function(i, r, t, a) {
      var o = i[n.id];
      return o ? o[Du(r)] : (a && (o = Pw(n, i), o[Du(r)] = t), t);
    },
    kill: function(i, r) {
      if (i && i[r])
        try {
          delete i[r];
        } catch (t) {
        }
    }
  };
  return n;
}
function xs(e) {
  return e && Ln(e) && (e.isVal || e.fb || Tr(e, "v") || Tr(e, "mrg") || Tr(e, "ref") || e.set);
}
function nC(e, n, i) {
  var r, t = i.dfVal || nd;
  if (n && i.fb) {
    var a = i.fb;
    Me(a) || (a = [a]);
    for (var o = 0; o < a[Ae]; o++) {
      var s = a[o], u = n[s];
      if (t(u) ? r = u : e && (u = e.cfg[s], t(u) && (r = u), e.set(e.cfg, Pi(s), u)), t(r))
        break;
    }
  }
  return !t(r) && t(i.v) && (r = i.v), r;
}
function tv(e, n, i) {
  var r = i;
  if (i && xs(i) && (r = nC(e, n, i)), r) {
    xs(r) && (r = tv(e, n, r));
    var t;
    Me(r) ? (t = [], t[Ae] = r[Ae]) : Bn(r) && (t = {}), t && (Te(r, function(a, o) {
      o && xs(o) && (o = tv(e, n, o)), t[a] = o;
    }), r = t);
  }
  return r;
}
function pf(e, n, i, r) {
  var t, a, o, s = r, u, c, l, g;
  xs(s) ? (t = s.isVal, a = s.set, l = s[cu], g = s[uu], u = s.mrg, c = s.ref, !c && qe(c) && (c = !!u), o = nC(e, n, s)) : o = r, g && e[uu](n, i);
  var R, v = !0, f = n[i];
  (f || !z(f)) && (R = f, v = !1, t && R !== o && !t(R) && (R = o, v = !0), a && (R = a(R, o, n), v = R === o)), v ? o ? R = tv(e, n, o) : R = o : (Bn(R) || Me(o)) && u && o && (Bn(o) || Me(o)) && Te(o, function(p, D) {
    pf(e, R, p, D);
  }), e.set(n, i, R), c && e.ref(n, i), l && e[cu](n, i);
}
var kr = sf("[[ai_dynCfg_1]]"), iC = sf("[[ai_blkDynCfg_1]]"), Aw = sf("[[ai_frcDynCfg_1]]");
function rC(e) {
  if (e) {
    var n;
    if (Me(e) ? (n = [], n[Ae] = e[Ae]) : Bn(e) && (n = {}), n)
      return Te(e, function(i, r) {
        n[i] = rC(r);
      }), n;
  }
  return e;
}
function Fw(e) {
  if (e) {
    var n = e[kr] || e;
    if (n.cfg && (n.cfg === e || n.cfg[kr] === n))
      return n;
  }
  return null;
}
function Lw(e) {
  if (e && (Bn(e) || Me(e)))
    try {
      e[iC] = !0;
    } catch (n) {
    }
  return e;
}
function Lc(e, n, i) {
  var r = !1;
  return i && !e[n.blkVal] && (r = i[Aw], !r && !i[iC] && (r = Bn(i) || Me(i))), r;
}
function tC(e) {
  Mi("InvalidAccess:" + e);
}
var Ow = [
  "push",
  "pop",
  "shift",
  "unshift",
  "splice"
], Ga = function(e, n, i, r) {
  e && e[Qa](3, 108, "".concat(i, " [").concat(n, "] failed - ") + ae(r));
};
function kw(e, n, i) {
  Me(n) && se(Ow, function(r) {
    var t = n[r];
    n[r] = function() {
      for (var a = [], o = 0; o < arguments.length; o++)
        a[o] = arguments[o];
      var s = t[_t](this, a);
      return wu(e, n, i, "Patching"), s;
    };
  });
}
function hu(e, n) {
  var i = rf(e, n);
  return i && i.get;
}
function Uw(e, n, i, r) {
  var t = {
    n: i,
    h: [],
    trk: function(c) {
      c && c.fn && (Nn(t.h, c) === -1 && t.h[Be](c), e.trk(c, t));
    },
    clr: function(c) {
      var l = Nn(t.h, c);
      l !== -1 && t.h[Bo](l, 1);
    }
  }, a = !0, o = !1;
  function s() {
    a && (o = o || Lc(s, e, r), r && !r[kr] && o && (r = wu(e, r, i, "Converting")), a = !1);
    var c = e.act;
    return c && t.trk(c), r;
  }
  s[e.prop] = {
    chng: function() {
      e.add(t);
    }
  };
  function u(c) {
    if (r !== c) {
      !!s[e.ro] && !e.upd && tC("[" + i + "] is read-only:" + ae(n)), a && (o = o || Lc(s, e, r), a = !1);
      var l = o && s[e.rf];
      if (o)
        if (l) {
          Te(r, function(R) {
            r[R] = c ? c[R] : _i;
          });
          try {
            Te(c, function(R, v) {
              Qu(e, r, R, v);
            }), c = r;
          } catch (R) {
            Ga((e.hdlr || {})[an], i, "Assigning", R), o = !1;
          }
        } else
          r && r[kr] && Te(r, function(R) {
            var v = hu(r, R);
            if (v) {
              var f = v[e.prop];
              f && f.chng();
            }
          });
      if (c !== r) {
        var g = c && Lc(s, e, c);
        !l && g && (c = wu(e, c, i, "Converting")), r = c, o = g;
      }
      e.add(t);
    }
  }
  xe(n, t.n, { g: s, s: u });
}
function Qu(e, n, i, r) {
  if (n) {
    var t = hu(n, i), a = t && !!t[e.prop];
    a ? n[i] = r : Uw(e, n, i, r);
  }
  return n;
}
function Oc(e, n, i, r) {
  if (n) {
    var t = hu(n, i), a = t && !!t[e.prop], o = r && r[0], s = r && r[1], u = r && r[2];
    if (!a) {
      if (u)
        try {
          Lw(n);
        } catch (c) {
          Ga((e.hdlr || {})[an], i, "Blocking", c);
        }
      try {
        Qu(e, n, i, n[i]), t = hu(n, i);
      } catch (c) {
        Ga((e.hdlr || {})[an], i, "State", c);
      }
    }
    o && (t[e.rf] = o), s && (t[e.ro] = s), u && (t[e.blkVal] = !0);
  }
  return n;
}
function wu(e, n, i, r) {
  try {
    Te(n, function(t, a) {
      Qu(e, n, t, a);
    }), n[kr] || (ci(n, kr, {
      get: function() {
        return e[Fd];
      }
    }), kw(e, n, i));
  } catch (t) {
    Ga((e.hdlr || {})[an], i, r, t);
  }
  return n;
}
var jo = "[[ai_", Ko = "]]";
function Yw(e) {
  var n, i = zo(jo + "get" + e.uid + Ko), r = zo(jo + "ro" + e.uid + Ko), t = zo(jo + "rf" + e.uid + Ko), a = zo(jo + "blkVal" + e.uid + Ko), o = zo(jo + "dtl" + e.uid + Ko), s = null, u = null, c;
  function l(f, p) {
    var D = c.act;
    try {
      c.act = f, f && f[o] && (se(f[o], function(_) {
        _.clr(f);
      }), f[o] = []), p({
        cfg: e.cfg,
        set: e.set.bind(e),
        setDf: e[xo].bind(e),
        ref: e.ref.bind(e),
        rdOnly: e[cu].bind(e)
      });
    } catch (_) {
      var C = e[an];
      throw C && C[Qa](1, 107, ae(_)), _;
    } finally {
      c.act = D || null;
    }
  }
  function g() {
    if (s) {
      var f = s;
      s = null, u && u[Ra](), u = null;
      var p = [];
      if (se(f, function(D) {
        if (D && (D[o] && (se(D[o], function(C) {
          C.clr(D);
        }), D[o] = null), D.fn))
          try {
            l(D, D.fn);
          } catch (C) {
            p[Be](C);
          }
      }), s)
        try {
          g();
        } catch (D) {
          p[Be](D);
        }
      p[Ae] > 0 && Vh("Watcher error(s): ", p);
    }
  }
  function R(f) {
    if (f && f.h[Ae] > 0) {
      s || (s = []), u || (u = Di(function() {
        u = null, g();
      }, 0));
      for (var p = 0; p < f.h[Ae]; p++) {
        var D = f.h[p];
        D && Nn(s, D) === -1 && s[Be](D);
      }
    }
  }
  function v(f, p) {
    if (f) {
      var D = f[o] = f[o] || [];
      Nn(D, p) === -1 && D[Be](p);
    }
  }
  return c = (n = {
    prop: i,
    ro: r,
    rf: t
  }, n[uu] = a, n[Fd] = e, n.add = R, n[lu] = g, n.use = l, n.trk = v, n), c;
}
function xw(e, n) {
  var i = {
    fn: n,
    rm: function() {
      i.fn = null, e = null, n = null;
    }
  };
  return e.use(i, n), i;
}
function Bw(e, n, i) {
  var r, t = Fw(n);
  if (t)
    return t;
  var a = ii("dyncfg", !0), o = n && i !== !1 ? n : rC(n), s;
  function u() {
    s[lu]();
  }
  function c(C, _, E) {
    try {
      C = Qu(s, C, _, E);
    } catch (N) {
      Ga(e, _, "Setting value", N);
    }
    return C[_];
  }
  function l(C) {
    return xw(s, C);
  }
  function g(C, _) {
    s.use(null, function(E) {
      var N = s.upd;
      try {
        qe(_) || (s.upd = _), C(E);
      } finally {
        s.upd = N;
      }
    });
  }
  function R(C, _) {
    var E;
    return Oc(s, C, _, (E = {}, E[0] = !0, E))[_];
  }
  function v(C, _) {
    var E;
    return Oc(s, C, _, (E = {}, E[1] = !0, E))[_];
  }
  function f(C, _) {
    var E;
    return Oc(s, C, _, (E = {}, E[2] = !0, E))[_];
  }
  function p(C, _) {
    return _ && Te(_, function(E, N) {
      pf(D, C, E, N);
    }), C;
  }
  var D = (r = {
    uid: null,
    cfg: o
  }, r[an] = e, r[lu] = u, r.set = c, r[xo] = p, r[zi] = l, r.ref = R, r[cu] = v, r[uu] = f, r._block = g, r);
  return xe(D, "uid", {
    c: !1,
    e: !1,
    w: !1,
    v: a
  }), s = Yw(D), wu(s, o, "config", "Creating"), D;
}
function Gw(e, n) {
  e ? (e[vu](n), e[Qa](2, 108, n)) : tC(n);
}
function ri(e, n, i, r) {
  var t = Bw(i, e || {}, r);
  return n && t[xo](t.cfg, n), t;
}
function tn(e, n, i) {
  var r = e[kr] || e;
  return r.cfg && (r.cfg === e || r.cfg[kr] === r) ? r[zi](n) : (Gw(i, iw + ae(e)), ri(e, null, i)[zi](n));
}
function uo(e, n) {
  if (e && e[Lr])
    return e[Lr](n);
}
function oC(e, n, i) {
  var r;
  return i || (r = Or(function(t) {
    i = t;
  })), e && Nh(e) > 0 ? Ao(uo(e[0], n), function() {
    oC(rr(e, 1), n, i);
  }) : i(), r;
}
var Vw = 500;
function Hw(e, n, i) {
  return !e && z(e) ? n : id(e) ? e : Pi(e)[su]() === "true";
}
function dr(e) {
  return {
    mrg: !0,
    v: e
  };
}
function hg(e, n) {
  return {
    set: e,
    v: n
  };
}
function _u(e, n, i) {
  return {
    fb: i,
    isVal: e,
    v: n
  };
}
function vn(e, n) {
  return {
    fb: n,
    set: Hw,
    v: !!e
  };
}
function zw(e) {
  return {
    isVal: he,
    v: Pi(e || Le)
  };
}
var kc = [Us, ma, Ys, ct], Eu = null, ds;
function $w(e, n) {
  return function() {
    var i = arguments, r = aC(n);
    if (r) {
      var t = r.listener;
      t && t[e] && t[e][_t](t, i);
    }
  };
}
function jw() {
  var e = yn("Microsoft");
  return e && (Eu = e.ApplicationInsights), Eu;
}
function aC(e) {
  var n = Eu;
  return !n && e.disableDbgExt !== !0 && (n = Eu || jw()), n ? n.ChromeDbgExt : null;
}
function Kw(e) {
  if (!ds) {
    ds = {};
    for (var n = 0; n < kc[Ae]; n++)
      ds[kc[n]] = $w(kc[n], e);
  }
  return ds;
}
var Ut, sC = "warnToConsole", Ww = "AI (Internal): ", Xw = "AI: ", qw = "AITR_", Jw = {
  loggingLevelConsole: 0,
  loggingLevelTelemetry: 1,
  maxMessageLimit: 25,
  enableDebug: !1
}, Qw = (Ut = {}, Ut[0] = null, Ut[1] = "errorToConsole", Ut[2] = sC, Ut[3] = "debugToConsole", Ut);
function wg(e) {
  return e ? '"' + e[Ro](/\"/g, Le) + '"' : Le;
}
function Uc(e, n) {
  var i = Dw();
  if (i) {
    var r = "log";
    i[e] && (r = e), _e(i[r]) && i[r](n);
  }
}
var Va = function() {
  function e(n, i, r, t) {
    r === void 0 && (r = !1);
    var a = this;
    a[gu] = n, a[go] = (r ? Xw : Ww) + n;
    var o = Le;
    Za() && (o = vi().stringify(t));
    var s = (i ? " message:" + wg(i) : Le) + (t ? " props:" + wg(o) : Le);
    a[go] += s;
  }
  return e.dataType = "MessageData", e;
}();
function St(e, n) {
  return (e || {})[an] || new mu(n);
}
var mu = function() {
  function e(n) {
    this.identifier = "DiagnosticLogger", this.queue = [];
    var i = 0, r = {}, t, a, o, s, u;
    We(e, this, function(c) {
      u = g(n || {}), c.consoleLoggingLevel = function() {
        return t;
      }, c[Qa] = function(f, p, D, C, _) {
        _ === void 0 && (_ = !1);
        var E = new Va(p, D, _, C);
        if (s)
          throw ae(E);
        var N = Qw[f] || sC;
        if (qe(E[go]))
          v("throw" + (f === 1 ? "Critical" : "Warning"), E);
        else {
          if (_) {
            var O = +E[gu];
            !r[O] && t >= f && (c[N](E[go]), r[O] = !0);
          } else
            t >= f && c[N](E[go]);
          l(f, E);
        }
      }, c.debugToConsole = function(f) {
        Uc("debug", f), v("warning", f);
      }, c[vu] = function(f) {
        Uc("warn", f), v("warning", f);
      }, c.errorToConsole = function(f) {
        Uc("error", f), v("error", f);
      }, c.resetInternalMessageCount = function() {
        i = 0, r = {};
      }, c[kd] = l, c[Lr] = function(f) {
        u && u.rm(), u = null;
      };
      function l(f, p) {
        if (!R()) {
          var D = !0, C = qw + p[gu];
          if (r[C] ? D = !1 : r[C] = !0, D && (f <= a && (c.queue[Be](p), i++, v(f === 1 ? "error" : "warn", p)), i === o)) {
            var _ = "Internal events throttle limit per PageView reached for this app.", E = new Va(23, _, !1);
            c.queue[Be](E), f === 1 ? c.errorToConsole(_) : c[vu](_);
          }
        }
      }
      function g(f) {
        return tn(ri(f, Jw, c).cfg, function(p) {
          var D = p.cfg;
          t = D[Od], a = D.loggingLevelTelemetry, o = D.maxMessageLimit, s = D.enableDebug;
        });
      }
      function R() {
        return i >= o;
      }
      function v(f, p) {
        var D = aC(n || {});
        D && D[Wi] && D[Wi](f, p);
      }
    });
  }
  return e.__ieDyn = 1, e;
}();
function hf(e) {
  return e || new mu();
}
function Q(e, n, i, r, t, a) {
  a === void 0 && (a = !1), hf(e)[Qa](n, i, r, t, a);
}
function ho(e, n) {
  hf(e)[vu](n);
}
function Zw(e, n, i) {
  hf(e)[kd](n, i);
}
var Yc, zr, _g = "toGMTString", Eg = "toUTCString", wf = "cookie", xc = "expires", mg = "isCookieUseDisabled", ov = "disableCookiesUsage", wr = "_ckMgr", Cs = null, Bc = null, Sg = null, Ti, Tg = {}, Su = {}, e_ = (Yc = {
  cookieCfg: dr((zr = {}, zr[Zl] = { fb: "cookieDomain", dfVal: po }, zr.path = { fb: "cookiePath", dfVal: po }, zr.enabled = _i, zr.ignoreCookies = _i, zr.blockedCookies = _i, zr)),
  cookieDomain: _i,
  cookiePath: _i
}, Yc[ov] = _i, Yc);
function _f() {
  !Ti && (Ti = Ja(function() {
    return Tn();
  }));
}
function n_(e, n) {
  var i = Sa[wr] || Su[wr];
  return i || (i = Sa[wr] = Sa(e, n), Su[wr] = i), i;
}
function Ds(e) {
  return e ? e.isEnabled() : !0;
}
function uC(e, n) {
  return n && e && Me(e.ignoreCookies) ? Nn(e.ignoreCookies, n) !== -1 : !1;
}
function i_(e, n) {
  return n && e && Me(e.blockedCookies) && Nn(e.blockedCookies, n) !== -1 ? !0 : uC(e, n);
}
function yg(e, n) {
  var i = n[ao];
  if (z(i)) {
    var r = void 0;
    qe(e[mg]) || (r = !e[mg]), qe(e[ov]) || (r = !e[ov]), i = r;
  }
  return i;
}
function Zu(e, n) {
  var i;
  if (e)
    i = e.getCookieMgr();
  else if (n) {
    var r = n.cookieCfg;
    r && r[wr] ? i = r[wr] : i = Sa(n);
  }
  return i || (i = n_(n, (e || {})[an])), i;
}
function Sa(e, n) {
  var i, r, t, a, o, s, u, c, l;
  e = ri(e || Su, null, n).cfg, o = tn(e, function(R) {
    R[xo](R.cfg, e_), r = R.ref(R.cfg, "cookieCfg"), t = r[bc] || "/", a = r[Zl], s = yg(e, r) !== !1, u = r.getCookie || r_, c = r.setCookie || Mg, l = r.delCookie || Mg;
  }, n);
  var g = (i = {
    isEnabled: function() {
      var R = yg(e, r) !== !1 && s && Ng(n), v = Su[wr];
      return R && v && g !== v && (R = Ds(v)), R;
    },
    setEnabled: function(R) {
      s = R !== !1, r[ao] = R;
    },
    set: function(R, v, f, p, D) {
      var C = !1;
      if (Ds(g) && !i_(r, R)) {
        var _ = {}, E = An(v || Le), N = Gn(E, ";");
        if (N !== -1 && (E = An(of(v, N)), _ = cC(Ci(v, N + 1))), je(_, Zl, p || a, eu, qe), !z(f)) {
          var O = iv();
          if (qe(_[xc])) {
            var d = Ni(), m = d + f * 1e3;
            if (m > 0) {
              var y = new Date();
              y.setTime(m), je(_, xc, Ig(y, O ? _g : Eg) || Ig(y, O ? _g : Eg) || Le, eu);
            }
          }
          O || je(_, "max-age", Le + f, null, qe);
        }
        var Y = $i();
        Y && Y.protocol === "https:" && (je(_, "secure", null, null, qe), Bc === null && (Bc = !t_((Ai() || {})[$l])), Bc && je(_, "SameSite", "None", null, qe)), je(_, bc, D || t, null, qe), c(R, bg(E, _)), C = !0;
      }
      return C;
    },
    get: function(R) {
      var v = Le;
      return Ds(g) && !uC(r, R) && (v = u(R)), v;
    },
    del: function(R, v) {
      var f = !1;
      return Ds(g) && (f = g.purge(R, v)), f;
    },
    purge: function(R, v) {
      var f, p = !1;
      if (Ng(n)) {
        var D = (f = {}, f[bc] = v || "/", f[xc] = "Thu, 01 Jan 1970 00:00:01 GMT", f);
        iv() || (D["max-age"] = "0"), l(R, bg(Le, D)), p = !0;
      }
      return p;
    }
  }, i[Lr] = function(R) {
    o && o.rm(), o = null;
  }, i);
  return g[wr] = g, g;
}
function Ng(e) {
  if (Cs === null) {
    Cs = !1, !Ti && _f();
    try {
      var n = Ti.v || {};
      Cs = n[wf] !== void 0;
    } catch (i) {
      Q(e, 2, 68, "Cannot access document.cookie - " + Ue(i), { exception: ae(i) });
    }
  }
  return Cs;
}
function cC(e) {
  var n = {};
  if (e && e[Ae]) {
    var i = An(e)[xa](";");
    se(i, function(r) {
      if (r = An(r || Le), r) {
        var t = Gn(r, "=");
        t === -1 ? n[r] = null : n[An(of(r, t))] = An(Ci(r, t + 1));
      }
    });
  }
  return n;
}
function Ig(e, n) {
  return _e(e[n]) ? e[n]() : null;
}
function bg(e, n) {
  var i = e || Le;
  return Te(n, function(r, t) {
    i += "; " + r + (z(t) ? Le : "=" + t);
  }), i;
}
function r_(e) {
  var n = Le;
  if (!Ti && _f(), Ti.v) {
    var i = Ti.v[wf] || Le;
    Sg !== i && (Tg = cC(i), Sg = i), n = An(Tg[e] || Le);
  }
  return n;
}
function Mg(e, n) {
  !Ti && _f(), Ti.v && (Ti.v[wf] = e + "=" + n);
}
function t_(e) {
  return he(e) ? !!(mn(e, "CPU iPhone OS 12") || mn(e, "iPad; CPU OS 12") || mn(e, "Macintosh; Intel Mac OS X 10_14") && mn(e, "Version/") && mn(e, "Safari") || mn(e, "Macintosh; Intel Mac OS X 10_14") && Sd(e, "AppleWebKit/605.1.15 (KHTML, like Gecko)") || mn(e, "Chrome/5") || mn(e, "Chrome/6") || mn(e, "UnrealEngine") && !mn(e, "Chrome") || mn(e, "UCBrowser/12") || mn(e, "UCBrowser/11")) : !1;
}
var o_ = {
  perfEvtsSendAll: !1
};
function Wo(e, n, i, r) {
  se(e, function(t) {
    if (t && t[n])
      if (i)
        Di(function() {
          return r(t);
        }, 0);
      else
        try {
          r(t);
        } catch (a) {
        }
  });
}
var a_ = function() {
  function e(n) {
    this.listeners = [];
    var i, r, t = [], a = ri(n, o_);
    r = a[zi](function(o) {
      i = !!o.cfg.perfEvtsSendAll;
    }), We(e, this, function(o) {
      xe(o, "listeners", {
        g: function() {
          return t;
        }
      }), o[Os] = function(s) {
        t[Be](s);
      }, o[ks] = function(s) {
        for (var u = Nn(t, s); u > -1; )
          t[Bo](u, 1), u = Nn(t, s);
      }, o[Us] = function(s) {
        Wo(t, Us, !0, function(u) {
          u[Us](s);
        });
      }, o[ma] = function(s, u) {
        Wo(t, ma, !0, function(c) {
          c[ma](s, u);
        });
      }, o[Ys] = function(s, u) {
        Wo(t, Ys, u, function(c) {
          c[Ys](s, u);
        });
      }, o[ct] = function(s) {
        s && (i || !s[jl]()) && Wo(t, ct, !1, function(u) {
          s[Po] ? Di(function() {
            return u[ct](s);
          }, 0) : u[ct](s);
        });
      }, o[Lr] = function(s) {
        var u = function() {
          r && r.rm(), r = null, t = [];
        }, c;
        if (Wo(t, "unload", !1, function(l) {
          var g = l[Lr](s);
          g && (c || (c = []), c[Be](g));
        }), c)
          return Or(function(l) {
            return Ao(nw(c), function() {
              u(), l();
            });
          });
        u();
      };
    });
  }
  return e.__ieDyn = 1, e;
}(), wo = "ctx", av = "ParentContextKey", Ta = "ChildrenContextKey", s_ = null, Bs = function() {
  function e(n, i, r) {
    var t = this;
    if (t.start = Ni(), t[yr] = n, t[Po] = r, t[jl] = function() {
      return !1;
    }, _e(i)) {
      var a;
      xe(t, "payload", {
        g: function() {
          return !a && _e(i) && (a = i(), i = null), a;
        }
      });
    }
    t[Co] = function(o) {
      return o ? o === e[av] || o === e[Ta] ? t[o] : (t[wo] || {})[o] : null;
    }, t[hi] = function(o, s) {
      if (o)
        if (o === e[av])
          t[o] || (t[jl] = function() {
            return !0;
          }), t[o] = s;
        else if (o === e[Ta])
          t[o] = s;
        else {
          var u = t[wo] = t[wo] || {};
          u[o] = s;
        }
    }, t[Kl] = function() {
      var o = 0, s = t[Co](e[Ta]);
      if (Me(s))
        for (var u = 0; u < s[Ae]; u++) {
          var c = s[u];
          c && (o += c[fo]);
        }
      t[fo] = Ni() - t.start, t.exTime = t[fo] - o, t[Kl] = function() {
      };
    };
  }
  return e.ParentContextKey = "parent", e.ChildrenContextKey = "childEvts", e;
}(), u_ = function() {
  function e(n) {
    this.ctx = {}, We(e, this, function(i) {
      i.create = function(r, t, a) {
        return new Bs(r, t, a);
      }, i.fire = function(r) {
        r && (r[Kl](), n && _e(n[ct]) && n[ct](r));
      }, i[hi] = function(r, t) {
        if (r) {
          var a = i[wo] = i[wo] || {};
          a[r] = t;
        }
      }, i[Co] = function(r) {
        return (i[wo] || {})[r];
      };
    });
  }
  return e.__ieDyn = 1, e;
}(), Gc = "CoreUtils.doPerf";
function Tu(e, n, i, r, t) {
  if (e) {
    var a = e;
    if (a[Cu] && (a = a[Cu]()), a) {
      var o = void 0, s = a[Co](Gc);
      try {
        if (o = a.create(n(), r, t), o) {
          if (s && o[hi] && (o[hi](Bs[av], s), s[Co] && s[hi])) {
            var u = s[Co](Bs[Ta]);
            u || (u = [], s[hi](Bs[Ta], u)), u[Be](o);
          }
          return a[hi](Gc, o), i(o);
        }
      } catch (c) {
        o && o[hi] && o[hi]("exception", c);
      } finally {
        o && a.fire(o), a[hi](Gc, s);
      }
    }
  }
  return i();
}
function c_() {
  return s_;
}
function _r() {
  for (var e = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"], n = Le, i, r = 0; r < 4; r++)
    i = Ba(), n += e[i & 15] + e[i >> 4 & 15] + e[i >> 8 & 15] + e[i >> 12 & 15] + e[i >> 16 & 15] + e[i >> 20 & 15] + e[i >> 24 & 15] + e[i >> 28 & 15];
  var t = e[8 + (Ba() & 3) | 0];
  return gr(n, 0, 8) + gr(n, 9, 4) + "4" + gr(n, 13, 3) + t + gr(n, 16, 3) + gr(n, 19, 12);
}
var sv = "00", l_ = "ff", lC = "00000000000000000000000000000000", vC = "0000000000000000";
function es(e, n, i) {
  return e && e[Ae] === n && e !== i ? !!e.match(/^[\da-f]*$/i) : !1;
}
function Pg(e, n, i) {
  return es(e, n) ? e : i;
}
function v_(e) {
  (isNaN(e) || e < 0 || e > 255) && (e = 1);
  for (var n = e.toString(16); n[Ae] < 2; )
    n = "0" + n;
  return n;
}
function Ag(e, n, i, r) {
  var t;
  return t = {}, t[fu] = es(r, 2, l_) ? r : sv, t[Wl] = Ef(e) ? e : _r(), t[Xl] = mf(n) ? n : of(_r(), 16), t.traceFlags = i >= 0 && i <= 255 ? i : 1, t;
}
function Ef(e) {
  return es(e, 32, lC);
}
function mf(e) {
  return es(e, 16, vC);
}
function Fg(e) {
  if (e) {
    var n = v_(e[ql]);
    es(n, 2) || (n = "01");
    var i = e[fu] || sv;
    return i !== "00" && i !== "ff" && (i = sv), "".concat(i.toLowerCase(), "-").concat(Pg(e.traceId, 32, lC).toLowerCase(), "-").concat(Pg(e.spanId, 16, vC).toLowerCase(), "-").concat(n.toLowerCase());
  }
  return "";
}
var f_ = eC("plugin");
function Rt(e) {
  return f_.get(e, "state", {}, !0);
}
function Lg(e, n) {
  for (var i = [], r = null, t = e[Si](), a; t; ) {
    var o = t[ka]();
    if (o) {
      r && r[Ya] && o[Ii] && r[Ya](o), a = Rt(o);
      var s = !!a[Ei];
      o[Ei] && (s = o[Ei]()), s || i[Be](o), r = o, t = t[Si]();
    }
  }
  se(i, function(u) {
    var c = e[Rn]();
    u[qu](e.getCfg(), c, n, e[Si]()), a = Rt(u), !u[Rn] && !a[Rn] && (a[Rn] = c), a[Ei] = !0, delete a[Vi];
  });
}
function Vc(e) {
  return e.sort(function(n, i) {
    var r = 0;
    if (i) {
      var t = i[Ii];
      n[Ii] ? r = t ? n[du] - i[du] : 1 : t && (r = -1);
    } else
      r = n ? 1 : -1;
    return r;
  });
}
function g_(e) {
  var n = {};
  return {
    getName: function() {
      return n[yr];
    },
    setName: function(i) {
      e && e.setName(i), n[yr] = i;
    },
    getTraceId: function() {
      return n[Wl];
    },
    setTraceId: function(i) {
      e && e.setTraceId(i), Ef(i) && (n[Wl] = i);
    },
    getSpanId: function() {
      return n[Xl];
    },
    setSpanId: function(i) {
      e && e.setSpanId(i), mf(i) && (n[Xl] = i);
    },
    getTraceFlags: function() {
      return n[ql];
    },
    setTraceFlags: function(i) {
      e && e.setTraceFlags(i), n[ql] = i;
    }
  };
}
var R_ = "TelemetryPluginChain", Og = "_hasRun", kg = "_getTelCtx", Ug = 0;
function d_(e, n, i) {
  for (; e; ) {
    if (e[ka]() === i)
      return e;
    e = e[Si]();
  }
  return mt([i], n.config || {}, n);
}
function Sf(e, n, i, r) {
  var t = null, a = [];
  n || (n = ri({}, null, i[an])), r !== null && (t = r ? d_(e, i, r) : e);
  var o = {
    _next: u,
    ctx: {
      core: function() {
        return i;
      },
      diagLog: function() {
        return St(i, n.cfg);
      },
      getCfg: function() {
        return n.cfg;
      },
      getExtCfg: l,
      getConfig: g,
      hasNext: function() {
        return !!t;
      },
      getNext: function() {
        return t;
      },
      setNext: function(v) {
        t = v;
      },
      iterate: R,
      onComplete: s
    }
  };
  function s(v, f) {
    for (var p = [], D = 2; D < arguments.length; D++)
      p[D - 2] = arguments[D];
    v && a[Be]({
      func: v,
      self: qe(f) ? o.ctx : f,
      args: p
    });
  }
  function u() {
    var v = t;
    if (t = v ? v[Si]() : null, !v) {
      var f = a;
      f && f[Ae] > 0 && (se(f, function(p) {
        try {
          p.func.call(p.self, p.args);
        } catch (D) {
          Q(i[an], 2, 73, "Unexpected Exception during onComplete - " + ae(D));
        }
      }), a = []);
    }
    return v;
  }
  function c(v, f) {
    var p = null, D = n.cfg;
    if (D && v) {
      var C = D[Do];
      !C && f && (C = {}), D[Do] = C, C = n.ref(D, Do), C && (p = C[v], !p && f && (p = {}), C[v] = p, p = n.ref(C, v));
    }
    return p;
  }
  function l(v, f) {
    var p = c(v, !0);
    return f && Te(f, function(D, C) {
      if (z(p[D])) {
        var _ = n.cfg[D];
        (_ || !z(_)) && (p[D] = _);
      }
      pf(n, p, D, C);
    }), n[xo](p, f);
  }
  function g(v, f, p) {
    p === void 0 && (p = !1);
    var D, C = c(v, !1), _ = n.cfg;
    return C && (C[f] || !z(C[f])) ? D = C[f] : (_[f] || !z(_[f])) && (D = _[f]), D || !z(D) ? D : p;
  }
  function R(v) {
    for (var f; f = o._next(); ) {
      var p = f[ka]();
      p && v(p);
    }
  }
  return o;
}
function fi(e, n, i, r) {
  var t = ri(n), a = Sf(e, t, i, r), o = a.ctx;
  function s(c) {
    var l = a._next();
    return l && l[Ii](c, o), !l;
  }
  function u(c, l) {
    return c === void 0 && (c = null), Me(c) && (c = mt(c, t.cfg, i, l)), fi(c || o[Si](), t.cfg, i, l);
  }
  return o[Mn] = s, o[Et] = u, o;
}
function yu(e, n, i) {
  var r = ri(n.config), t = Sf(e, r, n, i), a = t.ctx;
  function o(u) {
    var c = t._next();
    return c && c[Lr](a, u), !c;
  }
  function s(u, c) {
    return u === void 0 && (u = null), Me(u) && (u = mt(u, r.cfg, n, c)), yu(u || a[Si](), n, c);
  }
  return a[Mn] = o, a[Et] = s, a;
}
function Tf(e, n, i) {
  var r = ri(n.config), t = Sf(e, r, n, i), a = t.ctx;
  function o(u) {
    return a.iterate(function(c) {
      _e(c[Ua]) && c[Ua](a, u);
    });
  }
  function s(u, c) {
    return u === void 0 && (u = null), Me(u) && (u = mt(u, r.cfg, n, c)), Tf(u || a[Si](), n, c);
  }
  return a[Mn] = o, a[Et] = s, a;
}
function mt(e, n, i, r) {
  var t = null, a = !r;
  if (Me(e) && e[Ae] > 0) {
    var o = null;
    se(e, function(s) {
      if (!a && r === s && (a = !0), a && s && _e(s[Ii])) {
        var u = C_(s, n, i);
        t || (t = u), o && o._setNext(u), o = u;
      }
    });
  }
  return r && !t ? mt([r], n, i) : t;
}
function C_(e, n, i) {
  var r = null, t = _e(e[Ii]), a = _e(e[Ya]), o;
  e ? o = e[Rr] + "-" + e[du] + "-" + Ug++ : o = "Unknown-0-" + Ug++;
  var s = {
    getPlugin: function() {
      return e;
    },
    getNext: function() {
      return r;
    },
    processTelemetry: l,
    unload: g,
    update: R,
    _id: o,
    _setNext: function(v) {
      r = v;
    }
  };
  function u() {
    var v;
    return e && _e(e[kg]) && (v = e[kg]()), v || (v = fi(s, n, i)), v;
  }
  function c(v, f, p, D, C) {
    var _ = !1, E = e ? e[Rr] : R_, N = v[Og];
    return N || (N = v[Og] = {}), v.setNext(r), e && Tu(v[Rn](), function() {
      return E + ":" + p;
    }, function() {
      N[o] = !0;
      try {
        var O = r ? r._id : Le;
        O && (N[O] = !1), _ = f(v);
      } catch (m) {
        var d = r ? N[r._id] : !0;
        d && (_ = !0), (!r || !d) && Q(v[Wi](), 1, 73, "Plugin [" + E + "] failed during " + p + " - " + ae(m) + ", run flags: " + ae(N));
      }
    }, D, C), _;
  }
  function l(v, f) {
    f = f || u();
    function p(D) {
      if (!e || !t)
        return !1;
      var C = Rt(e);
      return C[Vi] || C[Ql] ? !1 : (a && e[Ya](r), e[Ii](v, D), !0);
    }
    c(f, p, "processTelemetry", function() {
      return { item: v };
    }, !v.sync) || f[Mn](v);
  }
  function g(v, f) {
    function p() {
      var D = !1;
      if (e) {
        var C = Rt(e), _ = e[Rn] || C[Rn];
        e && (!_ || _ === v.core()) && !C[Vi] && (C[Rn] = null, C[Vi] = !0, C[Ei] = !1, e[Vi] && e[Vi](v, f) === !0 && (D = !0));
      }
      return D;
    }
    c(v, p, "unload", function() {
    }, f[Po]) || v[Mn](f);
  }
  function R(v, f) {
    function p() {
      var D = !1;
      if (e) {
        var C = Rt(e), _ = e[Rn] || C[Rn];
        e && (!_ || _ === v.core()) && !C[Vi] && e[Ua] && e[Ua](v, f) === !0 && (D = !0);
      }
      return D;
    }
    c(v, p, "update", function() {
    }, !1) || v[Mn](f);
  }
  return Mo(s);
}
function fC() {
  var e = [];
  function n(r) {
    r && e[Be](r);
  }
  function i(r, t) {
    se(e, function(a) {
      try {
        a(r, t);
      } catch (o) {
        Q(r[Wi](), 2, 73, "Unexpected error calling unload handler - " + ae(o));
      }
    }), e = [];
  }
  return {
    add: n,
    run: i
  };
}
function gC() {
  var e = [];
  function n(r) {
    var t = e;
    e = [], se(t, function(a) {
      try {
        (a.rm || a.remove).call(a);
      } catch (o) {
        Q(r, 2, 73, "Unloading:" + ae(o));
      }
    });
  }
  function i(r) {
    r && oo(e, r);
  }
  return {
    run: n,
    add: i
  };
}
var Hc, tr = "getPlugin", D_ = (Hc = {}, Hc[Do] = { isVal: po, v: {} }, Hc), Tt = function() {
  function e() {
    var n = this, i, r, t, a, o;
    c(), We(e, n, function(l) {
      l[qu] = function(g, R, v, f) {
        u(g, R, f), i = !0;
      }, l[Vi] = function(g, R) {
        var v, f = l[Rn];
        if (!f || g && f !== g[Rn]())
          return;
        var p, D = !1, C = g || yu(null, f, t && t[tr] ? t[tr]() : t), _ = R || (v = {
          reason: 0
        }, v[Po] = !1, v);
        function E() {
          D || (D = !0, a.run(C, R), o.run(C[Wi]()), p === !0 && C[Mn](_), c());
        }
        return !l[zl] || l[zl](C, _, E) !== !0 ? E() : p = !0, p;
      }, l[Ua] = function(g, R) {
        var v = l[Rn];
        if (!v || g && v !== g[Rn]())
          return;
        var f, p = !1, D = g || Tf(null, v, t && t[tr] ? t[tr]() : t), C = R || {
          reason: 0
        };
        function _() {
          p || (p = !0, u(D.getCfg(), D.core(), D[Si]()));
        }
        return !l._doUpdate || l._doUpdate(D, C, _) !== !0 ? _() : f = !0, f;
      }, pu(l, "_addUnloadCb", function() {
        return a;
      }, "add"), pu(l, "_addHook", function() {
        return o;
      }, "add"), xe(l, "_unloadHooks", { g: function() {
        return o;
      } });
    }), n[Wi] = function(l) {
      return s(l)[Wi]();
    }, n[Ei] = function() {
      return i;
    }, n.setInitialized = function(l) {
      i = l;
    }, n[Ya] = function(l) {
      t = l;
    }, n[Mn] = function(l, g) {
      g ? g[Mn](l) : t && _e(t[Ii]) && t[Ii](l, null);
    }, n._getTelCtx = s;
    function s(l) {
      l === void 0 && (l = null);
      var g = l;
      if (!g) {
        var R = r || fi(null, {}, n[Rn]);
        t && t[tr] ? g = R[Et](null, t[tr]) : g = R[Et](null, t);
      }
      return g;
    }
    function u(l, g, R) {
      ri(l, D_, St(g)), !R && g && (R = g[Ld]()[Si]());
      var v = t;
      t && t[tr] && (v = t[tr]()), n[Rn] = g, r = fi(R, l, g, v);
    }
    function c() {
      i = !1, n[Rn] = null, r = null, t = null, o = gC(), a = fC();
    }
  }
  return e.__ieDyn = 1, e;
}();
function p_(e, n, i) {
  var r = {
    id: n,
    fn: i
  };
  oo(e, r);
  var t = {
    remove: function() {
      se(e, function(a, o) {
        if (a.id === r.id)
          return e[Bo](o, 1), -1;
      });
    }
  };
  return t;
}
function h_(e, n, i) {
  for (var r = !1, t = e[Ae], a = 0; a < t; ++a) {
    var o = e[a];
    if (o)
      try {
        if (o.fn[_t](null, [n]) === !1) {
          r = !0;
          break;
        }
      } catch (s) {
        Q(i, 2, 64, "Telemetry initializer failed: " + Ue(s), { exception: ae(s) }, !0);
      }
  }
  return !r;
}
var w_ = function(e) {
  Fi(n, e);
  function n() {
    var i = e.call(this) || this;
    i.identifier = "TelemetryInitializerPlugin", i.priority = 199;
    var r, t;
    a(), We(n, i, function(o, s) {
      o.addTelemetryInitializer = function(u) {
        return p_(t, r++, u);
      }, o[Ii] = function(u, c) {
        h_(t, u, c ? c[Wi]() : o[Wi]()) && o[Mn](u, c);
      }, o[zl] = function() {
        a();
      };
    });
    function a() {
      r = 0, t = [];
    }
    return i;
  }
  return n.__ieDyn = 1, n;
}(Tt), or, RC = "Plugins must provide initialize method", __ = "_notificationManager", Yg = "SDK is still unloading...", E_ = "SDK is not initialized", zc = ir((or = {
  cookieCfg: {}
}, or[Xt] = { rdOnly: !0, ref: !0, v: [] }, or[it] = { rdOnly: !0, ref: !0, v: [] }, or[Do] = { ref: !0, v: {} }, or[Jl] = _i, or.loggingLevelConsole = 0, or.diagnosticLogInterval = _i, or));
function m_(e, n) {
  return new u_(n);
}
function S_(e, n, i) {
  var r, t = [], a = [], o = {};
  return se(i, function(s) {
    (z(s) || z(s[qu])) && $n(RC);
    var u = s[du], c = s[Rr];
    s && u && (z(o[u]) ? o[u] = c : ho(e, "Two extensions have same priority #" + u + " - " + o[u] + ", " + c)), !u || u < n ? t[Be](s) : a[Be](s);
  }), r = {}, r[Rn] = t, r[it] = a, r;
}
function xg(e, n) {
  var i = !1;
  return se(n, function(r) {
    if (r === e)
      return i = !0, -1;
  }), i;
}
function uv(e, n, i, r) {
  i && Te(i, function(t, a) {
    r && Bn(a) && Bn(n[t]) && uv(e, n[t], a, r), r && Bn(a) && Bn(n[t]) ? uv(e, n[t], a, r) : e.set(n, t, a);
  });
}
function Bg(e, n) {
  var i = null, r = -1;
  return se(e, function(t, a) {
    if (t.w === n)
      return i = t, r = a, -1;
  }), { i: r, l: i };
}
function T_(e, n) {
  var i = Bg(e, n).l;
  return i || (i = {
    w: n,
    rm: function() {
      var r = Bg(e, n);
      r.i !== -1 && e[Bo](r.i, 1);
    }
  }, e[Be](i)), i;
}
function y_(e, n, i) {
  se(n, function(r) {
    var t = tn(e, r.w, i);
    delete r.w, r.rm = function() {
      t.rm();
    };
  });
}
var N_ = function() {
  function e() {
    var n, i, r, t, a, o, s, u, c, l, g, R, v, f, p, D, C, _, E, N, O, d, m, y, Y, k, J, te;
    We(e, this, function(I) {
      oe(), I._getDbgPlgTargets = function() {
        return [m];
      }, I[Ei] = function() {
        return i;
      }, I[qu] = function(F, Z, ge, ce) {
        v && $n(Yg), I[Ei]() && $n("Core cannot be initialized more than once"), n = ri(F, zc, ge || I[an], !1), F = n.cfg, Qe(n[zi](function(be) {
          O = be.cfg.instrumentationKey;
          var Ve = be.ref(be.cfg, Do);
          Te(Ve, function(Ge) {
            be.ref(Ve, Ge);
          }), z(O) && $n("Please provide instrumentation key");
        })), a = ce, ie(), pe(), I[an] = ge;
        var Re = F[Xt];
        if (l = [], l[Be].apply(l, gg(gg([], Z, !1), Re)), g = F[it], Ce(null), (!R || R[Ae] === 0) && $n("No " + it + " available"), g && g[Ae] > 1) {
          var Pe = I[ka]("TeeChannelController");
          (!Pe || !Pe.plugin) && Q(r, 1, 28, "TeeChannel required");
        }
        y_(F, d, r), d = null, i = !0, I.releaseQueue(), I[Rg]();
      }, I.getChannels = function() {
        var F = [];
        return R && se(R, function(Z) {
          F[Be](Z);
        }), Mo(F);
      }, I.track = function(F) {
        Tu(I[Cu](), function() {
          return "AppInsightsCore:track";
        }, function() {
          F === null && (ke(F), $n("Invalid telemetry item")), !F[yr] && z(F[yr]) && (ke(F), $n("telemetry name required")), F.iKey = F.iKey || O, F[fo] = F[fo] || Fo(new Date()), F.ver = F.ver || "4.0", !v && I[Ei]() ? B()[Mn](F) : t[Be](F);
        }, function() {
          return { item: F };
        }, !F.sync);
      }, I[Ld] = B, I[$o] = function() {
        return a || (a = new a_(n.cfg), I[__] = a), a;
      }, I[Os] = function(F) {
        I[$o]()[Os](F);
      }, I[ks] = function(F) {
        a && a[ks](F);
      }, I.getCookieMgr = function() {
        return u || (u = Sa(n.cfg, I[an])), u;
      }, I.setCookieMgr = function(F) {
        u !== F && (uo(u, !1), u = F);
      }, I[Cu] = function() {
        return !o && !s && Qe(n[zi](function(F) {
          if (F.cfg.enablePerfMgr) {
            var Z = F.cfg[Jl];
            _e(Z) && (s = Z(I, I[$o]()));
          }
        })), o || s || c_();
      }, I.setPerfMgr = function(F) {
        o = F;
      }, I.eventCnt = function() {
        return t[Ae];
      }, I.releaseQueue = function() {
        if (i && t[Ae] > 0) {
          var F = t;
          t = [], se(F, function(Z) {
            B()[Mn](Z);
          });
        }
      }, I[Rg] = function(F) {
        return p = F || null, te = !1, k && k[Ra](), T(!0);
      };
      function T(F) {
        if ((!k || !k[ao]) && !te) {
          var Z = F || r && r.queue[Ae] > 0;
          Z && (J || (J = !0, Qe(n[zi](function(ge) {
            var ce = ge.cfg.diagnosticLogInterval;
            (!ce || !(ce > 0)) && (ce = 1e4);
            var Re = !1;
            k && (Re = k[ao], k[Ra]()), k = Ph(L, ce), k.unref(), k[ao] = Re;
          }))), k[ao] = !0);
        }
        return k;
      }
      I[dg] = function() {
        te = !0, k && k[Ra](), L();
      }, so(I, function() {
        return f;
      }, ["addTelemetryInitializer"]), I[Lr] = function(F, Z, ge) {
        var ce;
        F === void 0 && (F = !0), i || $n(E_), v && $n(Yg);
        var Re = (ce = {
          reason: 50
        }, ce[Po] = F, ce.flushComplete = !1, ce), Pe;
        F && !Z && (Pe = Or(function(Ge) {
          Z = Ge;
        }));
        var be = yu(S(), I);
        be[fs](function() {
          _.run(I[an]), oC([u, a, r], F, function() {
            oe(), Z && Z(Re);
          });
        }, I);
        function Ve(Ge) {
          Re.flushComplete = Ge, v = !0, C.run(be, Re), I[dg](), be[Mn](Re);
        }
        return L(), V(F, Ve, 6, ge), Pe;
      }, I[ka] = P, I.addPlugin = function(F, Z, ge, ce) {
        if (!F) {
          ce && ce(!1), Ie(RC);
          return;
        }
        var Re = P(F[Rr]);
        if (Re && !Z) {
          ce && ce(!1), Ie("Plugin [" + F[Rr] + "] is already loaded!");
          return;
        }
        var Pe = {
          reason: 16
        };
        function be(Cn) {
          l[Be](F), Pe.added = [F], Ce(Pe), ce && ce(!0);
        }
        if (Re) {
          var Ve = [Re.plugin], Ge = {
            reason: 2,
            isAsync: !!ge
          };
          M(Ve, Ge, function(Cn) {
            Cn ? (Pe.removed = Ve, Pe.reason |= 32, be()) : ce && ce(!1);
          });
        } else
          be();
      }, I.updateCfg = function(F, Z) {
        Z === void 0 && (Z = !0);
        var ge;
        if (I[Ei]()) {
          ge = {
            reason: 1,
            cfg: n.cfg,
            oldCfg: sg({}, n.cfg),
            newConfig: sg({}, F),
            merge: Z
          }, F = ge.newConfig;
          var ce = n.cfg;
          F[Xt] = ce[Xt], F[it] = ce[it];
        }
        n._block(function(Re) {
          var Pe = Re.cfg;
          uv(Re, Pe, F, Z), Z || Te(Pe, function(be) {
            Tr(F, be) || Re.set(Pe, be, _i);
          }), Re[xo](Pe, zc);
        }, !0), n[lu](), ge && Se(ge);
      }, I.evtNamespace = function() {
        return D;
      }, I.flush = V, I.getTraceCtx = function(F) {
        return N || (N = g_()), N;
      }, I.setTraceCtx = function(F) {
        N = F || null;
      }, I.addUnloadHook = Qe, pu(I, "addUnloadCb", function() {
        return C;
      }, "add"), I.onCfgChange = function(F) {
        var Z;
        return i ? Z = tn(n.cfg, F, I[an]) : Z = T_(d, F), {
          rm: function() {
            Z.rm();
          }
        };
      }, I.getWParam = function() {
        return fd() || !!n.cfg.enableWParam ? 0 : -1;
      };
      function j() {
        var F = {};
        y = [];
        var Z = function(ge) {
          ge && se(ge, function(ce) {
            if (ce[Rr] && ce[fu] && !F[ce.identifier]) {
              var Re = ce[Rr] + "=" + ce[fu];
              y[Be](Re), F[ce.identifier] = ce;
            }
          });
        };
        Z(R), g && se(g, function(ge) {
          Z(ge);
        }), Z(l);
      }
      function oe() {
        i = !1, n = ri({}, zc, I[an]), n.cfg[Od] = 1, xe(I, "config", {
          g: function() {
            return n.cfg;
          },
          s: function(Z) {
            I.updateCfg(Z, !1);
          }
        }), xe(I, "pluginVersionStringArr", {
          g: function() {
            return y || j(), y;
          }
        }), xe(I, "pluginVersionString", {
          g: function() {
            return Y || (y || j(), Y = y.join(";")), Y || Le;
          }
        }), xe(I, "logger", {
          g: function() {
            return r || (r = new mu(n.cfg), n[an] = r), r;
          },
          s: function(Z) {
            n[an] = Z, r !== Z && (uo(r, !1), r = Z);
          }
        }), I[an] = new mu(n.cfg), m = [];
        var F = I.config[Xt] || [];
        F.splice(0, F[Ae]), oo(F, m), f = new w_(), t = [], uo(a, !1), a = null, o = null, s = null, uo(u, !1), u = null, c = null, l = [], g = null, R = null, v = !1, p = null, D = ii("AIBaseCore", !0), C = fC(), N = null, O = null, _ = gC(), d = [], Y = null, y = null, te = !1;
      }
      function B() {
        var F = fi(S(), n.cfg, I);
        return F[fs](T), F;
      }
      function Ce(F) {
        var Z = S_(I[an], Vw, l);
        c = null, Y = null, y = null, R = (g || [])[0] || [], R = Vc(oo(R, Z[it]));
        var ge = oo(Vc(Z[Rn]), R);
        m = Mo(ge);
        var ce = I.config[Xt] || [];
        ce.splice(0, ce[Ae]), oo(ce, m);
        var Re = B();
        R && R[Ae] > 0 && Lg(Re[Et](R), ge), Lg(Re, ge), F && Se(F);
      }
      function P(F) {
        var Z = null, ge = null, ce = [];
        return se(m, function(Re) {
          if (Re[Rr] === F && Re !== f)
            return ge = Re, -1;
          Re.getChannel && ce[Be](Re);
        }), !ge && ce[Ae] > 0 && se(ce, function(Re) {
          if (ge = Re.getChannel(F), !ge)
            return -1;
        }), ge && (Z = {
          plugin: ge,
          setEnabled: function(Re) {
            Rt(ge)[Ql] = !Re;
          },
          isEnabled: function() {
            var Re = Rt(ge);
            return !Re[Vi] && !Re[Ql];
          },
          remove: function(Re, Pe) {
            var be;
            Re === void 0 && (Re = !0);
            var Ve = [ge], Ge = (be = {
              reason: 1
            }, be[Po] = Re, be);
            M(Ve, Ge, function(Cn) {
              Cn && Ce({
                reason: 32,
                removed: Ve
              }), Pe && Pe(Cn);
            });
          }
        }), Z;
      }
      function S() {
        if (!c) {
          var F = (m || []).slice();
          Nn(F, f) === -1 && F[Be](f), c = mt(Vc(F), n.cfg, I);
        }
        return c;
      }
      function M(F, Z, ge) {
        if (F && F[Ae] > 0) {
          var ce = mt(F, n.cfg, I), Re = yu(ce, I);
          Re[fs](function() {
            var Pe = !1, be = [];
            se(l, function(Ge, Cn) {
              xg(Ge, F) ? Pe = !0 : be[Be](Ge);
            }), l = be, Y = null, y = null;
            var Ve = [];
            g && (se(g, function(Ge, Cn) {
              var Dn = [];
              se(Ge, function(On) {
                xg(On, F) ? Pe = !0 : Dn[Be](On);
              }), Ve[Be](Dn);
            }), g = Ve), ge && ge(Pe), T();
          }), Re[Mn](Z);
        } else
          ge(!1);
      }
      function L() {
        if (r && r.queue) {
          var F = r.queue.slice(0);
          r.queue[Ae] = 0, se(F, function(Z) {
            var ge, ce = (ge = {}, ge[yr] = p || "InternalMessageId: " + Z[gu], ge.iKey = O, ge[fo] = Fo(new Date()), ge.baseType = Va.dataType, ge.baseData = { message: Z[go] }, ge);
            I.track(ce);
          });
        }
      }
      function V(F, Z, ge, ce) {
        var Re = 1, Pe = !1, be = null;
        ce = ce || 5e3;
        function Ve() {
          Re--, Pe && Re === 0 && (be && be[Ra](), be = null, Z && Z(Pe), Z = null);
        }
        if (R && R[Ae] > 0) {
          var Ge = B()[Et](R);
          Ge.iterate(function(Cn) {
            if (Cn.flush) {
              Re++;
              var Dn = !1;
              Cn.flush(F, function() {
                Dn = !0, Ve();
              }, ge) || Dn || (F && be == null ? be = Di(function() {
                be = null, Ve();
              }, ce) : Ve());
            }
          });
        }
        return Pe = !0, Ve(), !0;
      }
      function ie() {
        !a && I[$o](), Qe(n[zi](function(F) {
          var Z = F.cfg.disableDbgExt;
          Z === !0 && E && (a[ks](E), E = null), a && !E && Z !== !0 && (E = Kw(F.cfg), a[Os](E));
        }));
      }
      function pe() {
        Qe(n[zi](function(F) {
          var Z = F.cfg.enablePerfMgr;
          !Z && s && (s = null), Z && bn(F.cfg, Jl, m_);
        }));
      }
      function Se(F) {
        var Z = Tf(S(), I);
        Z[fs](T), (!I._updateHook || I._updateHook(Z, F) !== !0) && Z[Mn](F);
      }
      function Ie(F) {
        var Z = I[an];
        Z ? (Q(Z, 2, 73, F), T()) : $n(F);
      }
      function ke(F) {
        var Z = I[$o]();
        Z && Z[ma]([F], 2);
      }
      function Qe(F) {
        _.add(F);
      }
    });
  }
  return e.__ieDyn = 1, e;
}(), dC = "on", Gg = "attachEvent", Vg = "addEventListener", Hg = "detachEvent", zg = "removeEventListener", cv = "events", lv = "visibilitychange", ec = "pagehide", CC = "unload", DC = "beforeunload", pC = ii("aiEvtPageHide");
ii("aiEvtPageShow");
var I_ = /\.[\.]+/g, b_ = /[\.]+$/, M_ = 1, Nu = eC("events"), P_ = /^([^.]*)(?:\.(.+)|)/;
function $g(e) {
  return e && e[Ro] ? e[Ro](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, Le) : e;
}
function yf(e, n) {
  var i;
  if (n) {
    var r = Le;
    Me(n) ? (r = Le, se(n, function(a) {
      a = $g(a), a && (a[0] !== "." && (a = "." + a), r += a);
    })) : r = $g(n), r && (r[0] !== "." && (r = "." + r), e = (e || Le) + r);
  }
  var t = P_.exec(e || Le) || [];
  return i = {}, i[Xi] = t[1], i.ns = (t[2] || Le).replace(I_, ".").replace(b_, Le)[xa](".").sort().join("."), i;
}
function hC(e, n, i) {
  i === void 0 && (i = !0);
  var r = Nu.get(e, cv, {}, i), t = r[n];
  return t || (t = r[n] = []), t;
}
function wC(e, n, i, r) {
  e && n && n[Xi] && (e[zg] ? e[zg](n[Xi], i, r) : e[Hg] && e[Hg](dC + n[Xi], i));
}
function A_(e, n, i, r) {
  var t = !1;
  return e && n && n[Xi] && i && (e[Vg] ? (e[Vg](n[Xi], i, r), t = !0) : e[Gg] && (e[Gg](dC + n[Xi], i), t = !0)), t;
}
function jg(e, n, i, r) {
  for (var t = n[Ae]; t--; ) {
    var a = n[t];
    a && (!i.ns || i.ns === a.evtName.ns) && (!r || r(a)) && (wC(e, a.evtName, a[Cf], a.capture), n[Bo](t, 1));
  }
}
function F_(e, n, i) {
  if (n[Xi])
    jg(e, hC(e, n[Xi]), n, i);
  else {
    var r = Nu.get(e, cv, {});
    Te(r, function(t, a) {
      jg(e, a, n, i);
    }), Ar(r)[Ae] === 0 && Nu.kill(e, cv);
  }
}
function xr(e, n) {
  var i;
  return n ? (Me(n) ? i = [e].concat(n) : i = [e, n], i = yf("xx", i).ns[xa](".")) : i = e, i;
}
function qi(e, n, i, r, t) {
  var a;
  t === void 0 && (t = !1);
  var o = !1;
  if (e)
    try {
      var s = yf(n, r);
      if (o = A_(e, s, i, t), o && Nu.accept(e)) {
        var u = (a = {
          guid: M_++,
          evtName: s
        }, a[Cf] = i, a.capture = t, a);
        hC(e, s.type)[Be](u);
      }
    } catch (c) {
    }
  return o;
}
function _o(e, n, i, r, t) {
  if (t === void 0 && (t = !1), e)
    try {
      var a = yf(n, r), o = !1;
      F_(e, a, function(s) {
        return a.ns && !i || s[Cf] === i ? (o = !0, !0) : !1;
      }), o || wC(e, a, i, t);
    } catch (s) {
    }
}
function L_(e, n, i) {
  var r = !1, t = jn();
  t && (r = qi(t, e, n, i), r = qi(t.body, e, n, i) || r);
  var a = Tn();
  return a && (r = qi(a, e, n, i) || r), r;
}
function O_(e, n, i) {
  var r = jn();
  r && (_o(r, e, n, i), _o(r.body, e, n, i));
  var t = Tn();
  t && _o(t, e, n, i);
}
function Iu(e, n, i, r) {
  var t = !1;
  return n && e && e[Ae] > 0 && se(e, function(a) {
    a && (!i || Nn(i, a) === -1) && (t = L_(a, n, r) || t);
  }), t;
}
function k_(e, n, i, r) {
  var t = !1;
  return n && e && Me(e) && (t = Iu(e, n, i, r), !t && i && i[Ae] > 0 && (t = Iu(e, n, null, r))), t;
}
function vv(e, n, i) {
  e && Me(e) && se(e, function(r) {
    r && O_(r, n, i);
  });
}
function U_(e, n, i) {
  return k_([DC, CC, ec], e, n, i);
}
function Y_(e, n) {
  vv([DC, CC, ec], e, n);
}
function fv(e, n, i) {
  function r(o) {
    var s = Tn();
    e && s && s.visibilityState === "hidden" && e(o);
  }
  var t = xr(pC, i), a = Iu([ec], e, n, t);
  return (!n || Nn(n, lv) === -1) && (a = Iu([lv], r, n, t) || a), !a && n && (a = fv(e, null, i)), a;
}
function x_(e, n) {
  var i = xr(pC, n);
  vv([ec], e, i), vv([lv], null, i);
}
var Kg = "_aiHooks", Wg = [
  "req",
  "rsp",
  "hkErr",
  "fnErr"
];
function Nf(e, n) {
  if (e)
    for (var i = 0; i < e[Ae] && !n(e[i], i); i++)
      ;
}
function $c(e, n, i, r, t) {
  t >= 0 && t <= 2 && Nf(e, function(a, o) {
    var s = a.cbks, u = s[Wg[t]];
    if (u) {
      n.ctx = function() {
        var g = r[o] = r[o] || {};
        return g;
      };
      try {
        u[_t](n.inst, i);
      } catch (g) {
        var c = n.err;
        try {
          var l = s[Wg[2]];
          l && (n.err = g, l[_t](n.inst, i));
        } catch (R) {
        } finally {
          n.err = c;
        }
      }
    }
  });
}
function B_(e) {
  return function() {
    var n, i = this, r = arguments, t = e.h, a = (n = {}, n[yr] = e.n, n.inst = i, n.ctx = null, n.set = c, n), o = [], s = u([a], r);
    a.evt = yn("event");
    function u(g, R) {
      return Nf(R, function(v) {
        g[Be](v);
      }), g;
    }
    function c(g, R) {
      r = u([], r), r[g] = R, s = u([a], r);
    }
    $c(t, a, s, o, 0);
    var l = e.f;
    if (l)
      try {
        a.rslt = l[_t](i, r);
      } catch (g) {
        throw a.err = g, $c(t, a, s, o, 3), g;
      }
    return $c(t, a, s, o, 1), a.rslt;
  };
}
function If(e, n, i, r) {
  var t = null;
  return e && (ni(e, n) ? t = e : i && (t = If(sw(e), n, r, !1))), t;
}
function G_(e, n, i) {
  return e ? gv(e[mi], n, i, !1) : null;
}
function _C(e, n, i, r) {
  var t = i && i[Kg];
  if (!t) {
    t = {
      i: 0,
      n,
      f: i,
      h: []
    };
    var a = B_(t);
    a[Kg] = t, e[n] = a;
  }
  var o = {
    id: t.i,
    cbks: r,
    rm: function() {
      var s = this.id;
      Nf(t.h, function(u, c) {
        if (u.id === s)
          return t.h[Bo](c, 1), 1;
      });
    }
  };
  return t.i++, t.h[Be](o), o;
}
function gv(e, n, i, r, t) {
  if (r === void 0 && (r = !0), e && n && i) {
    var a = If(e, n, r, t);
    if (a) {
      var o = a[n];
      if (typeof o === bd)
        return _C(a, n, o, i);
    }
  }
  return null;
}
function ps(e, n, i, r, t) {
  if (e && n && i) {
    var a = If(e, n, r, t) || e;
    if (a)
      return _C(a, n, a[n], i);
  }
  return null;
}
var lt = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation", EC = "sampleRate", jc = "ProcessLegacy", Xg = "http.method", bf = "https://dc.services.visualstudio.com", ya = "/v2/track", bi = "not_specified", Kc = "iKey", Ye = Gh({
  requestContextHeader: [0, "Request-Context"],
  requestContextTargetKey: [1, "appId"],
  requestContextAppIdFormat: [2, "appId=cid-v1:"],
  requestIdHeader: [3, "Request-Id"],
  traceParentHeader: [4, "traceparent"],
  traceStateHeader: [5, "tracestate"],
  sdkContextHeader: [6, "Sdk-Context"],
  sdkContextHeaderAppIdRequest: [7, "appId"],
  requestContextHeaderLowerCase: [8, "request-context"]
}), Lo = "split", me = "length", Ha = "toLowerCase", $r = "ingestionendpoint", Oo = "toString", Mf = "removeItem", gi = "name", Er = "message", qt = "count", Wc = "preTriggerDate", Xc = "disabled", qc = "interval", qg = "daysOfMonth", Jc = "date", Qc = "getUTCDate", bu = "stringify", Zc = "pathname", Jg = "correlationHeaderExcludePatterns", Yt = "exceptions", oi = "parsedStack", Ji = "properties", Qi = "measurements", Eo = "sizeInBytes", Gi = "typeName", Da = "severityLevel", el = "problemGroup", nl = "isManual", mC = "CreateFromInterface", co = "assembly", rt = "fileName", Gs = "hasFullStack", hs = "level", xt = "method", Xo = "line", Mu = "duration", Qg = "receivedResponse";
function SC(e, n, i) {
  var r = n[me], t = V_(e, n);
  if (t[me] !== r) {
    for (var a = 0, o = t; i[o] !== void 0; )
      a++, o = Ci(t, 0, 150 - 3) + $_(a);
    t = o;
  }
  return t;
}
function V_(e, n) {
  var i;
  return n && (n = An(Pi(n)), n[me] > 150 && (i = Ci(n, 0, 150), Q(e, 2, 57, "name is too long.  It has been truncated to " + 150 + " characters.", { name: n }, !0))), i || n;
}
function fn(e, n, i) {
  i === void 0 && (i = 1024);
  var r;
  return n && (i = i || 1024, n = An(Pi(n)), n[me] > i && (r = Ci(n, 0, i), Q(e, 2, 61, "string value is too long. It has been truncated to " + i + " characters.", { value: n }, !0))), r || n;
}
function nc(e, n) {
  return yC(e, n, 2048, 66);
}
function TC(e, n) {
  var i;
  return n && n[me] > 32768 && (i = Ci(n, 0, 32768), Q(e, 2, 56, "message is too long, it has been truncated to " + 32768 + " characters.", { message: n }, !0)), i || n;
}
function H_(e, n) {
  var i;
  if (n) {
    var r = "" + n;
    r[me] > 32768 && (i = Ci(r, 0, 32768), Q(e, 2, 52, "exception is too long, it has been truncated to " + 32768 + " characters.", { exception: n }, !0));
  }
  return i || n;
}
function yt(e, n) {
  if (n) {
    var i = {};
    Te(n, function(r, t) {
      if (Ln(t) && Za())
        try {
          t = vi()[bu](t);
        } catch (a) {
          Q(e, 2, 49, "custom property is not valid", { exception: a }, !0);
        }
      t = fn(e, t, 8192), r = SC(e, r, i), i[r] = t;
    }), n = i;
  }
  return n;
}
function Nt(e, n) {
  if (n) {
    var i = {};
    Te(n, function(r, t) {
      r = SC(e, r, i), i[r] = t;
    }), n = i;
  }
  return n;
}
function z_(e, n) {
  return n && yC(e, n, 128, 69)[Oo]();
}
function yC(e, n, i, r) {
  var t;
  return n && (n = An(Pi(n)), n[me] > i && (t = Ci(n, 0, i), Q(e, 2, r, "input is too long, it has been truncated to " + i + " characters.", { data: n }, !0))), t || n;
}
function $_(e) {
  var n = "00" + e;
  return gr(n, n[me] - 3);
}
var Zg = Tn() || {}, eR = 0, j_ = [null, null, null, null, null];
function Pf(e) {
  var n = eR, i = j_, r = i[n];
  return Zg.createElement ? i[n] || (r = i[n] = Zg.createElement("a")) : r = { host: X_(e, !0) }, r.href = e, n++, n >= i[me] && (n = 0), eR = n, r;
}
function K_(e) {
  var n, i = Pf(e);
  return i && (n = i.href), n;
}
function W_(e, n) {
  return e ? e.toUpperCase() + " " + n : n;
}
function X_(e, n) {
  var i = NC(e, n) || "";
  if (i) {
    var r = i.match(/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
    if (r != null && r[me] > 3 && he(r[2]) && r[2][me] > 0)
      return r[2] + (r[3] || "");
  }
  return i;
}
function NC(e, n) {
  var i = null;
  if (e) {
    var r = e.match(/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
    if (r != null && r[me] > 2 && he(r[2]) && r[2][me] > 0 && (i = r[2] || "", n && r[me] > 2)) {
      var t = (r[1] || "")[Ha](), a = r[3] || "";
      (t === "http" && a === ":80" || t === "https" && a === ":443") && (a = ""), i += a;
    }
  }
  return i;
}
var q_ = [
  bf + ya,
  "https://breeze.aimon.applicationinsights.io" + ya,
  "https://dc-int.services.visualstudio.com" + ya
], J_ = "cid-v1:";
function Vs(e) {
  return Nn(q_, e[Ha]()) !== -1;
}
function nR(e, n, i) {
  if (!n || e && e.disableCorrelationHeaders)
    return !1;
  if (e && e[Jg]) {
    for (var r = 0; r < e.correlationHeaderExcludePatterns[me]; r++)
      if (e[Jg][r].test(n))
        return !1;
  }
  var t = Pf(n).host[Ha]();
  if (t && (Gn(t, ":443") !== -1 || Gn(t, ":80") !== -1) && (t = (NC(n, !0) || "")[Ha]()), (!e || !e.enableCorsCorrelation) && t && t !== i)
    return !1;
  var a = e && e.correlationHeaderDomains;
  if (a) {
    var o;
    if (se(a, function(c) {
      var l = new RegExp(c.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
      o = o || l.test(t);
    }), !o)
      return !1;
  }
  var s = e && e.correlationHeaderExcludedDomains;
  if (!s || s[me] === 0)
    return !0;
  for (var r = 0; r < s[me]; r++) {
    var u = new RegExp(s[r].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
    if (u.test(t))
      return !1;
  }
  return t && t[me] > 0;
}
function iR(e) {
  if (e) {
    var n = Q_(e, Ye[1]);
    if (n && n !== J_)
      return n;
  }
}
function Q_(e, n) {
  if (e)
    for (var i = e[Lo](","), r = 0; r < i[me]; ++r) {
      var t = i[r][Lo]("=");
      if (t[me] === 2 && t[0] === n)
        return t[1];
    }
}
function Z_(e, n, i, r) {
  var t, a = r, o = r;
  if (n && n[me] > 0) {
    var s = Pf(n);
    if (t = s.host, !a)
      if (s[Zc] != null) {
        var u = s.pathname[me] === 0 ? "/" : s[Zc];
        u.charAt(0) !== "/" && (u = "/" + u), o = s[Zc], a = fn(e, i ? i + " " + u : u);
      } else
        a = fn(e, n);
  } else
    t = r, a = r;
  return {
    target: t,
    name: a,
    data: o
  };
}
function ws() {
  var e = Zi();
  if (e && e.now && e.timing) {
    var n = e.now() + e.timing.navigationStart;
    if (n > 0)
      return n;
  }
  return Ni();
}
function Yn(e, n) {
  var i = null;
  return e !== 0 && n !== 0 && !z(e) && !z(n) && (i = n - e), i;
}
function Af(e, n) {
  var i = e || {};
  return {
    getName: function() {
      return i[gi];
    },
    setName: function(r) {
      n && n.setName(r), i[gi] = r;
    },
    getTraceId: function() {
      return i.traceID;
    },
    setTraceId: function(r) {
      n && n.setTraceId(r), Ef(r) && (i.traceID = r);
    },
    getSpanId: function() {
      return i.parentID;
    },
    setSpanId: function(r) {
      n && n.setSpanId(r), mf(r) && (i.parentID = r);
    },
    getTraceFlags: function() {
      return i.traceFlags;
    },
    setTraceFlags: function(r) {
      n && n.setTraceFlags(r), i.traceFlags = r;
    }
  };
}
var ns = Ad({
  LocalStorage: 0,
  SessionStorage: 1
});
Ad({
  AI: 0,
  AI_AND_W3C: 1,
  W3C: 2
});
var Ir = void 0, br = void 0, IC = "";
function Ff() {
  return rc() ? ic(ns.LocalStorage) : null;
}
function ic(e) {
  try {
    if (z(ei()))
      return null;
    var n = new Date()[Oo](), i = yn(e === ns.LocalStorage ? "localStorage" : "sessionStorage"), r = IC + n;
    i.setItem(r, n);
    var t = i.getItem(r) !== n;
    if (i[Mf](r), !t)
      return i;
  } catch (a) {
  }
  return null;
}
function Lf() {
  return za() ? ic(ns.SessionStorage) : null;
}
function e0() {
  Ir = !1, br = !1;
}
function Of(e) {
  IC = e || "";
}
function n0() {
  Ir = rc(!0), br = za(!0);
}
function rc(e) {
  return (e || Ir === void 0) && (Ir = !!ic(ns.LocalStorage)), Ir;
}
function bC(e, n) {
  var i = Ff();
  if (i !== null)
    try {
      return i.getItem(n);
    } catch (r) {
      Ir = !1, Q(e, 2, 1, "Browser failed read of local storage. " + Ue(r), { exception: ae(r) });
    }
  return null;
}
function MC(e, n, i) {
  var r = Ff();
  if (r !== null)
    try {
      return r.setItem(n, i), !0;
    } catch (t) {
      Ir = !1, Q(e, 2, 3, "Browser failed write to local storage. " + Ue(t), { exception: ae(t) });
    }
  return !1;
}
function i0(e, n) {
  var i = Ff();
  if (i !== null)
    try {
      return i[Mf](n), !0;
    } catch (r) {
      Ir = !1, Q(e, 2, 5, "Browser failed removal of local storage item. " + Ue(r), { exception: ae(r) });
    }
  return !1;
}
function za(e) {
  return (e || br === void 0) && (br = !!ic(ns.SessionStorage)), br;
}
function Rv(e, n) {
  var i = Lf();
  if (i !== null)
    try {
      return i.getItem(n);
    } catch (r) {
      br = !1, Q(e, 2, 2, "Browser failed read of session storage. " + Ue(r), { exception: ae(r) });
    }
  return null;
}
function PC(e, n, i) {
  var r = Lf();
  if (r !== null)
    try {
      return r.setItem(n, i), !0;
    } catch (t) {
      br = !1, Q(e, 2, 4, "Browser failed write to session storage. " + Ue(t), { exception: ae(t) });
    }
  return !1;
}
function r0(e, n) {
  var i = Lf();
  if (i !== null)
    try {
      return i[Mf](n), !0;
    } catch (r) {
      br = !1, Q(e, 2, 6, "Browser failed removal of session storage item. " + Ue(r), { exception: ae(r) });
    }
  return !1;
}
var t0 = "appInsightsThrottle", o0 = function() {
  function e(n, i) {
    var r = this, t, a, o, s, u, c, l, g = !1, R = !1;
    f(), r._getDbgPlgTargets = function() {
      return [l];
    }, r.getConfig = function() {
      return o;
    }, r.canThrottle = function(T) {
      var j = J(T), oe = p(T);
      return _(oe, t, j);
    }, r.isTriggered = function(T) {
      return te(T);
    }, r.isReady = function() {
      return g;
    }, r.flush = function(T) {
      try {
        var j = I(T);
        if (j && j[me] > 0) {
          var oe = j.slice(0);
          return l[T] = [], se(oe, function(B) {
            v(B.msgID, B[Er], B.severity, !1);
          }), !0;
        }
      } catch (B) {
      }
      return !1;
    }, r.flushAll = function() {
      try {
        if (l) {
          var T = !0;
          return Te(l, function(j) {
            var oe = r.flush(parseInt(j));
            T = T && oe;
          }), T;
        }
      } catch (j) {
      }
      return !1;
    }, r.onReadyState = function(T, j) {
      return j === void 0 && (j = !0), g = z(T) ? !0 : T, g && j ? r.flushAll() : null;
    }, r.sendMessage = function(T, j, oe) {
      return v(T, j, oe, !0);
    };
    function v(T, j, oe, B) {
      if (g) {
        var Ce = k(T);
        if (!Ce)
          return;
        var P = p(T), S = J(T), M = _(P, t, S), L = !1, V = 0, ie = te(T);
        try {
          M && !ie ? (V = Math.min(P.limit.maxSendNumber, S[qt] + 1), S[qt] = 0, L = !0, u[T] = !0, S[Wc] = new Date()) : (u[T] = M, S[qt] += 1);
          var pe = E(T);
          m(a, pe, S);
          for (var Se = 0; Se < V; Se++)
            Y(T, a, j, oe);
        } catch (ke) {
        }
        return {
          isThrottled: L,
          throttleNum: V
        };
      } else if (B) {
        var Ie = I(T);
        Ie.push({
          msgID: T,
          message: j,
          severity: oe
        });
      }
      return null;
    }
    function f() {
      a = St(n), u = {}, s = {}, l = {}, o = {}, D(109), c = po(i) ? i : "", n.addUnloadHook(tn(n.config, function(T) {
        var j = T.cfg;
        t = rc();
        var oe = j.throttleMgrCfg || {};
        Te(oe, function(B, Ce) {
          D(parseInt(B), Ce);
        });
      }));
    }
    function p(T) {
      return o[T] || o[109];
    }
    function D(T, j) {
      var oe, B;
      try {
        var Ce = j || {}, P = {};
        P[Xc] = !!Ce[Xc];
        var S = Ce[qc] || {};
        R = (S == null ? void 0 : S.daysOfMonth) && (S == null ? void 0 : S.daysOfMonth[me]) > 0, P[qc] = C(S);
        var M = {
          samplingRate: ((oe = Ce.limit) === null || oe === void 0 ? void 0 : oe.samplingRate) || 100,
          maxSendNumber: ((B = Ce.limit) === null || B === void 0 ? void 0 : B.maxSendNumber) || 1
        };
        P.limit = M, o[T] = P;
      } catch (L) {
      }
    }
    function C(T) {
      T = T || {};
      var j = T == null ? void 0 : T.monthInterval, oe = T == null ? void 0 : T.dayInterval;
      return z(j) && z(oe) && (T.monthInterval = 3, R || (T[qg] = [28], R = !0)), T = {
        monthInterval: T == null ? void 0 : T.monthInterval,
        dayInterval: T == null ? void 0 : T.dayInterval,
        daysOfMonth: T == null ? void 0 : T.daysOfMonth
      }, T;
    }
    function _(T, j, oe) {
      if (T && !T[Xc] && j && po(oe)) {
        var B = d(), Ce = oe[Jc], P = T[qc], S = 1;
        if (P != null && P.monthInterval) {
          var M = (B.getUTCFullYear() - Ce.getUTCFullYear()) * 12 + B.getUTCMonth() - Ce.getUTCMonth();
          S = y(P.monthInterval, 0, M);
        }
        var L = 1;
        if (R)
          L = Nn(P[qg], B[Qc]());
        else if (P != null && P.dayInterval) {
          var V = Math.floor((B.getTime() - Ce.getTime()) / 864e5);
          L = y(P.dayInterval, 0, V);
        }
        return S >= 0 && L >= 0;
      }
      return !1;
    }
    function E(T, j) {
      var oe = po(j) ? j : "";
      return T ? t0 + oe + "-" + T : null;
    }
    function N(T) {
      try {
        if (T) {
          var j = new Date();
          return T.getUTCFullYear() === j.getUTCFullYear() && T.getUTCMonth() === j.getUTCMonth() && T[Qc]() === j[Qc]();
        }
      } catch (oe) {
      }
      return !1;
    }
    function O(T, j, oe) {
      try {
        var B = {
          date: d(),
          count: 0
        };
        if (T) {
          var Ce = JSON.parse(T), P = {
            date: d(Ce[Jc]) || B[Jc],
            count: Ce[qt] || B[qt],
            preTriggerDate: Ce.preTriggerDate ? d(Ce[Wc]) : void 0
          };
          return P;
        } else
          return m(j, oe, B), B;
      } catch (S) {
      }
      return null;
    }
    function d(T) {
      try {
        if (T) {
          var j = new Date(T);
          if (!isNaN(j.getDate()))
            return j;
        } else
          return new Date();
      } catch (oe) {
      }
      return null;
    }
    function m(T, j, oe) {
      try {
        return MC(T, j, An(JSON[bu](oe)));
      } catch (B) {
      }
      return !1;
    }
    function y(T, j, oe) {
      return T <= 0 ? 1 : oe >= j && (oe - j) % T == 0 ? Math.floor((oe - j) / T) + 1 : -1;
    }
    function Y(T, j, oe, B) {
      Q(j, B || 1, T, oe);
    }
    function k(T) {
      try {
        var j = p(T);
        return Nw(1e6) <= j.limit.samplingRate;
      } catch (oe) {
      }
      return !1;
    }
    function J(T) {
      try {
        var j = s[T];
        if (!j) {
          var oe = E(T, c);
          j = O(bC(a, oe), a, oe), s[T] = j;
        }
        return s[T];
      } catch (B) {
      }
      return null;
    }
    function te(T) {
      var j = u[T];
      if (z(j)) {
        j = !1;
        var oe = J(T);
        oe && (j = N(oe[Wc])), u[T] = j;
      }
      return u[T];
    }
    function I(T) {
      return l = l || {}, z(l[T]) && (l[T] = []), l[T];
    }
  }
  return e;
}(), a0 = ";", s0 = "=";
function u0(e) {
  if (!e)
    return {};
  var n = e[Lo](a0), i = lh(n, function(t, a) {
    var o = a[Lo](s0);
    if (o[me] === 2) {
      var s = o[0][Ha](), u = o[1];
      t[s] = u;
    }
    return t;
  }, {});
  if (Ar(i)[me] > 0) {
    if (i.endpointsuffix) {
      var r = i.location ? i.location + "." : "";
      i[$r] = i[$r] || "https://" + r + "dc." + i.endpointsuffix;
    }
    i[$r] = i[$r] || bf, Sd(i[$r], "/") && (i[$r] = i[$r].slice(0, -1));
  }
  return i;
}
var c0 = function() {
  function e(n, i, r) {
    var t = this, a = this;
    a.ver = 1, a.sampleRate = 100, a.tags = {}, a[gi] = fn(n, r) || bi, a.data = i, a.time = Fo(new Date()), a.aiDataContract = {
      time: 1,
      iKey: 1,
      name: 1,
      sampleRate: function() {
        return t.sampleRate === 100 ? 4 : 1;
      },
      tags: 1,
      data: 1
    };
  }
  return e;
}(), Cr = function() {
  function e(n, i, r, t) {
    this.aiDataContract = {
      ver: 1,
      name: 1,
      properties: 0,
      measurements: 0
    };
    var a = this;
    a.ver = 2, a[gi] = fn(n, i) || bi, a[Ji] = yt(n, r), a[Qi] = Nt(n, t);
  }
  return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Event", e.dataType = "EventData", e;
}(), l0 = "<no_method>", mo = "error", xn = "stack", dv = "stackDetails", rR = "errorSrc", Cv = "message", AC = "description";
function Dv(e, n) {
  var i = e;
  return i && !he(i) && (JSON && JSON[bu] ? (i = JSON[bu](e), n && (!i || i === "{}") && (_e(e[Oo]) ? i = e[Oo]() : i = "" + e)) : i = "" + e + " - (Missing JSON.stringify)"), i || "";
}
function FC(e, n) {
  var i = e;
  return e && (i && !he(i) && (i = e[Cv] || e[AC] || i), i && !he(i) && (i = Dv(i, !0)), e.filename && (i = i + " @" + (e.filename || "") + ":" + (e.lineno || "?") + ":" + (e.colno || "?"))), n && n !== "String" && n !== "Object" && n !== "Error" && Gn(i || "", n) === -1 && (i = n + ": " + i), i || "";
}
function v0(e) {
  try {
    if (Ln(e))
      return "hasFullStack" in e && "typeName" in e;
  } catch (n) {
  }
  return !1;
}
function f0(e) {
  try {
    if (Ln(e))
      return "ver" in e && "exceptions" in e && "properties" in e;
  } catch (n) {
  }
  return !1;
}
function tR(e) {
  return e && e.src && he(e.src) && e.obj && Me(e.obj);
}
function jr(e) {
  var n = e || "";
  he(n) || (he(n[xn]) ? n = n[xn] : n = "" + n);
  var i = n[Lo](`
`);
  return {
    src: n,
    obj: i
  };
}
function g0(e) {
  for (var n = [], i = e[Lo](`
`), r = 0; r < i[me]; r++) {
    var t = i[r];
    i[r + 1] && (t += "@" + i[r + 1], r++), n.push(t);
  }
  return {
    src: e,
    obj: n
  };
}
function LC(e) {
  var n = null;
  if (e)
    try {
      if (e[xn])
        n = jr(e[xn]);
      else if (e[mo] && e[mo][xn])
        n = jr(e[mo][xn]);
      else if (e.exception && e.exception[xn])
        n = jr(e.exception[xn]);
      else if (tR(e))
        n = e;
      else if (tR(e[dv]))
        n = e[dv];
      else if (jn() && jn().opera && e[Cv])
        n = g0(e[Er]);
      else if (e.reason && e.reason[xn])
        n = jr(e.reason[xn]);
      else if (he(e))
        n = jr(e);
      else {
        var i = e[Cv] || e[AC] || "";
        he(e[rR]) && (i && (i += `
`), i += " from " + e[rR]), i && (n = jr(i));
      }
    } catch (r) {
      n = jr(r);
    }
  return n || {
    src: "",
    obj: null
  };
}
function R0(e) {
  var n = "";
  return e && (e.obj ? se(e.obj, function(i) {
    n += i + `
`;
  }) : n = e.src || ""), n;
}
function d0(e) {
  var n, i = e.obj;
  if (i && i[me] > 0) {
    n = [];
    var r = 0, t = 0;
    se(i, function(f) {
      var p = f[Oo]();
      if (pv.regex.test(p)) {
        var D = new pv(p, r++);
        t += D[Eo], n.push(D);
      }
    });
    var a = 32 * 1024;
    if (t > a)
      for (var o = 0, s = n[me] - 1, u = 0, c = o, l = s; o < s; ) {
        var g = n[o][Eo], R = n[s][Eo];
        if (u += g + R, u > a) {
          var v = l - c + 1;
          n.splice(c, v);
          break;
        }
        c = o, l = s, o++, s--;
      }
  }
  return n;
}
function Pu(e) {
  var n = "";
  if (e && (n = e.typeName || e[gi] || "", !n))
    try {
      var i = /function (.{1,200})\(/, r = i.exec(e.constructor[Oo]());
      n = r && r[me] > 1 ? r[1] : "";
    } catch (t) {
    }
  return n;
}
function il(e) {
  if (e)
    try {
      if (!he(e)) {
        var n = Pu(e), i = Dv(e, !1);
        return (!i || i === "{}") && (e[mo] && (e = e[mo], n = Pu(e)), i = Dv(e, !0)), Gn(i, n) !== 0 && n !== "String" ? n + ":" + i : i;
      }
    } catch (r) {
    }
  return "" + (e || "");
}
var Jn = function() {
  function e(n, i, r, t, a, o) {
    this.aiDataContract = {
      ver: 1,
      exceptions: 1,
      severityLevel: 0,
      properties: 0,
      measurements: 0
    };
    var s = this;
    s.ver = 2, f0(i) ? (s[Yt] = i[Yt] || [], s[Ji] = i[Ji], s[Qi] = i[Qi], i[Da] && (s[Da] = i[Da]), i.id && (s.id = i.id), i[el] && (s[el] = i[el]), z(i[nl]) || (s[nl] = i[nl])) : (r || (r = {}), s[Yt] = [new oR(n, i, r)], s[Ji] = yt(n, r), s[Qi] = Nt(n, t), a && (s[Da] = a), o && (s.id = o));
  }
  return e.CreateAutoException = function(n, i, r, t, a, o, s, u) {
    var c, l = Pu(a || o || n);
    return c = {}, c[Er] = FC(n, l), c.url = i, c.lineNumber = r, c.columnNumber = t, c.error = il(a || o || n), c.evt = il(o || n), c[Gi] = l, c.stackDetails = LC(s || a || o), c.errorSrc = u, c;
  }, e.CreateFromInterface = function(n, i, r, t) {
    var a = i[Yt] && Ea(i[Yt], function(s) {
      return oR[mC](n, s);
    }), o = new e(n, Fn(Fn({}, i), { exceptions: a }), r, t);
    return o;
  }, e.prototype.toInterface = function() {
    var n, i = this, r = i.exceptions, t = i.properties, a = i.measurements, o = i.severityLevel, s = i.problemGroup, u = i.id, c = i.isManual, l = r instanceof Array && Ea(r, function(g) {
      return g.toInterface();
    }) || void 0;
    return n = {
      ver: "4.0"
    }, n[Yt] = l, n.severityLevel = o, n.properties = t, n.measurements = a, n.problemGroup = s, n.id = u, n.isManual = c, n;
  }, e.CreateSimpleException = function(n, i, r, t, a, o) {
    var s;
    return {
      exceptions: [
        (s = {}, s[Gs] = !0, s.message = n, s.stack = a, s.typeName = i, s)
      ]
    };
  }, e.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception", e.dataType = "ExceptionData", e.formatError = il, e;
}(), oR = function() {
  function e(n, i, r) {
    this.aiDataContract = {
      id: 0,
      outerId: 0,
      typeName: 1,
      message: 1,
      hasFullStack: 0,
      stack: 0,
      parsedStack: 2
    };
    var t = this;
    if (v0(i))
      t[Gi] = i[Gi], t[Er] = i[Er], t[xn] = i[xn], t[oi] = i[oi] || [], t[Gs] = i[Gs];
    else {
      var a = i, o = a && a.evt;
      ju(a) || (a = a[mo] || o || a), t[Gi] = fn(n, Pu(a)) || bi, t[Er] = TC(n, FC(i || a, t[Gi])) || bi;
      var s = i[dv] || LC(i);
      t[oi] = d0(s), Me(t[oi]) && Ea(t[oi], function(u) {
        u[co] = fn(n, u[co]), u[rt] = fn(n, u[rt]);
      }), t[xn] = H_(n, R0(s)), t.hasFullStack = Me(t.parsedStack) && t.parsedStack[me] > 0, r && (r[Gi] = r[Gi] || t[Gi]);
    }
  }
  return e.prototype.toInterface = function() {
    var n, i = this, r = i[oi] instanceof Array && Ea(i[oi], function(a) {
      return a.toInterface();
    }), t = (n = {
      id: i.id,
      outerId: i.outerId,
      typeName: i[Gi],
      message: i[Er],
      hasFullStack: i[Gs],
      stack: i[xn]
    }, n[oi] = r || void 0, n);
    return t;
  }, e.CreateFromInterface = function(n, i) {
    var r = i[oi] instanceof Array && Ea(i[oi], function(a) {
      return pv[mC](a);
    }) || i[oi], t = new e(n, Fn(Fn({}, i), { parsedStack: r }));
    return t;
  }, e;
}(), pv = function() {
  function e(n, i) {
    this.aiDataContract = {
      level: 1,
      method: 1,
      assembly: 0,
      fileName: 0,
      line: 0
    };
    var r = this;
    if (r[Eo] = 0, typeof n == "string") {
      var t = n;
      r[hs] = i, r[xt] = l0, r[co] = An(t), r[rt] = "", r[Xo] = 0;
      var a = t.match(e.regex);
      a && a[me] >= 5 && (r[xt] = An(a[2]) || r[xt], r[rt] = An(a[4]), r[Xo] = parseInt(a[5]) || 0);
    } else
      r[hs] = n[hs], r[xt] = n[xt], r[co] = n[co], r[rt] = n[rt], r[Xo] = n[Xo], r[Eo] = 0;
    r.sizeInBytes += r.method[me], r.sizeInBytes += r.fileName[me], r.sizeInBytes += r.assembly[me], r[Eo] += e.baseSize, r.sizeInBytes += r.level.toString()[me], r.sizeInBytes += r.line.toString()[me];
  }
  return e.CreateFromInterface = function(n) {
    return new e(n, null);
  }, e.prototype.toInterface = function() {
    var n = this;
    return {
      level: n[hs],
      method: n[xt],
      assembly: n[co],
      fileName: n[rt],
      line: n[Xo]
    };
  }, e.regex = /^([\s]+at)?[\s]{0,50}([^\@\()]+?)[\s]{0,50}(\@|\()([^\(\n]+):([0-9]+):([0-9]+)(\)?)$/, e.baseSize = 58, e;
}(), C0 = function() {
  function e() {
    this.aiDataContract = {
      name: 1,
      kind: 0,
      value: 1,
      count: 0,
      min: 0,
      max: 0,
      stdDev: 0
    }, this.kind = 0;
  }
  return e;
}(), dt = function() {
  function e(n, i, r, t, a, o, s, u, c) {
    this.aiDataContract = {
      ver: 1,
      metrics: 1,
      properties: 0
    };
    var l = this;
    l.ver = 2;
    var g = new C0();
    g[qt] = t > 0 ? t : void 0, g.max = isNaN(o) || o === null ? void 0 : o, g.min = isNaN(a) || a === null ? void 0 : a, g[gi] = fn(n, i) || bi, g.value = r, g.stdDev = isNaN(s) || s === null ? void 0 : s, l.metrics = [g], l[Ji] = yt(n, u), l[Qi] = Nt(n, c);
  }
  return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric", e.dataType = "MetricData", e;
}(), qo = "";
function Dr(e) {
  (isNaN(e) || e < 0) && (e = 0), e = Math.round(e);
  var n = qo + e % 1e3, i = qo + Math.floor(e / 1e3) % 60, r = qo + Math.floor(e / (1e3 * 60)) % 60, t = qo + Math.floor(e / (1e3 * 60 * 60)) % 24, a = Math.floor(e / (1e3 * 60 * 60 * 24));
  return n = n[me] === 1 ? "00" + n : n[me] === 2 ? "0" + n : n, i = i[me] < 2 ? "0" + i : i, r = r[me] < 2 ? "0" + r : r, t = t[me] < 2 ? "0" + t : t, (a > 0 ? a + "." : qo) + t + ":" + r + ":" + i + "." + n;
}
function D0(e, n, i, r, t) {
  return !t && he(e) && (e === "Script error." || e === "Script error");
}
var Mr = function() {
  function e(n, i, r, t, a, o, s) {
    this.aiDataContract = {
      ver: 1,
      name: 0,
      url: 0,
      duration: 0,
      properties: 0,
      measurements: 0,
      id: 0
    };
    var u = this;
    u.ver = 2, u.id = z_(n, s), u.url = nc(n, r), u[gi] = fn(n, i) || bi, isNaN(t) || (u[Mu] = Dr(t)), u[Ji] = yt(n, a), u[Qi] = Nt(n, o);
  }
  return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview", e.dataType = "PageviewData", e;
}(), Ct = function() {
  function e(n, i, r, t, a, o, s, u, c, l, g, R) {
    c === void 0 && (c = "Ajax"), this.aiDataContract = {
      id: 1,
      ver: 1,
      name: 0,
      resultCode: 0,
      duration: 0,
      success: 0,
      data: 0,
      target: 0,
      type: 0,
      properties: 0,
      measurements: 0,
      kind: 0,
      value: 0,
      count: 0,
      min: 0,
      max: 0,
      stdDev: 0,
      dependencyKind: 0,
      dependencySource: 0,
      commandName: 0,
      dependencyTypeName: 0
    };
    var v = this;
    v.ver = 2, v.id = i, v[Mu] = Dr(a), v.success = o, v.resultCode = s + "", v.type = fn(n, c);
    var f = Z_(n, r, u, t);
    v.data = nc(n, t) || f.data, v.target = fn(n, f.target), l && (v.target = "".concat(v.target, " | ").concat(l)), v[gi] = fn(n, f[gi]), v[Ji] = yt(n, g), v[Qi] = Nt(n, R);
  }
  return e.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency", e.dataType = "RemoteDependencyData", e;
}(), So = function() {
  function e(n, i, r, t, a) {
    this.aiDataContract = {
      ver: 1,
      message: 1,
      severityLevel: 0,
      properties: 0
    };
    var o = this;
    o.ver = 2, i = i || bi, o[Er] = TC(n, i), o[Ji] = yt(n, t), o[Qi] = Nt(n, a), r && (o[Da] = r);
  }
  return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Message", e.dataType = "MessageData", e;
}(), To = function() {
  function e(n, i, r, t, a, o, s) {
    this.aiDataContract = {
      ver: 1,
      name: 0,
      url: 0,
      duration: 0,
      perfTotal: 0,
      networkConnect: 0,
      sentRequest: 0,
      receivedResponse: 0,
      domProcessing: 0,
      properties: 0,
      measurements: 0
    };
    var u = this;
    u.ver = 2, u.url = nc(n, r), u[gi] = fn(n, i) || bi, u[Ji] = yt(n, a), u[Qi] = Nt(n, o), s && (u.domProcessing = s.domProcessing, u[Mu] = s[Mu], u.networkConnect = s.networkConnect, u.perfTotal = s.perfTotal, u[Qg] = s[Qg], u.sentRequest = s.sentRequest);
  }
  return e.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance", e.dataType = "PageviewPerformanceData", e;
}(), It = function() {
  function e(n, i) {
    this.aiDataContract = {
      baseType: 1,
      baseData: 1
    }, this.baseType = n, this.baseData = i;
  }
  return e;
}();
function Br(e) {
  var n = "ai." + e + ".";
  return function(i) {
    return n + i;
  };
}
var Jo = Br("application"), gn = Br("device"), _s = Br("location"), Bt = Br("operation"), rl = Br("session"), ar = Br("user"), Kr = Br("cloud"), Qo = Br("internal"), OC = function(e) {
  Fi(n, e);
  function n() {
    return e.call(this) || this;
  }
  return n;
}(cw({
  applicationVersion: Jo("ver"),
  applicationBuild: Jo("build"),
  applicationTypeId: Jo("typeId"),
  applicationId: Jo("applicationId"),
  applicationLayer: Jo("layer"),
  deviceId: gn("id"),
  deviceIp: gn("ip"),
  deviceLanguage: gn("language"),
  deviceLocale: gn("locale"),
  deviceModel: gn("model"),
  deviceFriendlyName: gn("friendlyName"),
  deviceNetwork: gn("network"),
  deviceNetworkName: gn("networkName"),
  deviceOEMName: gn("oemName"),
  deviceOS: gn("os"),
  deviceOSVersion: gn("osVersion"),
  deviceRoleInstance: gn("roleInstance"),
  deviceRoleName: gn("roleName"),
  deviceScreenResolution: gn("screenResolution"),
  deviceType: gn("type"),
  deviceMachineName: gn("machineName"),
  deviceVMName: gn("vmName"),
  deviceBrowser: gn("browser"),
  deviceBrowserVersion: gn("browserVersion"),
  locationIp: _s("ip"),
  locationCountry: _s("country"),
  locationProvince: _s("province"),
  locationCity: _s("city"),
  operationId: Bt("id"),
  operationName: Bt("name"),
  operationParentId: Bt("parentId"),
  operationRootId: Bt("rootId"),
  operationSyntheticSource: Bt("syntheticSource"),
  operationCorrelationVector: Bt("correlationVector"),
  sessionId: rl("id"),
  sessionIsFirst: rl("isFirst"),
  sessionIsNew: rl("isNew"),
  userAccountAcquisitionDate: ar("accountAcquisitionDate"),
  userAccountId: ar("accountId"),
  userAgent: ar("userAgent"),
  userId: ar("id"),
  userStoreRegion: ar("storeRegion"),
  userAuthUserId: ar("authUserId"),
  userAnonymousUserAcquisitionDate: ar("anonUserAcquisitionDate"),
  userAuthenticatedUserAcquisitionDate: ar("authUserAcquisitionDate"),
  cloudName: Kr("name"),
  cloudRole: Kr("role"),
  cloudRoleVer: Kr("roleVer"),
  cloudRoleInstance: Kr("roleInstance"),
  cloudEnvironment: Kr("environment"),
  cloudLocation: Kr("location"),
  cloudDeploymentUnit: Kr("deploymentUnit"),
  internalNodeName: Qo("nodeName"),
  internalSdkVersion: Qo("sdkVersion"),
  internalAgentVersion: Qo("agentVersion"),
  internalSnippet: Qo("snippet"),
  internalSdkSrc: Qo("sdkSrc")
}));
function vr(e, n, i, r, t, a) {
  var o;
  i = fn(r, i) || bi, (z(e) || z(n) || z(i)) && $n("Input doesn't contain all required fields");
  var s = "";
  e[Kc] && (s = e[Kc], delete e[Kc]);
  var u = (o = {}, o[gi] = i, o.time = Fo(new Date()), o.iKey = s, o.ext = a || {}, o.tags = [], o.data = {}, o.baseType = n, o.baseData = e, o);
  return z(t) || Te(t, function(c, l) {
    u.data[c] = l;
  }), u;
}
var zn = {
  UserExt: "user",
  DeviceExt: "device",
  TraceExt: "trace",
  WebExt: "web",
  AppExt: "app",
  OSExt: "os",
  SessionExt: "ses",
  SDKExt: "sdk"
}, Xe = new OC();
function Zo(e) {
  var n = null;
  if (_e(Event))
    n = new Event(e);
  else {
    var i = Tn();
    i && i.createEvent && (n = i.createEvent("Event"), n.initEvent(e, !0, !0));
  }
  return n;
}
var tc = "AppInsightsPropertiesPlugin", kC = "AppInsightsChannelPlugin", kf = "ApplicationInsightsAnalytics", Au = "toString", hv = "isStorageUseDisabled", Gt = "_addHook", pn = "core", sr = "dataType", Wr = "envelopeType", Hn = "diagLog", Xr = "track", Hs = "trackPageView", wv = "trackPreviousPageVisit", tt = "sendPageViewInternal", ko = "startTime", _v = "properties", wi = "duration", Ev = "sendPageViewPerformanceInternal", Uf = "populatePageViewPerformanceEvent", Jt = "href", aR = "sendExceptionInternal", tl = "exception", ea = "error", ol = "_onerror", al = "errorSrc", sl = "lineNumber", ul = "columnNumber", sR = "message", cl = "CreateAutoException", Es = "addTelemetryInitializer", p0 = "overridePageViewDuration", UC = "autoTrackPageVisitTime", YC = "isBrowserLinkTrackingEnabled", $a = "length", xC = "enableAutoRouteTracking", BC = "enableUnhandledPromiseRejectionTracking", mv = "autoUnhandledPromiseInstrumented", Sv = "getEntriesByType", GC = "isPerformanceTimingSupported", VC = "getPerformanceTiming", Fu = "navigationStart", Tv = "shouldCollectDuration", HC = "isPerformanceTimingDataReady", pa = "responseStart", h0 = "requestStart", zs = "loadEventEnd", yv = "responseEnd", $s = "connectEnd", zC = "pageVisitStartTime", w0 = function() {
  function e(n, i, r, t) {
    We(e, this, function(a) {
      var o = null, s = [], u = !1, c = !1, l;
      r && (l = r.logger);
      function g(f) {
        r && r.flush(f, function() {
        });
      }
      function R() {
        o || (o = Di(function() {
          o = null;
          var f = s.slice(0), p = !1;
          s = [], se(f, function(D) {
            D() ? p = !0 : s.push(D);
          }), s[$a] > 0 && R(), p && g(!0);
        }, 100));
      }
      function v(f) {
        s.push(f), R();
      }
      a[Hs] = function(f, p) {
        var D = f.name;
        if (z(D) || typeof D != "string") {
          var C = Tn();
          D = f.name = C && C.title || "";
        }
        var _ = f.uri;
        if (z(_) || typeof _ != "string") {
          var E = $i();
          _ = f.uri = E && E[Jt] || "";
        }
        if (!c) {
          var N = Zi(), O = N && N[Sv] && N[Sv]("navigation");
          if (O && O[0] && !qe(N.timeOrigin)) {
            var d = O[0].loadEventStart;
            f[ko] = new Date(N.timeOrigin + d);
          } else {
            var m = (p || f[_v] || {})[wi] || 0;
            f[ko] = new Date(new Date().getTime() - m);
          }
          c = !0;
        }
        if (!t[GC]()) {
          n[tt](f, p), g(!0), Rd() || Q(l, 2, 25, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
          return;
        }
        var y = !1, Y, k = t[VC]()[Fu];
        k > 0 && (Y = Yn(k, +new Date()), t[Tv](Y) || (Y = void 0));
        var J;
        !z(p) && !z(p[wi]) && (J = p[wi]), (i || !isNaN(J)) && (isNaN(J) && (p || (p = {}), p[wi] = Y), n[tt](f, p), g(!0), y = !0);
        var te = 6e4;
        p || (p = {}), v(function() {
          var I = !1;
          try {
            if (t[HC]()) {
              I = !0;
              var T = {
                name: D,
                uri: _
              };
              t[Uf](T), !T.isValid && !y ? (p[wi] = Y, n[tt](f, p)) : (y || (p[wi] = T.durationMs, n[tt](f, p)), u || (n[Ev](T, p), u = !0));
            } else
              k > 0 && Yn(k, +new Date()) > te && (I = !0, y || (p[wi] = te, n[tt](f, p)));
          } catch (j) {
            Q(l, 1, 38, "trackPageView failed on page load calculation: " + Ue(j), { exception: ae(j) });
          }
          return I;
        });
      }, a.teardown = function(f, p) {
        if (o) {
          o.cancel(), o = null;
          var D = s.slice(0);
          s = [], se(D, function(C) {
            C();
          });
        }
      };
    });
  }
  return e.__ieDyn = 1, e;
}(), _0 = 36e5, uR = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function $C() {
  var e = Zi();
  return e && !!e.timing;
}
function E0() {
  var e = Zi();
  return e && e.getEntriesByType && e.getEntriesByType("navigation")[$a] > 0;
}
function m0() {
  var e = Zi(), n = e ? e.timing : 0;
  return n && n.domainLookupStart > 0 && n[Fu] > 0 && n[pa] > 0 && n[h0] > 0 && n[zs] > 0 && n[yv] > 0 && n[$s] > 0 && n.domLoading > 0;
}
function cR() {
  return $C() ? Zi().timing : null;
}
function S0() {
  return E0() ? Zi()[Sv]("navigation")[0] : null;
}
function T0() {
  for (var e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  var i = Ai() || {}, r = i.userAgent, t = !1;
  if (r)
    for (var a = 0; a < uR[$a]; a++)
      t = t || Gn(r.toLowerCase(), uR[a]) !== -1;
  if (t)
    return !1;
  for (var a = 0; a < e[$a]; a++)
    if (e[a] < 0 || e[a] >= _0)
      return !1;
  return !0;
}
var y0 = function() {
  function e(n) {
    var i = St(n);
    We(e, this, function(r) {
      r[Uf] = function(t) {
        t.isValid = !1;
        var a = S0(), o = cR(), s = 0, u = 0, c = 0, l = 0, g = 0;
        (a || o) && (a ? (s = a[wi], u = a[ko] === 0 ? a[$s] : Yn(a[ko], a[$s]), c = Yn(a.requestStart, a[pa]), l = Yn(a[pa], a[yv]), g = Yn(a.responseEnd, a[zs])) : (s = Yn(o[Fu], o[zs]), u = Yn(o[Fu], o[$s]), c = Yn(o.requestStart, o[pa]), l = Yn(o[pa], o[yv]), g = Yn(o.responseEnd, o[zs])), s === 0 ? Q(i, 2, 10, "error calculating page view performance.", { total: s, network: u, request: c, response: l, dom: g }) : r[Tv](s, u, c, l, g) ? s < Math.floor(u) + Math.floor(c) + Math.floor(l) + Math.floor(g) ? Q(i, 2, 8, "client performance math error.", { total: s, network: u, request: c, response: l, dom: g }) : (t.durationMs = s, t.perfTotal = t[wi] = Dr(s), t.networkConnect = Dr(u), t.sentRequest = Dr(c), t.receivedResponse = Dr(l), t.domProcessing = Dr(g), t.isValid = !0) : Q(i, 2, 45, "Invalid page load duration value. Browser perf data won't be sent.", { total: s, network: u, request: c, response: l, dom: g }));
      }, r[VC] = cR, r[GC] = $C, r[HC] = m0, r[Tv] = T0;
    });
  }
  return e.__ieDyn = 1, e;
}(), N0 = function() {
  function e(n, i) {
    var r = "prevPageVisitData";
    We(e, this, function(t) {
      t[wv] = function(s, u) {
        try {
          var c = a(s, u);
          c && i(c.pageName, c.pageUrl, c.pageVisitTime);
        } catch (l) {
          ho(n, "Auto track page visit time failed, metric will not be collected: " + ae(l));
        }
      };
      function a(s, u) {
        var c = null;
        try {
          if (c = o(), za()) {
            Rv(n, r) != null && $n("Cannot call startPageVisit consecutively without first calling stopPageVisit");
            var l = vi().stringify(new I0(s, u));
            PC(n, r, l);
          }
        } catch (g) {
          ho(n, "Call to restart failed: " + ae(g)), c = null;
        }
        return c;
      }
      function o() {
        var s = null;
        try {
          if (za()) {
            var u = Ni(), c = Rv(n, r);
            c && Za() && (s = vi().parse(c), s.pageVisitTime = u - s[zC], r0(n, r));
          }
        } catch (l) {
          ho(n, "Stop page visit timer failed: " + ae(l)), s = null;
        }
        return s;
      }
      xe(t, "_logger", { g: function() {
        return n;
      } }), xe(t, "pageVisitTimeTrackingHandler", { g: function() {
        return i;
      } });
    });
  }
  return e.__ieDyn = 1, e;
}(), I0 = function() {
  function e(n, i) {
    this[zC] = Ni(), this.pageName = n, this.pageUrl = i;
  }
  return e;
}(), lR = function() {
  function e(n, i) {
    var r = this, t = {};
    r.start = function(a) {
      typeof t[a] != "undefined" && Q(n, 2, 62, "start was called more than once for this event without calling stop.", { name: a, key: a }, !0), t[a] = +new Date();
    }, r.stop = function(a, o, s, u) {
      var c = t[a];
      if (isNaN(c))
        Q(n, 2, 63, "stop was called without a corresponding start.", { name: a, key: a }, !0);
      else {
        var l = +new Date(), g = Yn(c, l);
        r.action(a, o, g, s, u);
      }
      delete t[a], t[a] = void 0;
    };
  }
  return e;
}(), Un, b0 = "event";
function na(e, n) {
  e && e.dispatchEvent && n && e.dispatchEvent(n);
}
function M0(e) {
  if (e && e.reason) {
    var n = e.reason;
    return !he(n) && _e(n[Au]) ? n[Au]() : ae(n);
  }
  return e || "";
}
var vR = 6e4, P0 = ir((Un = {
  sessionRenewalMs: hg(fR, 30 * 60 * 1e3),
  sessionExpirationMs: hg(fR, 24 * 60 * 60 * 1e3),
  disableExceptionTracking: vn()
}, Un[UC] = vn(), Un[p0] = vn(), Un[BC] = vn(), Un[mv] = !1, Un.samplingPercentage = _u(A0, 100), Un[hv] = vn(), Un[YC] = vn(), Un[xC] = vn(), Un.namePrefix = zw(), Un.enableDebug = vn(), Un.disableFlushOnBeforeUnload = vn(), Un.disableFlushOnUnload = vn(!1, "disableFlushOnBeforeUnload"), Un));
function fR(e, n) {
  return e = e || n, e < vR && (e = vR), +e;
}
function A0(e) {
  return !isNaN(e) && e > 0 && e <= 100;
}
function F0(e) {
  qe(e[hv]) || (e[hv] ? e0() : n0());
}
var L0 = function(e) {
  Fi(n, e);
  function n() {
    var i = e.call(this) || this;
    i.identifier = kf, i.priority = 180, i.autoRoutePVDelay = 500;
    var r, t, a, o, s, u, c, l, g, R, v, f, p, D, C, _, E, N, O;
    return We(n, i, function(d, m) {
      var y = m[Gt];
      P(), d.getCookieMgr = function() {
        return Zu(d[pn]);
      }, d.processTelemetry = function(S, M) {
        d.processNext(S, M);
      }, d.trackEvent = function(S, M) {
        try {
          var L = vr(S, Cr[sr], Cr[Wr], d[Hn](), M);
          d[pn][Xr](L);
        } catch (V) {
          Ce(2, 39, "trackTrace failed, trace will not be collected: " + Ue(V), { exception: ae(V) });
        }
      }, d.startTrackEvent = function(S) {
        try {
          r.start(S);
        } catch (M) {
          Ce(1, 29, "startTrackEvent failed, event will not be collected: " + Ue(M), { exception: ae(M) });
        }
      }, d.stopTrackEvent = function(S, M, L) {
        try {
          r.stop(S, void 0, M, L);
        } catch (V) {
          Ce(1, 30, "stopTrackEvent failed, event will not be collected: " + Ue(V), { exception: ae(V) });
        }
      }, d.trackTrace = function(S, M) {
        try {
          var L = vr(S, So[sr], So[Wr], d[Hn](), M);
          d[pn][Xr](L);
        } catch (V) {
          Ce(2, 39, "trackTrace failed, trace will not be collected: " + Ue(V), { exception: ae(V) });
        }
      }, d.trackMetric = function(S, M) {
        try {
          var L = vr(S, dt[sr], dt[Wr], d[Hn](), M);
          d[pn][Xr](L);
        } catch (V) {
          Ce(1, 36, "trackMetric failed, metric will not be collected: " + Ue(V), { exception: ae(V) });
        }
      }, d[Hs] = function(S, M) {
        try {
          var L = S || {};
          a[Hs](L, Fn(Fn(Fn({}, L.properties), L.measurements), M)), _ && s[wv](L.name, L.uri);
        } catch (V) {
          Ce(1, 37, "trackPageView failed, page view will not be collected: " + Ue(V), { exception: ae(V) });
        }
      }, d[tt] = function(S, M, L) {
        var V = Tn();
        if (V && (S.refUri = S.refUri === void 0 ? V.referrer : S.refUri), z(S[ko])) {
          var ie = (M || S[_v] || {})[wi] || 0;
          S[ko] = new Date(new Date().getTime() - ie);
        }
        var pe = vr(S, Mr[sr], Mr[Wr], d[Hn](), M, L);
        d[pn][Xr](pe);
      }, d[Ev] = function(S, M, L) {
        var V = vr(S, To[sr], To[Wr], d[Hn](), M, L);
        d[pn][Xr](V);
      }, d.trackPageViewPerformance = function(S, M) {
        var L = S || {};
        try {
          o[Uf](L), d[Ev](L, M);
        } catch (V) {
          Ce(1, 37, "trackPageViewPerformance failed, page view will not be collected: " + Ue(V), { exception: ae(V) });
        }
      }, d.startTrackPage = function(S) {
        try {
          if (typeof S != "string") {
            var M = Tn();
            S = M && M.title || "";
          }
          t.start(S);
        } catch (L) {
          Ce(1, 31, "startTrackPage failed, page view may not be collected: " + Ue(L), { exception: ae(L) });
        }
      }, d.stopTrackPage = function(S, M, L, V) {
        try {
          if (typeof S != "string") {
            var ie = Tn();
            S = ie && ie.title || "";
          }
          if (typeof M != "string") {
            var pe = $i();
            M = pe && pe[Jt] || "";
          }
          t.stop(S, M, L, V), _ && s[wv](S, M);
        } catch (Se) {
          Ce(1, 32, "stopTrackPage failed, page view will not be collected: " + Ue(Se), { exception: ae(Se) });
        }
      }, d[aR] = function(S, M, L) {
        var V = S && (S[tl] || S[ea]) || ju(S) && S || { name: S && typeof S, message: S || bi };
        S = S || {};
        var ie = new Jn(d[Hn](), V, S[_v] || M, S.measurements, S.severityLevel, S.id).toInterface(), pe = vr(ie, Jn[sr], Jn[Wr], d[Hn](), M, L);
        d[pn][Xr](pe);
      }, d.trackException = function(S, M) {
        S && !S[tl] && S[ea] && (S[tl] = S[ea]);
        try {
          d[aR](S, M);
        } catch (L) {
          Ce(1, 35, "trackException failed, exception will not be collected: " + Ue(L), { exception: ae(L) });
        }
      }, d[ol] = function(S) {
        var M = S && S[ea], L = S && S.evt;
        try {
          if (!L) {
            var V = jn();
            V && (L = V[b0]);
          }
          var ie = S && S.url || (Tn() || {}).URL, pe = S[al] || "window.onerror@" + ie + ":" + (S[sl] || 0) + ":" + (S[ul] || 0), Se = {
            errorSrc: pe,
            url: ie,
            lineNumber: S[sl] || 0,
            columnNumber: S[ul] || 0,
            message: S[sR]
          };
          D0(S.message, S.url, S.lineNumber, S.columnNumber, S[ea]) ? te(Jn[cl]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", ie, S[sl] || 0, S[ul] || 0, M, L, null, pe), Se) : (S[al] || (S[al] = pe), d.trackException({ exception: S, severityLevel: 3 }, Se));
        } catch (ke) {
          var Ie = M ? M.name + ", " + M[sR] : "null";
          Ce(1, 11, "_onError threw exception while logging error, error will not be collected: " + Ue(ke), { exception: ae(ke), errorString: Ie });
        }
      }, d[Es] = function(S) {
        if (d[pn])
          return d[pn][Es](S);
        u || (u = []), u.push(S);
      }, d.initialize = function(S, M, L, V) {
        if (!d.isInitialized()) {
          z(M) && $n("Error initializing"), m.initialize(S, M, L, V);
          try {
            O = xr(ii(d.identifier), M.evtNamespace && M.evtNamespace()), u && (se(u, function(ie) {
              M[Es](ie);
            }), u = null), Y(S), o = new y0(d[pn]), a = new w0(d, C.overridePageViewDuration, d[pn], o), s = new N0(d[Hn](), function(ie, pe, Se) {
              return k(ie, pe, Se);
            }), r = new lR(d[Hn](), "trackEvent"), r.action = function(ie, pe, Se, Ie, ke) {
              Ie || (Ie = {}), ke || (ke = {}), Ie.duration = Se[Au](), d.trackEvent({ name: ie, properties: Ie, measurements: ke });
            }, t = new lR(d[Hn](), "trackPageView"), t.action = function(ie, pe, Se, Ie, ke) {
              z(Ie) && (Ie = {}), Ie.duration = Se[Au]();
              var Qe = {
                name: ie,
                uri: pe,
                properties: Ie,
                measurements: ke
              };
              d[tt](Qe, Ie);
            }, Ku() && (I(), T());
          } catch (ie) {
            throw d.setInitialized(!1), ie;
          }
        }
      }, d._doTeardown = function(S, M) {
        a && a.teardown(S, M), _o(window, null, null, O), P();
      };
      function Y(S) {
        var M = d.identifier, L = d[pn];
        d[Gt](tn(S, function() {
          var V = fi(null, S, L);
          C = V.getExtCfg(M, P0), _ = C[UC], S.storagePrefix && Of(S.storagePrefix), F0(C), c = C[YC], J();
        }));
      }
      function k(S, M, L) {
        var V = { PageName: S, PageUrl: M };
        d.trackMetric({
          name: "PageVisitTime",
          average: L,
          max: L,
          min: L,
          sampleCount: 1
        }, V);
      }
      function J() {
        if (!l && c) {
          var S = ["/browserLinkSignalR/", "/__browserLink/"], M = function(L) {
            if (c && L.baseType === Ct[sr]) {
              var V = L.baseData;
              if (V) {
                for (var ie = 0; ie < S[$a]; ie++)
                  if (V.target && Gn(V.target, S[ie]) >= 0)
                    return !1;
              }
            }
            return !0;
          };
          d[Gt](d[Es](M)), l = !0;
        }
      }
      function te(S, M) {
        var L = vr(S, Jn[sr], Jn[Wr], d[Hn](), M);
        d[pn][Xr](L);
      }
      function I() {
        var S = jn(), M = $i(!0);
        d[Gt](tn(C, function() {
          v = C.disableExceptionTracking, !v && !f && !C.autoExceptionInstrumented && (y(ps(S, "onerror", {
            ns: O,
            rsp: function(L, V, ie, pe, Se, Ie) {
              !v && L.rslt !== !0 && d[ol](Jn[cl](V, ie, pe, Se, Ie, L.evt));
            }
          }, !1)), f = !0);
        })), B(S, M);
      }
      function T() {
        var S = jn(), M = $i(!0);
        d[Gt](tn(C, function() {
          if (g = C[xC] === !0, S && g && !R && ah()) {
            var L = gd();
            _e(L.pushState) && _e(L.replaceState) && typeof Event !== Rf && oe(S, L, M);
          }
        }));
      }
      function j() {
        var S = null;
        if (d[pn] && d[pn].getTraceCtx && (S = d[pn].getTraceCtx(!1)), !S) {
          var M = d[pn].getPlugin(tc);
          if (M) {
            var L = M.plugin.context;
            L && (S = Af(L.telemetryTrace));
          }
        }
        return S;
      }
      function oe(S, M, L) {
        if (R)
          return;
        var V = C.namePrefix || "";
        function ie() {
          g && na(S, Zo(V + "locationchange"));
        }
        function pe() {
          if (N && (E = N), N = L && L[Jt] || "", g) {
            var Se = j();
            if (Se) {
              Se.setTraceId(_r());
              var Ie = "_unknown_";
              L && L.pathname && (Ie = L.pathname + (L.hash || "")), Se.setName(fn(d[Hn](), Ie));
            }
            Di(function(ke) {
              d[Hs]({ refUri: ke, properties: { duration: 0 } });
            }.bind(d, E), d.autoRoutePVDelay);
          }
        }
        y(ps(M, "pushState", {
          ns: O,
          rsp: function() {
            g && (na(S, Zo(V + "pushState")), na(S, Zo(V + "locationchange")));
          }
        }, !0)), y(ps(M, "replaceState", {
          ns: O,
          rsp: function() {
            g && (na(S, Zo(V + "replaceState")), na(S, Zo(V + "locationchange")));
          }
        }, !0)), qi(S, V + "popstate", ie, O), qi(S, V + "locationchange", pe, O), R = !0;
      }
      function B(S, M) {
        d[Gt](tn(C, function() {
          p = C[BC] === !0, f = f || C[mv], p && !D && (y(ps(S, "onunhandledrejection", {
            ns: O,
            rsp: function(L, V) {
              p && L.rslt !== !0 && d[ol](Jn[cl](M0(V), M ? M[Jt] : "", 0, 0, V, L.evt));
            }
          }, !1)), C[mv] = D = !0);
        }));
      }
      function Ce(S, M, L, V, ie) {
        d[Hn]().throwInternal(S, M, L, V, ie);
      }
      function P() {
        r = null, t = null, a = null, o = null, s = null, u = null, c = !1, l = !1, g = !1, R = !1, v = !1, f = !1, p = !1, D = !1, _ = !1;
        var S = $i(!0);
        E = S && S[Jt] || "", N = null, O = null, C = null, xe(d, "config", {
          g: function() {
            return C;
          }
        });
      }
      xe(d, "_pageViewManager", { g: function() {
        return a;
      } }), xe(d, "_pageViewPerformanceManager", { g: function() {
        return o;
      } }), xe(d, "_pageVisitTimeManager", { g: function() {
        return s;
      } }), xe(d, "_evtNamespace", { g: function() {
        return "." + O;
      } });
    }), i;
  }
  return n.Version = "3.0.6", n;
}(Tt), js = "featureOptIn", jC = "onCfgChangeReceive", KC = "nonOverrideConfigs", WC = "scheduleFetchTimeout";
function XC(e, n, i, r) {
  try {
    var t = i > r;
    t && (e = null);
    var a = i == 0 ? yh({}, e) : e;
    return a && n && !t && Te(a, function(o) {
      var s = n[o];
      s && (Ln(a[o]) && Ln(s) ? a[o] = XC(a[o], s, ++i, r) : delete a[o]);
    }), a;
  } catch (o) {
  }
  return e;
}
var yo = "featureOptIn.", qC = ".mode", JC = ".onCfg", QC = ".offCfg";
function O0(e, n, i) {
  var r;
  if (!n || !n.enabled)
    return null;
  var t = (n[js] || {})[e] || { mode: 1 }, a = t.mode, o = t.onCfg, s = t.offCfg, u = (i || {})[e] || { mode: 2 }, c = u.mode, l = u.onCfg, g = u.offCfg, R = !!u.blockCdnCfg, v = yo + e + qC, f = yo + e + JC, p = yo + e + QC, D = c, C = l, _ = g;
  return R || (a === 4 || a === 5 ? (D = a == 4 ? 3 : 2, C = o || l, _ = s || g) : a === 2 || c === 2 ? (D = 2, C = l || o, _ = g || s) : a === 3 ? (D = 3, C = l || o, _ = g || s) : a === 1 && c === 1 && (D = 1)), r = {}, r[v] = D, r[f] = C, r[p] = _, r;
}
function k0(e, n) {
  try {
    if (!e || !e.enabled)
      return null;
    if (!e[js])
      return e.config;
    var i = e[js], r = e.config || {};
    return Te(i, function(t) {
      var a = O0(t, e, n.config[js]);
      z(a) || (Te(a, function(o, s) {
        md(r, o, s);
      }), U0(t, a, r));
    }), r;
  } catch (t) {
  }
  return null;
}
function U0(e, n, i) {
  var r = n[yo + e + qC], t = n[yo + e + JC], a = n[yo + e + QC], o = null;
  r === 3 && (o = t), r === 2 && (o = a), o && Te(o, function(s, u) {
    md(i, s, u);
  });
}
var ia, Y0 = "ai_cfgsync", gR = "GET", x0 = 18e5, Vt = void 0, B0 = { instrumentationKey: !0, connectionString: !0, endpointUrl: !0 }, G0 = ir((ia = {
  syncMode: 1,
  blkCdnCfg: Vt,
  customEvtName: Vt,
  cfgUrl: Vt,
  overrideSyncFn: Vt,
  overrideFetchFn: Vt
}, ia[jC] = Vt, ia[WC] = x0, ia[KC] = B0, ia)), V0 = function(e) {
  Fi(n, e);
  function n() {
    var i = e.call(this) || this;
    i.priority = 198, i.identifier = "AppInsightsCfgSyncPlugin";
    var r, t, a, o, s, u, c, l, g, R, v, f, p, D, C, _, E = !1;
    return We(n, i, function(N, O) {
      d(), N.initialize = function(M, L, V, ie) {
        O.initialize(M, L, V, ie), o = xr(ii(N.identifier), L.evtNamespace && L.evtNamespace()), m(M);
      }, N.getCfg = function() {
        return t;
      }, N.pause = function() {
        E = !0, S();
      }, N.resume = function() {
        E = !1, P();
      }, N.setCfg = function(M) {
        return y(M);
      }, N.sync = function(M) {
        return k(M);
      }, N.updateEventListenerName = function(M) {
        return J(M);
      }, N._doTeardown = function(M, L) {
        Y(), S(), d();
      }, N._getDbgPlgTargets = function() {
        return [l, c, a, g];
      };
      function d() {
        t = null, a = null, o = null, s = null, c = null, l = null, p = null, u = null, R = null, v = null, g = null, C = null, _ = null, f = null;
      }
      function m(M) {
        var L = N.identifier, V = N.core;
        N._addHook(tn(M, function() {
          var ie = fi(null, M, V);
          r = ie.getExtCfg(L, G0);
          var pe = g;
          g = !!r.blkCdnCfg, !z(pe) && pe !== g && (!g && s ? D && D(s, j, l) : S()), z(c) && (c = r.syncMode === 2), z(l) && (l = r.syncMode === 1);
          var Se = r.customEvtName || Y0;
          a !== Se && (c ? J(Se) : (Y(), a = Se)), z(s) && (s = r.cfgUrl), s || (t = M, l && k());
        })), _ = r.overrideSyncFn, C = r.overrideFetchFn, f = r[jC], p = r[KC], R = r[WC], D = te(), v = 0, s && !g && D && D(s, j, l);
      }
      function y(M, L) {
        if (M) {
          if (t = M, !!L && !E)
            return k();
          if (c && !E)
            return N.core.updateCfg(M), !0;
        }
        return !1;
      }
      function Y() {
        try {
          var M = ei();
          M && _o(M, null, null, o);
        } catch (L) {
        }
      }
      function k(M) {
        try {
          return !!_ && _e(_) ? _(t, M) : Sw(a, t, M);
        } catch (L) {
        }
        return !1;
      }
      function J(M) {
        try {
          return Y(), M && (a = M, B()), !0;
        } catch (L) {
        }
        return !1;
      }
      function te() {
        var M = C;
        return z(M) && (rv() ? M = I : Ju() && (M = T)), M;
      }
      function I(M, L, V) {
        var ie = ei(), pe = ie && ie.fetch || null;
        if (M && pe && _e(pe))
          try {
            var Se = {
              method: gR
            }, Ie = new Request(M, Se);
            Ao(fetch(Ie), function(ke) {
              var Qe = ke.value;
              ke.rejected ? oe(L, 400) : Qe.ok ? Ao(Qe.text(), function(F) {
                oe(L, Qe.status, F.value, V);
              }) : oe(L, Qe.status, null, V);
            });
          } catch (ke) {
          }
      }
      function T(M, L, V) {
        try {
          var ie = new XMLHttpRequest();
          ie.open(gR, M), ie.onreadystatechange = function() {
            ie.readyState === XMLHttpRequest.DONE && oe(L, ie.status, ie.responseText, V);
          }, ie.onerror = function() {
            oe(L, 400);
          }, ie.ontimeout = function() {
            oe(L, 400);
          }, ie.send();
        } catch (pe) {
        }
      }
      function j(M, L, V) {
        try {
          if (M >= 200 && M < 400 && L) {
            v = 0;
            var ie = vi();
            if (ie) {
              var pe = ie.parse(L), Se = k0(pe, N.core);
              Se && y(Se, V);
            }
          } else
            v++;
          v < 3 && P();
        } catch (Ie) {
        }
      }
      function oe(M, L, V, ie) {
        try {
          M(L, V, ie);
        } catch (pe) {
        }
      }
      function B() {
        if (c) {
          var M = ei();
          if (M)
            try {
              qi(M, a, function(L) {
                var V = L && L.detail;
                if (f && V)
                  f(V);
                else {
                  var ie = V && V.cfg, pe = ie && Bn(ie) && Ce(ie);
                  pe && y(pe);
                }
              }, o, !0);
            } catch (L) {
            }
        }
      }
      function Ce(M, L) {
        var V = null;
        try {
          M && (V = XC(M, p, 0, 5));
        } catch (ie) {
        }
        return V;
      }
      function P() {
        !u && R && (u = Di(function() {
          u = null, D(s, j, l);
        }, R), u.unref());
      }
      function S() {
        u && u.cancel(), u = null, v = 0;
      }
      N.processTelemetry = function(M, L) {
        N.processNext(M, L);
      };
    }), i;
  }
  return n.__ieDyn = 1, n;
}(Tt), et = "duration", wn = "tags", ll = "deviceType", _n = "data", er = "name", ja = "traceID", Ne = "length", Ka = "stringify", bt = "measurements", yi = "dataType", Mt = "envelopeType", nt = "toString", ms = "onLine", Nv = "isOnline", ha = "_get", Dt = "enqueue", No = "count", ZC = "eventsLimitInMem", Io = "push", Iv = "emitLineDelimitedJson", pt = "clear", bv = "batchPayloads", Yf = "createNew", Lu = "markAsSent", Na = "clearSent", xf = "bufferOverride", vl = "BUFFER_KEY", ur = "SENT_BUFFER_KEY", ra = "MAX_BUFFER_SIZE", Mv = "sendPOST", ta = "triggerSend", hn = "diagLog", oa = "_sender", Pv = "customHeaders", eD = "maxBatchSizeInBytes", nD = "onunloadDisableBeacon", Av = "isBeaconApiDisabled", iD = "alwaysUseXhrOverride", rD = "enableSessionStorageBuffer", cr = "_buffer", tD = "onunloadDisableFetch", oD = "disableSendBeaconSplit", aD = "instrumentationKey", sD = "convertUndefined", uD = "maxBatchInterval", fl = "baseType", Ou = "sampleRate", H0 = "_xhrReadyStateChange", qr = "_onError", gl = "_onPartialSuccess", Ss = "_onSuccess", Ts = "itemsAccepted", z0 = "itemsReceived", aa = "oriPayload", Rl = "setRequestHeader", RR = "eventsSendRequest", cD = "getSamplingScore", $0 = "getHashCodeScore", dl = "baseType", Je = "baseData", dn = "properties", dR = "true";
function cn(e, n, i) {
  return je(e, n, i, eu);
}
function j0(e, n, i) {
  var r = i[wn] = i[wn] || {}, t = n.ext = n.ext || {}, a = n[wn] = n[wn] || [], o = t.user;
  o && (cn(r, Xe.userAuthUserId, o.authId), cn(r, Xe.userId, o.id || o.localId));
  var s = t.app;
  s && cn(r, Xe.sessionId, s.sesId);
  var u = t.device;
  u && (cn(r, Xe.deviceId, u.id || u.localId), cn(r, Xe[ll], u.deviceClass), cn(r, Xe.deviceIp, u.ip), cn(r, Xe.deviceModel, u.model), cn(r, Xe[ll], u[ll]));
  var c = n.ext.web;
  if (c) {
    cn(r, Xe.deviceLanguage, c.browserLang), cn(r, Xe.deviceBrowserVersion, c.browserVer), cn(r, Xe.deviceBrowser, c.browser);
    var l = i[_n] = i[_n] || {}, g = l[Je] = l[Je] || {}, R = g[dn] = g[dn] || {};
    cn(R, "domain", c.domain), cn(R, "isManual", c.isManual ? dR : null), cn(R, "screenRes", c.screenRes), cn(R, "userConsent", c.userConsent ? dR : null);
  }
  var v = t.os;
  v && cn(r, Xe.deviceOS, v[er]);
  var f = t.trace;
  f && (cn(r, Xe.operationParentId, f.parentID), cn(r, Xe.operationName, fn(e, f[er])), cn(r, Xe.operationId, f[ja]));
  for (var p = {}, D = a[Ne] - 1; D >= 0; D--) {
    var C = a[D];
    Te(C, function(E, N) {
      p[E] = N;
    }), a.splice(D, 1);
  }
  Te(a, function(E, N) {
    p[E] = N;
  });
  var _ = Fn(Fn({}, r), p);
  _[Xe.internalSdkVersion] || (_[Xe.internalSdkVersion] = fn(e, "javascript:".concat(K0.Version), 64)), i[wn] = Vd(_);
}
function Ur(e, n, i) {
  z(e) || Te(e, function(r, t) {
    $u(t) ? i[r] = t : he(t) ? n[r] = t : Za() && (n[r] = vi()[Ka](t));
  });
}
function Pt(e, n) {
  z(e) || Te(e, function(i, r) {
    e[i] = r || n;
  });
}
function At(e, n, i, r) {
  var t = new c0(e, r, n);
  cn(t, "sampleRate", i[EC]), (i[Je] || {}).startTime && (t.time = Fo(i[Je].startTime)), t.iKey = i.iKey;
  var a = i.iKey.replace(/-/g, "");
  return t[er] = t[er].replace("{0}", a), j0(e, i, t), i[wn] = i[wn] || [], Vd(t);
}
function Ft(e, n) {
  z(n[Je]) && Q(e, 1, 46, "telemetryItem.baseData cannot be null.");
}
var K0 = {
  Version: "3.0.6"
};
function W0(e, n, i) {
  Ft(e, n);
  var r = n[Je][bt] || {}, t = n[Je][dn] || {};
  Ur(n[_n], t, r), z(i) || Pt(t, i);
  var a = n[Je];
  if (z(a))
    return ho(e, "Invalid input for dependency data"), null;
  var o = a[dn] && a[dn][Xg] ? a[dn][Xg] : "GET", s = new Ct(e, a.id, a.target, a[er], a[et], a.success, a.responseCode, o, a.type, a.correlationContext, t, r), u = new It(Ct[yi], s);
  return At(e, Ct[Mt], n, u);
}
function lD(e, n, i) {
  Ft(e, n);
  var r = {}, t = {};
  n[dl] !== Cr[yi] && (r.baseTypeSource = n[dl]), n[dl] === Cr[yi] ? (r = n[Je][dn] || {}, t = n[Je][bt] || {}) : n[Je] && Ur(n[Je], r, t), Ur(n[_n], r, t), z(i) || Pt(r, i);
  var a = n[Je][er], o = new Cr(e, a, r, t), s = new It(Cr[yi], o);
  return At(e, Cr[Mt], n, s);
}
function X0(e, n, i) {
  Ft(e, n);
  var r = n[Je][bt] || {}, t = n[Je][dn] || {};
  Ur(n[_n], t, r), z(i) || Pt(t, i);
  var a = n[Je], o = Jn.CreateFromInterface(e, a, t, r), s = new It(Jn[yi], o);
  return At(e, Jn[Mt], n, s);
}
function q0(e, n, i) {
  Ft(e, n);
  var r = n[Je], t = r[dn] || {}, a = r[bt] || {};
  Ur(n[_n], t, a), z(i) || Pt(t, i);
  var o = new dt(e, r[er], r.average, r.sampleCount, r.min, r.max, r.stdDev, t, a), s = new It(dt[yi], o);
  return At(e, dt[Mt], n, s);
}
function J0(e, n, i) {
  Ft(e, n);
  var r, t = n[Je];
  !z(t) && !z(t[dn]) && !z(t[dn][et]) ? (r = t[dn][et], delete t[dn][et]) : !z(n[_n]) && !z(n[_n][et]) && (r = n[_n][et], delete n[_n][et]);
  var a = n[Je], o;
  ((n.ext || {}).trace || {})[ja] && (o = n.ext.trace[ja]);
  var s = a.id || o, u = a[er], c = a.uri, l = a[dn] || {}, g = a[bt] || {};
  if (z(a.refUri) || (l.refUri = a.refUri), z(a.pageType) || (l.pageType = a.pageType), z(a.isLoggedIn) || (l.isLoggedIn = a.isLoggedIn[nt]()), !z(a[dn])) {
    var R = a[dn];
    Te(R, function(p, D) {
      l[p] = D;
    });
  }
  Ur(n[_n], l, g), z(i) || Pt(l, i);
  var v = new Mr(e, u, c, r, l, g, s), f = new It(Mr[yi], v);
  return At(e, Mr[Mt], n, f);
}
function Q0(e, n, i) {
  Ft(e, n);
  var r = n[Je], t = r[er], a = r.uri || r.url, o = r[dn] || {}, s = r[bt] || {};
  Ur(n[_n], o, s), z(i) || Pt(o, i);
  var u = new To(e, t, a, void 0, o, s, r), c = new It(To[yi], u);
  return At(e, To[Mt], n, c);
}
function Z0(e, n, i) {
  Ft(e, n);
  var r = n[Je].message, t = n[Je].severityLevel, a = n[Je][dn] || {}, o = n[Je][bt] || {};
  Ur(n[_n], a, o), z(i) || Pt(a, i);
  var s = new So(e, r, t, a, o), u = new It(So[yi], s);
  return At(e, So[Mt], n, u);
}
function CR(e, n) {
  _o(e, null, null, n);
}
function eE(e) {
  var n, i = Tn(), r = Ai(), t = !1, a = !0, o = xr(ii("OfflineListener"), e);
  try {
    if (u(jn()) && (t = !0), i) {
      var s = i.body || i;
      s.ononline && u(s) && (t = !0);
    }
    t && r && !z(r[ms]) && (a = r[ms]);
  } catch (v) {
    t = !1;
  }
  function u(v) {
    var f = !1;
    return v && (f = qi(v, "online", c, o), f && qi(v, "offline", l, o)), f;
  }
  function c() {
    a = !0;
  }
  function l() {
    a = !1;
  }
  function g() {
    var v = !0;
    return t ? v = a : r && !z(r[ms]) && (v = r[ms]), v;
  }
  function R() {
    var v = jn();
    if (v && t) {
      if (CR(v, o), i) {
        var f = i.body || i;
        qe(f.ononline) || CR(f, o);
      }
      t = !1;
    }
  }
  return n = {}, n[Nv] = g, n.isListening = function() {
    return t;
  }, n.unload = R, n;
}
var vD = function() {
  function e(n, i) {
    var r = [], t = !1;
    this[ha] = function() {
      return r;
    }, this._set = function(a) {
      return r = a, r;
    }, We(e, this, function(a) {
      a[Dt] = function(o) {
        if (a[No]() >= i[ZC]) {
          t || (Q(n, 2, 105, "Maximum in-memory buffer size reached: " + a[No](), !0), t = !0);
          return;
        }
        r[Io](o);
      }, a[No] = function() {
        return r[Ne];
      }, a.size = function() {
        for (var o = r[Ne], s = 0; s < r[Ne]; s++)
          o += r[s][Ne];
        return i[Iv] || (o += 2), o;
      }, a[pt] = function() {
        r = [], t = !1;
      }, a.getItems = function() {
        return r.slice(0);
      }, a[bv] = function(o) {
        if (o && o[Ne] > 0) {
          var s = i[Iv] ? o.join(`
`) : "[" + o.join(",") + "]";
          return s;
        }
        return null;
      }, a[Yf] = function(o, s, u) {
        var c = r.slice(0);
        o = o || n, s = s || {};
        var l = u ? new fD(o, s) : new Bf(o, s);
        return se(c, function(g) {
          l[Dt](g);
        }), l;
      };
    });
  }
  return e.__ieDyn = 1, e;
}(), Bf = function(e) {
  Fi(n, e);
  function n(i, r) {
    var t = e.call(this, i, r) || this;
    return We(n, t, function(a, o) {
      a[Lu] = function(s) {
        o[pt]();
      }, a[Na] = function(s) {
      };
    }), t;
  }
  return n.__ieDyn = 1, n;
}(vD), fD = function(e) {
  Fi(n, e);
  function n(i, r) {
    var t = e.call(this, i, r) || this, a = !1, o = r == null ? void 0 : r.namePrefix, s = r[xf] || { getItem: Rv, setItem: PC }, u = s.getItem, c = s.setItem;
    return We(n, t, function(l, g) {
      var R = D(n[vl]), v = D(n[ur]), f = l._set(R.concat(v));
      f[Ne] > n[ra] && (f[Ne] = n[ra]), C(n[ur], []), C(n[vl], f), l[Dt] = function(_) {
        if (l[No]() >= n[ra]) {
          a || (Q(i, 2, 67, "Maximum buffer size reached: " + l[No](), !0), a = !0);
          return;
        }
        g[Dt](_), C(n.BUFFER_KEY, l[ha]());
      }, l[pt] = function() {
        g[pt](), C(n.BUFFER_KEY, l[ha]()), C(n[ur], []), a = !1;
      }, l[Lu] = function(_) {
        C(n[vl], l._set(p(_, l[ha]())));
        var E = D(n[ur]);
        E instanceof Array && _ instanceof Array && (E = E.concat(_), E[Ne] > n[ra] && (Q(i, 1, 67, "Sent buffer reached its maximum size: " + E[Ne], !0), E[Ne] = n[ra]), C(n[ur], E));
      }, l[Na] = function(_) {
        var E = D(n[ur]);
        E = p(_, E), C(n[ur], E);
      }, l[Yf] = function(_, E, N) {
        N = !!N;
        var O = l[ha]().slice(0), d = D(n[ur]).slice(0);
        _ = _ || i, E = E || {}, l[pt]();
        var m = N ? new n(_, E) : new Bf(_, E);
        return se(O, function(y) {
          m[Dt](y);
        }), N && m[Lu](d), m;
      };
      function p(_, E) {
        var N = [];
        return se(E, function(O) {
          !_e(O) && Nn(_, O) === -1 && N[Io](O);
        }), N;
      }
      function D(_) {
        var E = _;
        try {
          E = o ? o + "_" + E : E;
          var N = u(i, E);
          if (N) {
            var O = vi().parse(N);
            if (he(O) && (O = vi().parse(O)), O && Me(O))
              return O;
          }
        } catch (d) {
          Q(i, 1, 42, " storage key: " + E + ", " + Ue(d), { exception: ae(d) });
        }
        return [];
      }
      function C(_, E) {
        var N = _;
        try {
          N = o ? o + "_" + N : N;
          var O = JSON[Ka](E);
          c(i, N, O);
        } catch (d) {
          c(i, N, JSON[Ka]([])), Q(i, 2, 41, " storage key: " + N + ", " + Ue(d) + ". Buffer cleared", { exception: ae(d) });
        }
      }
    }), t;
  }
  return n.BUFFER_KEY = "AI_buffer", n.SENT_BUFFER_KEY = "AI_sentBuffer", n.MAX_BUFFER_SIZE = 2e3, n;
}(vD), nE = function() {
  function e(n) {
    We(e, this, function(i) {
      i.serialize = function(o) {
        var s = r(o, "root");
        try {
          return vi()[Ka](s);
        } catch (u) {
          Q(n, 1, 48, u && _e(u[nt]) ? u[nt]() : "Error serializing object", null, !0);
        }
      };
      function r(o, s) {
        var u = "__aiCircularRefCheck", c = {};
        if (!o)
          return Q(n, 1, 48, "cannot serialize object because it is null or undefined", { name: s }, !0), c;
        if (o[u])
          return Q(n, 2, 50, "Circular reference detected while serializing object", { name: s }, !0), c;
        if (!o.aiDataContract) {
          if (s === "measurements")
            c = a(o, "number", s);
          else if (s === "properties")
            c = a(o, "string", s);
          else if (s === "tags")
            c = a(o, "string", s);
          else if (Me(o))
            c = t(o, s);
          else {
            Q(n, 2, 49, "Attempting to serialize an object which does not implement ISerializable", { name: s }, !0);
            try {
              vi()[Ka](o), c = o;
            } catch (l) {
              Q(n, 1, 48, l && _e(l[nt]) ? l[nt]() : "Error serializing object", null, !0);
            }
          }
          return c;
        }
        return o[u] = !0, Te(o.aiDataContract, function(l, g) {
          var R = _e(g) ? g() & 1 : g & 1, v = _e(g) ? g() & 4 : g & 4, f = g & 2, p = o[l] !== void 0, D = Ln(o[l]) && o[l] !== null;
          if (R && !p && !f)
            Q(n, 1, 24, "Missing required field specification. The field is required but not present on source", { field: l, name: s });
          else if (!v) {
            var C = void 0;
            D ? f ? C = t(o[l], l) : C = r(o[l], l) : C = o[l], C !== void 0 && (c[l] = C);
          }
        }), delete o[u], c;
      }
      function t(o, s) {
        var u;
        if (o)
          if (!Me(o))
            Q(n, 1, 54, `This field was specified as an array in the contract but the item is not an array.\r
`, { name: s }, !0);
          else {
            u = [];
            for (var c = 0; c < o[Ne]; c++) {
              var l = o[c], g = r(l, s + "[" + c + "]");
              u[Io](g);
            }
          }
        return u;
      }
      function a(o, s, u) {
        var c;
        return o && (c = {}, Te(o, function(l, g) {
          if (s === "string")
            g === void 0 ? c[l] = "undefined" : g === null ? c[l] = "null" : g[nt] ? c[l] = g[nt]() : c[l] = "invalid field: toString() is not defined.";
          else if (s === "number")
            if (g === void 0)
              c[l] = "undefined";
            else if (g === null)
              c[l] = "null";
            else {
              var R = parseFloat(g);
              isNaN(R) ? c[l] = "NaN" : c[l] = R;
            }
          else
            c[l] = "invalid field: " + u + " is of unknown type.", Q(n, 1, c[l], null, !0);
        })), c;
      }
    });
  }
  return e.__ieDyn = 1, e;
}(), iE = 8, rE = function() {
  function e() {
  }
  return e.prototype.getHashCodeScore = function(n) {
    var i = this.getHashCode(n) / e.INT_MAX_VALUE;
    return i * 100;
  }, e.prototype.getHashCode = function(n) {
    if (n === "")
      return 0;
    for (; n[Ne] < iE; )
      n = n.concat(n);
    for (var i = 5381, r = 0; r < n[Ne]; ++r)
      i = (i << 5) + i + n.charCodeAt(r), i = i & i;
    return Math.abs(i);
  }, e.INT_MAX_VALUE = 2147483647, e;
}(), tE = function() {
  function e() {
    var n = this, i = new rE(), r = new OC();
    n[cD] = function(t) {
      var a = 0;
      return t[wn] && t[wn][r.userId] ? a = i.getHashCodeScore(t[wn][r.userId]) : t.ext && t.ext.user && t.ext.user.id ? a = i[$0](t.ext.user.id) : t[wn] && t[wn][r.operationId] ? a = i.getHashCodeScore(t[wn][r.operationId]) : t.ext && t.ext.telemetryTrace && t.ext.telemetryTrace[ja] ? a = i.getHashCodeScore(t.ext.telemetryTrace[ja]) : a = Math.random() * 100, a;
    };
  }
  return e;
}(), oE = function() {
  function e(n, i) {
    this.INT_MAX_VALUE = 2147483647;
    var r = i || St(null);
    (n > 100 || n < 0) && (r.throwInternal(2, 58, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: n }, !0), n = 100), this[Ou] = n, this.samplingScoreGenerator = new tE();
  }
  return e.prototype.isSampledIn = function(n) {
    var i = this[Ou], r = !1;
    return i == null || i >= 100 || n.baseType === dt[yi] ? !0 : (r = this.samplingScoreGenerator[cD](n) < i, r);
  }, e;
}(), en, xi, pr = void 0, aE = 65e3;
function ys(e) {
  try {
    return e.responseText;
  } catch (n) {
  }
  return null;
}
function sE(e) {
  return e && e[Mv];
}
var DR = ir((en = {
  endpointUrl: _u(eu, bf + ya)
}, en[Iv] = vn(), en[uD] = 15e3, en[eD] = 102400, en.disableTelemetry = vn(), en[rD] = vn(!0), en.isRetryDisabled = vn(), en[Av] = vn(!0), en[oD] = vn(), en.disableXhr = vn(), en[tD] = vn(), en[nD] = vn(), en[aD] = pr, en.namePrefix = pr, en.samplingPercentage = _u(uE, 100), en[Pv] = pr, en[sD] = pr, en[ZC] = 1e4, en[xf] = !1, en.httpXHROverride = { isVal: sE, v: pr }, en[iD] = vn(), en));
function uE(e) {
  return !isNaN(e) && e > 0 && e <= 100;
}
var cE = (xi = {}, xi[Cr.dataType] = lD, xi[So.dataType] = Z0, xi[Mr.dataType] = J0, xi[To.dataType] = Q0, xi[Jn.dataType] = X0, xi[dt.dataType] = q0, xi[Ct.dataType] = W0, xi), lE = function(e) {
  Fi(n, e);
  function n() {
    var i = e.call(this) || this;
    i.priority = 1001, i.identifier = kC;
    var r, t, a, o, s, u, c, l, g = 0, R, v, f, p, D, C, _, E, N, O, d, m, y, Y, k, J, te, I, T, j, oe, B, Ce;
    return We(n, i, function(P, S) {
      Ee(), P.pause = function() {
        On(), o = !0;
      }, P.resume = function() {
        o && (o = !1, t = null, Ie(), Dn());
      }, P.flush = function(w, b, G) {
        if (w === void 0 && (w = !0), !o) {
          On();
          try {
            return P[ta](w, null, G || 1);
          } catch (K) {
            Q(P[hn](), 1, 22, "flush failed, telemetry will not be collected: " + Ue(K), { exception: ae(K) });
          }
        }
      }, P.onunloadFlush = function() {
        if (!o)
          if (_ || I)
            try {
              return P[ta](!0, Z, 2);
            } catch (w) {
              Q(P[hn](), 1, 20, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + Ue(w), { exception: ae(w) });
            }
          else
            P.flush(!1);
      }, P.addHeader = function(w, b) {
        l[w] = b;
      }, P.initialize = function(w, b, G, K) {
        P.isInitialized() && Q(P[hn](), 1, 28, "Sender is already initialized"), S.initialize(w, b, G, K);
        var re = P.identifier;
        u = new nE(b.logger), r = 0, t = null, a = 0, P[oa] = null, c = 0;
        var ee = P[hn]();
        f = xr(ii("Sender"), b.evtNamespace && b.evtNamespace()), v = eE(f), P._addHook(tn(w, function(ve) {
          var De = ve.cfg;
          De.storagePrefix && Of(De.storagePrefix);
          var He = fi(null, De, b), fe = He.getExtCfg(re, DR);
          xe(P, "_senderConfig", {
            g: function() {
              return fe;
            }
          }), D !== fe.endpointUrl && (p = D = fe.endpointUrl), E && E !== fe[Pv] && se(E, function(Ke) {
            delete l[Ke.header];
          }), C = fe[eD], _ = (fe[nD] === !1 || fe[Av] === !1) && Rs(), I = fe[iD], T = !!fe.disableXhr;
          var kn = fe[xf], Kn = !!fe[rD] && (!!kn || za()), Li = fe.namePrefix, Vr = Kn !== Y || Kn && J !== Li || Kn && k !== kn;
          if (P[cr]) {
            if (Vr)
              try {
                P._buffer = P._buffer[Yf](ee, fe, Kn);
              } catch (Ke) {
                Q(P[hn](), 1, 12, "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + Ue(Ke), { exception: ae(Ke) });
              }
            Ie();
          } else
            P[cr] = Kn ? new fD(ee, fe) : new Bf(ee, fe);
          J = Li, Y = Kn, k = kn, j = !fe[tD] && rv(!0), Ce = !!fe[oD], P._sample = new oE(fe.samplingPercentage, ee), O = fe[aD], de(O, De) || Q(ee, 1, 100, "Invalid Instrumentation key " + O), E = fe[Pv], !Vs(p) && E && E[Ne] > 0 ? se(E, function(Ke) {
            i.addHeader(Ke.header, Ke.value);
          }) : E = null, te = fe.enableSendPromise;
          var Wn = fe.httpXHROverride, pi = null, Oi = null;
          pi = L([1, 2], !1);
          var sn = { sendPOST: Re };
          oe = function(Ke, ti) {
            return ie(sn, Ke, ti);
          }, B = function(Ke, ti) {
            return ie(sn, Ke, ti, !1);
          }, !fe[Av] && Rs() && (pi = L([3], !1)), pi = I ? Wn : pi || Wn || sn, P[oa] = function(Ke, ti) {
            return ie(pi, Ke, ti);
          }, j && (R = Pe), Oi = I ? Wn : L([3, 1], !0) || Wn, (I || !R) && Oi && (R = function(Ke, ti) {
            return ie(Oi, Ke, ti);
          }), R || (R = oe), N = fe.disableTelemetry, d = fe[sD] || pr, m = fe.isRetryDisabled, y = fe[uD];
        }));
      }, P.processTelemetry = function(w, b) {
        b = P._getTelCtx(b);
        var G = b[hn]();
        try {
          if (N)
            return;
          if (!w) {
            Q(G, 1, 7, "Cannot send empty telemetry");
            return;
          }
          if (w.baseData && !w[fl]) {
            Q(G, 1, 70, "Cannot send telemetry without baseData and baseType");
            return;
          }
          if (w[fl] || (w[fl] = "EventData"), !P[oa]) {
            Q(G, 1, 28, "Sender was not initialized");
            return;
          }
          if (M(w))
            w[EC] = P._sample[Ou];
          else {
            Q(G, 2, 33, "Telemetry item was sampled out and not sent", { SampleRate: P._sample[Ou] });
            return;
          }
          var K = w.iKey || O, re = n.constructEnvelope(w, K, G, d);
          if (!re) {
            Q(G, 1, 47, "Unable to create an AppInsights envelope");
            return;
          }
          var ee = !1;
          if (w[wn] && w[wn][jc] && (se(w[wn][jc], function(He) {
            try {
              He && He(re) === !1 && (ee = !0, ho(G, "Telemetry processor check returns false"));
            } catch (fe) {
              Q(G, 1, 64, "One of telemetry initializers failed, telemetry item will not be sent: " + Ue(fe), { exception: ae(fe) }, !0);
            }
          }), delete w[wn][jc]), ee)
            return;
          var ve = u.serialize(re), De = P[cr];
          Ie(ve), De[Dt](ve), Dn();
        } catch (He) {
          Q(G, 2, 12, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + Ue(He), { exception: ae(He) });
        }
        P.processNext(w, b);
      }, P[H0] = function(w, b, G) {
        w.readyState === 4 && ke(w.status, b, w.responseURL, G, x(w), ys(w) || w.response);
      }, P[ta] = function(w, b, G) {
        w === void 0 && (w = !0);
        var K;
        if (!o)
          try {
            var re = P[cr];
            if (N)
              re[pt]();
            else {
              if (re[No]() > 0) {
                var ee = re.getItems();
                le(G || 0, w), b ? K = b.call(P, ee, w) : K = P[oa](ee, w);
              }
              a = +new Date();
            }
            On();
          } catch (De) {
            var ve = Kd();
            (!ve || ve > 9) && Q(P[hn](), 1, 40, "Telemetry transmission failed, some telemetry will be lost: " + Ue(De), { exception: ae(De) });
          }
        return K;
      }, P._doTeardown = function(w, b) {
        P.onunloadFlush(), uo(v, !1), Ee();
      }, P[qr] = function(w, b, G) {
        Q(P[hn](), 2, 26, "Failed to send telemetry.", { message: b }), P._buffer && P._buffer[Na](w);
      }, P[gl] = function(w, b) {
        for (var G = [], K = [], re = b.errors.reverse(), ee = 0, ve = re; ee < ve.length; ee++) {
          var De = ve[ee], He = w.splice(De.index, 1)[0];
          A(De.statusCode) ? K[Io](He) : G[Io](He);
        }
        w[Ne] > 0 && P[Ss](w, b[Ts]), G[Ne] > 0 && P[qr](G, x(null, ["partial success", b[Ts], "of", b.itemsReceived].join(" "))), K[Ne] > 0 && (Ge(K), Q(P[hn](), 2, 40, "Partial success. Delivered: " + w[Ne] + ", Failed: " + G[Ne] + ". Will retry to send " + K[Ne] + " our of " + b[z0] + " items"));
      }, P[Ss] = function(w, b) {
        P._buffer && P._buffer[Na](w);
      }, P._xdrOnLoad = function(w, b) {
        var G = ys(w);
        if (w && (G + "" == "200" || G === ""))
          r = 0, P[Ss](b, 0);
        else {
          var K = Ve(G);
          K && K.itemsReceived && K.itemsReceived > K[Ts] && !m ? P[gl](b, K) : P[qr](b, H(w));
        }
      };
      function M(w) {
        return P._sample.isSampledIn(w);
      }
      function L(w, b) {
        for (var G, K = null, re = null, ee = 0; re == null && ee < w[Ne]; )
          K = w[ee], !T && K === 1 ? _w() ? re = q : Ju() && (re = Re) : K === 2 && rv(b) ? re = Se : Rs() && K === 3 && (re = ce), ee++;
        return re ? (G = {}, G[Mv] = re, G) : null;
      }
      function V(w, b, G, K) {
        b === 200 && w ? P._onSuccess(w, w[Ne]) : K && P[qr](w, K);
      }
      function ie(w, b, G, K) {
        K === void 0 && (K = !0);
        var re = function(De, He, fe) {
          return V(b, De, He, fe);
        }, ee = pe(b), ve = w && w[Mv];
        return ve && ee ? (K && P._buffer[Lu](b), ve(ee, re, !G)) : null;
      }
      function pe(w) {
        var b;
        if (Me(w) && w[Ne] > 0) {
          var G = P._buffer[bv](w), K = (b = {}, b[_n] = G, b.urlString = p, b.headers = l, b.disableXhrSync = T, b.disableFetchKeepAlive = !j, b[aa] = w, b);
          return K;
        }
        return null;
      }
      function Se(w, b, G) {
        return be(w, b, !1);
      }
      function Ie(w) {
        var b = w ? w[Ne] : 0;
        return P[cr].size() + b > C ? ((!v || v[Nv]()) && P[ta](!0, null, 10), !0) : !1;
      }
      function ke(w, b, G, K, re, ee) {
        var ve = null;
        if (P._appId || (ve = Ve(ee), ve && ve.appId && (P._appId = ve.appId)), (w < 200 || w >= 300) && w !== 0) {
          if ((w === 301 || w === 307 || w === 308) && !Qe(G)) {
            P[qr](b, re);
            return;
          }
          !m && A(w) ? (Ge(b), Q(P[hn](), 2, 40, ". Response code " + w + ". Will retry to send " + b[Ne] + " items.")) : P[qr](b, re);
        } else if (v && !v[Nv]()) {
          if (!m) {
            var De = 10;
            Ge(b, De), Q(P[hn](), 2, 40, ". Offline - Response Code: ".concat(w, ". Offline status: ").concat(!v.isOnline(), ". Will retry to send ").concat(b.length, " items."));
          }
        } else
          Qe(G), w === 206 ? (ve || (ve = Ve(ee)), ve && !m ? P[gl](b, ve) : P[qr](b, re)) : (r = 0, P[Ss](b, K));
      }
      function Qe(w) {
        return c >= 10 ? !1 : !z(w) && w !== "" && w !== p ? (p = w, ++c, !0) : !1;
      }
      function F(w, b, G, K) {
        try {
          w(b, G, K);
        } catch (re) {
        }
      }
      function Z(w, b) {
        if (R)
          R(w, !1);
        else {
          var G = pe(w);
          ce(G);
        }
      }
      function ge(w, b) {
        var G = Ai(), K = p, re = P[cr], ee = re[bv](w), ve = new Blob([ee], { type: "text/plain;charset=UTF-8" }), De = G.sendBeacon(K, ve);
        return De && P._onSuccess(w, w[Ne]), De;
      }
      function ce(w, b, G) {
        var K = w, re = K && K[aa];
        if (Me(re) && re[Ne] > 0 && !ge(re))
          if (Ce)
            B && B(re, !0), Q(P[hn](), 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender.");
          else {
            for (var ee = [], ve = 0; ve < re[Ne]; ve++) {
              var De = re[ve];
              ge([De]) || ee[Io](De);
            }
            ee[Ne] > 0 && (B && B(ee, !0), Q(P[hn](), 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender."));
          }
      }
      function Re(w, b, G) {
        var K = w, re, ee, ve, De = new XMLHttpRequest(), He = p;
        try {
          De[lt] = !0;
        } catch (fe) {
        }
        return De.open("POST", He, !G), De[Rl]("Content-type", "application/json"), Vs(He) && De[Rl](Ye[6], Ye[7]), se(Ar(l), function(fe) {
          De[Rl](fe, l[fe]);
        }), De.onreadystatechange = function() {
          var fe = K[aa];
          P._xhrReadyStateChange(De, fe, fe[Ne]), De.readyState === 4 && ee && ee(!0);
        }, De.onerror = function(fe) {
          F(b, 400, {}, x(De)), ve && ve(fe);
        }, !G && te && (re = Or(function(fe, kn) {
          ee = fe, ve = kn;
        })), De.send(w[_n]), re;
      }
      function Pe(w, b) {
        var G = function(ve, De, He) {
          return V(w, ve, De, He);
        };
        if (Me(w)) {
          for (var K = w[Ne], re = 0; re < w[Ne]; re++)
            K += w[re][Ne];
          var ee = pe(w);
          g + K <= aE ? be(ee, G, !0) : Rs() ? ce(ee) : (B && B(w, !0), Q(P[hn](), 2, 40, ". Failed to send telemetry with Beacon API, retried with xhrSender."));
        }
      }
      function be(w, b, G) {
        var K, re = p, ee = w, ve = ee[_n], De = new Blob([ve], { type: "application/json" }), He, fe, kn, Kn = new Headers(), Li = ve[Ne], Vr = !1, Wn = !1;
        Vs(re) && Kn.append(Ye[6], Ye[7]), se(Ar(l), function(sn) {
          Kn.append(sn, l[sn]);
        });
        var pi = (K = {
          method: "POST",
          headers: Kn,
          body: De
        }, K[lt] = !0, K);
        G && (pi.keepalive = !0, Vr = !0, g += Li);
        var Oi = new Request(re, pi);
        try {
          Oi[lt] = !0;
        } catch (sn) {
        }
        !G && te && (He = Or(function(sn, Ke) {
          fe = sn, kn = Ke;
        }));
        try {
          Ao(fetch(Oi), function(sn) {
            if (G && (g -= Li, Li = 0), !Wn)
              if (Wn = !0, sn.rejected)
                F(b, 400, {}, sn.reason && sn.reason.message), kn && kn(sn.reason);
              else {
                var Ke = sn.value;
                Ke.ok ? Ao(Ke.text(), function(ti) {
                  var is = ee[aa];
                  ke(Ke.status, is, Ke.url, is[Ne], Ke.statusText, ti.value || ""), fe && fe(!0);
                }) : (F(b, 400, {}, Ke.statusText), fe && fe(!1));
              }
          });
        } catch (sn) {
          Wn || (F(b, 400, {}, ae(sn)), kn && kn(sn));
        }
        return Vr && !Wn && (Wn = !0, F(b, 200, {}), fe && fe(!0)), He;
      }
      function Ve(w) {
        try {
          if (w && w !== "") {
            var b = vi().parse(w);
            if (b && b.itemsReceived && b.itemsReceived >= b[Ts] && b.itemsReceived - b.itemsAccepted === b.errors[Ne])
              return b;
          }
        } catch (G) {
          Q(P[hn](), 1, 43, "Cannot parse the response. " + Ue(G), {
            response: w
          });
        }
        return null;
      }
      function Ge(w, b) {
        if (b === void 0 && (b = 1), !(!w || w[Ne] === 0)) {
          var G = P[cr];
          G[Na](w), r++;
          for (var K = 0, re = w; K < re.length; K++) {
            var ee = re[K];
            G[Dt](ee);
          }
          Cn(b), Dn();
        }
      }
      function Cn(w) {
        var b = 10, G;
        if (r <= 1)
          G = b;
        else {
          var K = (Math.pow(2, r) - 1) / 2, re = Math.floor(Math.random() * K * b) + 1;
          re = w * re, G = Math.max(Math.min(re, 3600), b);
        }
        var ee = Ni() + G * 1e3;
        t = ee;
      }
      function Dn() {
        if (!s && !o) {
          var w = t ? Math.max(0, t - Ni()) : 0, b = Math.max(y, w);
          s = Di(function() {
            s = null, P[ta](!0, null, 1);
          }, b);
        }
      }
      function On() {
        s && s.cancel(), s = null, t = null;
      }
      function A(w) {
        return w === 401 || w === 403 || w === 408 || w === 429 || w === 500 || w === 502 || w === 503 || w === 504;
      }
      function x(w, b) {
        return w ? "XMLHttpRequest,Status:" + w.status + ",Response:" + ys(w) || w.response || "" : b;
      }
      function q(w, b, G) {
        var K = w, re = jn(), ee = new XDomainRequest(), ve = K[_n];
        ee.onload = function() {
          var fe = K[aa];
          P._xdrOnLoad(ee, fe);
        }, ee.onerror = function() {
          F(b, 400, {}, H(ee));
        };
        var De = re && re.location && re.location.protocol || "";
        if (p.lastIndexOf(De, 0) !== 0) {
          Q(P[hn](), 2, 40, ". Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol."), P._buffer[pt]();
          return;
        }
        var He = p.replace(/^(https?:)/, "");
        ee.open("POST", He), ee.send(ve);
      }
      function H(w, b) {
        return w ? "XDomainRequest,Response:" + ys(w) || "" : b;
      }
      function W() {
        var w = "getNotifyMgr";
        return P.core[w] ? P.core[w]() : P.core._notificationManager;
      }
      function le(w, b) {
        var G = W();
        if (G && G[RR])
          try {
            G[RR](w, b);
          } catch (K) {
            Q(P[hn](), 1, 74, "send request notification failed: " + Ue(K), { exception: ae(K) });
          }
      }
      function de(w, b) {
        var G = b.disableInstrumentationKeyValidation, K = z(G) ? !1 : G;
        if (K)
          return !0;
        var re = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$", ee = new RegExp(re);
        return ee.test(w);
      }
      function Ee() {
        P[oa] = null, P[cr] = null, P._appId = null, P._sample = null, l = {}, v = null, r = 0, t = null, a = null, o = !1, s = null, u = null, c = 0, g = 0, R = null, f = null, p = null, D = null, C = 0, _ = !1, E = null, N = !1, O = null, d = pr, m = !1, Y = null, J = pr, T = !1, j = !1, Ce = !1, oe = null, B = null, xe(P, "_senderConfig", {
          g: function() {
            return Hd({}, DR);
          }
        });
      }
    }), i;
  }
  return n.constructEnvelope = function(i, r, t, a) {
    var o;
    r !== i.iKey && !z(r) ? o = Fn(Fn({}, i), { iKey: r }) : o = i;
    var s = cE[o.baseType] || lD;
    return s(t, o, a);
  }, n;
}(Tt), pR = "duration", ht = "properties", ui = "requestUrl", wa = "inst", Hi = "length", ji = "traceID", mr = "spanID", Zn = "traceFlags", Ia = "context", bo = "aborted", Ks = "traceId", Ws = "spanId", Ns = "_addHook", ai = "core", Cl = "includeCorrelationHeaders", Fv = "getAbsoluteUrl", Jr = "headers", qn = "requestHeaders", Dl = "setRequestHeader", hR = "trackDependencyDataInternal", vt = "startTime", Ht = "toLowerCase", Lv = "enableRequestHeaderTracking", gD = "enableAjaxErrorStatusText", RD = "enableAjaxPerfTracking", dD = "maxAjaxCallsPerView", CD = "excludeRequestFromAutoTrackingPatterns", DD = "addRequestContext", Ov = "disableAjaxTracking", pD = "ajaxPerfLookupDelay", hD = "disableFetchTracking", wD = "enableResponseHeaderTracking", si = "status", ot = "statusText", lo = "headerMap", kv = "openDone", Uv = "sendDone", ft = "requestSentTime", Yv = "abortDone", xv = "getTraceId", Bv = "getTraceFlags", hr = "method", Gv = "errorStatusText", _D = "stateChangeAttached", wR = "responseText", _a = "responseFinishedTime", Vv = "CreateTrackItem", ED = "response", _R = "getAllResponseHeaders", Hv = "getPartAProps", ku = "perfMark", Qt = "name", zv = "perfTiming", ba = "exception", ER = "ajaxDiagnosticsMessage", $v = "correlationContext", pl = "ajaxTotalDuration", hl = "eventTraceCtx";
function mD(e, n, i) {
  var r = 0, t = e[n], a = e[i];
  return t && a && (r = Yn(t, a)), r;
}
function Qr(e, n, i, r, t) {
  var a = 0, o = mD(i, r, t);
  return o && (a = fr(e, n, Dr(o))), a;
}
function fr(e, n, i) {
  var r = "ajaxPerf", t = 0;
  if (e && n && i) {
    var a = e[r] = e[r] || {};
    a[n] = i, t = 1;
  }
  return t;
}
function vE(e, n) {
  var i = e[zv], r = n[ht] || {}, t = 0, a = "name", o = "Start", s = "End", u = "domainLookup", c = "connect", l = "redirect", g = "request", R = "response", v = "startTime", f = u + o, p = u + s, D = c + o, C = c + s, _ = g + o, E = g + s, N = R + o, O = R + s, d = l + o, m = l = s, y = "transferSize", Y = "encodedBodySize", k = "decodedBodySize", J = "serverTiming";
  if (i) {
    t |= Qr(r, l, i, d, m), t |= Qr(r, u, i, f, p), t |= Qr(r, c, i, D, C), t |= Qr(r, g, i, _, E), t |= Qr(r, R, i, N, O), t |= Qr(r, "networkConnect", i, v, C), t |= Qr(r, "sentRequest", i, _, O);
    var te = i[pR];
    te || (te = mD(i, v, O) || 0), t |= fr(r, pR, te), t |= fr(r, "perfTotal", te);
    var I = i[J];
    if (I) {
      var T = {};
      se(I, function(j, oe) {
        var B = Du(j[a] || "" + oe), Ce = T[B] || {};
        Te(j, function(P, S) {
          (P !== a && he(S) || $u(S)) && (Ce[P] && (S = Ce[P] + ";" + S), (S || !he(S)) && (Ce[P] = S));
        }), T[B] = Ce;
      }), t |= fr(r, J, T);
    }
    t |= fr(r, y, i[y]), t |= fr(r, Y, i[Y]), t |= fr(r, k, i[k]);
  } else
    e[ku] && (t |= fr(r, "missing", e.perfAttempts));
  t && (n[ht] = r);
}
var fE = function() {
  function e() {
    var n = this;
    n[kv] = !1, n.setRequestHeaderDone = !1, n[Uv] = !1, n[Yv] = !1, n[_D] = !1;
  }
  return e;
}(), mR = function() {
  function e(n, i, r, t) {
    var a, o = this, s = r, u = "responseText";
    o[ku] = null, o.completed = !1, o.requestHeadersSize = null, o[qn] = null, o.responseReceivingDuration = null, o.callbackDuration = null, o[pl] = null, o[bo] = 0, o.pageUrl = null, o[ui] = null, o.requestSize = 0, o[hr] = null, o[si] = null, o[ft] = null, o.responseStartedTime = null, o[_a] = null, o.callbackFinishedTime = null, o.endTime = null, o.xhrMonitoringState = new fE(), o.clientFailure = 0, o[ji] = n, o[mr] = i, o[Zn] = t == null ? void 0 : t.getTraceFlags(), t ? o[hl] = (a = {}, a[Ks] = t[xv](), a[Ws] = t.getSpanId(), a[Zn] = t[Bv](), a) : o[hl] = null, We(e, o, function(c) {
      c.getAbsoluteUrl = function() {
        return c[ui] ? K_(c[ui]) : null;
      }, c.getPathName = function() {
        return c[ui] ? nc(s, W_(c[hr], c[ui])) : null;
      }, c[Vv] = function(l, g, R) {
        var v;
        if (c.ajaxTotalDuration = Math.round(Yn(c.requestSentTime, c.responseFinishedTime) * 1e3) / 1e3, c[pl] < 0)
          return null;
        var f = (v = {
          id: "|" + c[ji] + "." + c[mr],
          target: c[Fv]()
        }, v[Qt] = c.getPathName(), v.type = l, v[vt] = null, v.duration = c[pl], v.success = +c[si] >= 200 && +c[si] < 400, v.responseCode = +c[si], v[ht] = { HttpMethod: c[hr] }, v), p = f[ht];
        if (c[bo] && (p[bo] = !0), c[ft] && (f[vt] = new Date(), f[vt].setTime(c[ft])), vE(c, f), g && Ar(c.requestHeaders)[Hi] > 0 && (p[qn] = c[qn]), R) {
          var D = R();
          if (D) {
            var C = D[$v];
            if (C && (f.correlationContext = C), D[lo] && Ar(D.headerMap)[Hi] > 0 && (p.responseHeaders = D[lo]), c[Gv])
              if (c[si] >= 400) {
                var _ = D.type;
                (_ === "" || _ === "text") && (p.responseText = D.responseText ? D[ot] + " - " + D[u] : D[ot]), _ === "json" && (p.responseText = D.response ? D[ot] + " - " + JSON.stringify(D[ED]) : D[ot]);
              } else
                c[si] === 0 && (p.responseText = D[ot] || "");
          }
        }
        return f;
      }, c[Hv] = function() {
        var l, g = null, R = c[hl];
        if (R && (R[Ks] || R[Ws])) {
          g = {};
          var v = g[zn.TraceExt] = (l = {}, l[ji] = R[Ks], l.parentID = R[Ws], l);
          z(R[Zn]) || (v[Zn] = R[Zn]);
        }
        return g;
      };
    });
  }
  return e.__ieDyn = 1, e;
}(), nn, SR = "ai.ajxmn.", Ma = "diagLog", Pr = "_ajaxData", at = "fetch", sa = "Failed to monitor XMLHttpRequest", SD = ", monitoring data for this ajax call ", zt = SD + "may be incorrect.", TR = SD + "won't be sent.", yR = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.", NR = "Failed to add custom defined request context as configured call back may missing a null check.", IR = "Failed to calculate the duration of the ", bR = 0;
function gE() {
  var e = ei();
  return !e || z(e.Request) || z(e.Request[mi]) || z(e[at]) ? null : e[at];
}
function RE(e, n) {
  var i, r, t = !1;
  if (Ju()) {
    var a = XMLHttpRequest[mi];
    t = !z(a) && !z(a.open) && !z(a.send) && !z(a.abort);
  }
  var o = Kd();
  if (o && o < 9 && (t = !1), t)
    try {
      var s = new XMLHttpRequest(), u = {
        xh: [],
        i: (i = {}, i[n] = {}, i)
      };
      s[Pr] = u;
      var c = XMLHttpRequest[mi].open;
      XMLHttpRequest[mi].open = c;
    } catch (l) {
      t = !1, Pa(e, 15, "Failed to enable XMLHttpRequest monitoring, extension is not supported", (r = {}, r[ba] = ae(l), r));
    }
  return t;
}
var Zt = function(e, n) {
  return e && n && e[Pr] ? (e[Pr].i || {})[n] : null;
}, dE = function(e, n, i) {
  if (e) {
    var r = (e[Pr] || {}).xh;
    r && r.push({
      n,
      v: i
    });
  }
}, wl = function(e, n) {
  var i = !1;
  if (e) {
    var r = (e[Pr] || {}).xh;
    r && se(r, function(t) {
      if (t.n === n)
        return i = !0, -1;
    });
  }
  return i;
};
function Xs(e, n) {
  var i = "";
  try {
    var r = Zt(e, n);
    r && r[ui] && (i += "(url: '" + r[ui] + "')");
  } catch (t) {
  }
  return i;
}
function Pa(e, n, i, r, t) {
  Q(e[Ma](), 1, n, i, r, t);
}
function Bi(e, n, i, r, t) {
  Q(e[Ma](), 2, n, i, r, t);
}
function ua(e, n, i) {
  return function(r) {
    var t;
    Pa(e, n, i, (t = {
      ajaxDiagnosticsMessage: Xs(r[wa], e._ajaxDataId)
    }, t[ba] = ae(r.err), t));
  };
}
function $t(e, n) {
  return e && n ? Gn(e, n) : -1;
}
function MR(e, n, i) {
  var r = {
    id: n,
    fn: i
  };
  return e.push(r), {
    remove: function() {
      se(e, function(t, a) {
        if (t.id === r.id)
          return e.splice(a, 1), -1;
      });
    }
  };
}
function TD(e, n, i, r) {
  var t = !0;
  return se(n, function(a, o) {
    try {
      a.fn.call(null, i) === !1 && (t = !1);
    } catch (s) {
      Q(e && e.logger, 1, 64, "Dependency " + r + " [#" + o + "] failed: " + Ue(s), { exception: ae(s) }, !0);
    }
  }), t;
}
function CE(e, n, i, r, t, a) {
  var o, s = e[Hi];
  if (s > 0) {
    var u = (o = {}, o[ai] = n, o.xhr = r, o.input = t, o.init = a, o.traceId = i[ji], o.spanId = i[mr], o.traceFlags = i[Zn], o.context = i[Ia] || {}, o.aborted = !!i[bo], o);
    TD(n, e, u, "listener"), i[ji] = u[Ks], i[mr] = u[Ws], i[Zn] = u[Zn], i[Ia] = u[Ia];
  }
}
var Is = "*.blob.core.", DE = Mo([
  Is + "windows.net",
  Is + "chinacloudapi.cn",
  Is + "cloudapi.de",
  Is + "usgovcloudapi.net"
]), pE = [
  /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
], hE = Mo((nn = {}, nn[dD] = 500, nn[Ov] = !1, nn[hD] = !1, nn[CD] = void 0, nn.disableCorrelationHeaders = !1, nn.distributedTracingMode = 1, nn.correlationHeaderExcludedDomains = DE, nn.correlationHeaderDomains = void 0, nn.correlationHeaderExcludePatterns = void 0, nn.appId = void 0, nn.enableCorsCorrelation = !1, nn[Lv] = !1, nn[wD] = !1, nn[gD] = !1, nn[RD] = !1, nn.maxAjaxPerfLookupAttempts = 3, nn[pD] = 25, nn.ignoreHeaders = [
  "Authorization",
  "X-API-Key",
  "WWW-Authenticate"
], nn[DD] = void 0, nn.addIntEndpoints = !0, nn)), wE = function(e) {
  Fi(n, e);
  function n() {
    var i = e.call(this) || this;
    i.identifier = n.identifier, i.priority = 120;
    var r, t, a, o, s, u, c, l, g, R, v, f, p, D, C, _, E, N, O, d, m, y, Y, k, J, te, I, T, j, oe;
    return We(n, i, function(B, Ce) {
      var P = Ce[Ns];
      S(), B.initialize = function(A, x, q, H) {
        B.isInitialized() || (Ce.initialize(A, x, q, H), d = xr(ii("ajax"), x && x.evtNamespace && x.evtNamespace()), M(A), Se(), ie(), L());
      }, B._doTeardown = function() {
        S();
      }, B.trackDependencyData = function(A, x) {
        On(k, B[ai], null, A, x);
      }, B[Cl] = function(A, x, q, H) {
        var W = B._currentWindowHost || a;
        if (CE(Y, B[ai], A, H, x, q), x || x === "") {
          if (nR(o, A[Fv](), W)) {
            q || (q = {});
            var le = new Headers(q[Jr] || (x instanceof Request ? x[Jr] || {} : {}));
            if (R) {
              var de = "|" + A[ji] + "." + A[mr];
              le.set(Ye[3], de), s && (A[qn][Ye[3]] = de);
            }
            var Ee = j || l && l.appId();
            if (Ee && (le.set(Ye[0], Ye[2] + Ee), s && (A[qn][Ye[0]] = Ye[2] + Ee)), g) {
              var w = A[Zn];
              z(w) && (w = 1);
              var b = Fg(Ag(A[ji], A[mr], w));
              le.set(Ye[4], b), s && (A[qn][Ye[4]] = b);
            }
            q[Jr] = le;
          }
          return q;
        } else if (H) {
          if (nR(o, A[Fv](), W)) {
            if (R)
              if (wl(H, Ye[3]))
                Bi(B, 71, "Unable to set [" + Ye[3] + "] as it has already been set by another instance");
              else {
                var de = "|" + A[ji] + "." + A[mr];
                H[Dl](Ye[3], de), s && (A[qn][Ye[3]] = de);
              }
            var Ee = j || l && l.appId();
            if (Ee && (wl(H, Ye[0]) ? Bi(B, 71, "Unable to set [" + Ye[0] + "] as it has already been set by another instance") : (H[Dl](Ye[0], Ye[2] + Ee), s && (A[qn][Ye[0]] = Ye[2] + Ee))), g) {
              var w = A[Zn];
              if (z(w) && (w = 1), wl(H, Ye[4]))
                Bi(B, 71, "Unable to set [" + Ye[4] + "] as it has already been set by another instance");
              else {
                var b = Fg(Ag(A[ji], A[mr], w));
                H[Dl](Ye[4], b), s && (A[qn][Ye[4]] = b);
              }
            }
          }
          return H;
        }
      }, B[hR] = function(A, x, q) {
        if (p === -1 || c < p) {
          (T === 2 || T === 1) && typeof A.id == "string" && A.id[A.id[Hi] - 1] !== "." && (A.id += "."), z(A[vt]) && (A[vt] = new Date());
          var H = vr(A, Ct.dataType, Ct.envelopeType, B[Ma](), x, q);
          B[ai].track(H);
        } else
          c === p && Pa(B, 55, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", !0);
        ++c;
      }, B.addDependencyListener = function(A) {
        return MR(Y, y++, A);
      }, B.addDependencyInitializer = function(A) {
        return MR(k, y++, A);
      };
      function S() {
        var A = $i();
        r = !1, t = !1, oe = !1, a = A && A.host && A.host[Ht](), o = null, s = !1, u = !1, c = 0, l = null, g = !1, R = !1, v = null, f = !1, p = 0, D = !1, C = {}, _ = !1, E = !1, N = null, O = null, d = null, y = 0, Y = [], k = [], m = ii("ajaxData"), B._ajaxDataId = m, J = null, te = 1, I = 1, T = 1, j = null;
      }
      function M(A) {
        B[Ns](tn(A, function(x) {
          var q = x.cfg, H = fi(null, q, B[ai]);
          if (o = H.getExtCfg(n.identifier, hE), T = o.distributedTracingMode, s = o[Lv], u = o[gD], f = o[RD], p = o[dD], N = [].concat(o[CD] || [], o.addIntEndpoints !== !1 ? pE : []), O = o[DD], R = T === 0 || T === 1, g = T === 1 || T === 2, f) {
            var W = q.instrumentationKey || "unkwn";
            W[Hi] > 5 ? v = SR + Ci(W, W[Hi] - 5) + "." : v = SR + W + ".";
          }
          _ = !!o[Ov], te = o.maxAjaxPerfLookupAttempts, I = o[pD], J = o.ignoreHeaders, j = o.appId;
        }));
      }
      function L() {
        var A = B[ai].getPlugin(tc);
        A && (l = A.plugin[Ia]);
      }
      function V(A) {
        var x = !0;
        return (A || J) && se(J, function(q) {
          if (q[Ht]() === A[Ht]())
            return x = !1, -1;
        }), x;
      }
      function ie() {
        var A = gE();
        if (!!A) {
          var x = ei(), q = A.polyfill;
          B[Ns](tn(o, function() {
            E = !!o[hD], D = o[wD], !E && !r ? (P(gv(x, at, {
              ns: d,
              req: function(H, W, le) {
                var de;
                if (!E && r && !Ie(null, W, le) && !(q && t)) {
                  var Ee = H.ctx();
                  de = Ve(W, le);
                  var w = B[Cl](de, W, le);
                  w !== le && H.set(1, w), Ee.data = de;
                }
              },
              rsp: function(H, W) {
                if (!E) {
                  var le = H.ctx().data;
                  le && (H.rslt = H.rslt.then(function(de) {
                    return Cn(H, (de || {})[si], W, de, le, function() {
                      var Ee, w = (Ee = {
                        statusText: (de || {})[ot]
                      }, Ee[lo] = null, Ee[$v] = Dn(de), Ee);
                      if (D && de) {
                        var b = {};
                        de.headers.forEach(function(G, K) {
                          V(K) && (b[K] = G);
                        }), w[lo] = b;
                      }
                      return w;
                    }), de;
                  }).catch(function(de) {
                    throw Cn(H, 0, W, null, le, null, { error: de.message || ae(de) }), de;
                  }));
                }
              },
              hkErr: ua(B, 15, "Failed to monitor Window.fetch" + zt)
            }, !0, Rd())), r = !0) : q && !oe && (P(gv(x, at, {
              ns: d,
              req: function(H, W, le) {
                Ie(null, W, le);
              }
            })), oe = !0);
          })), q && (x[at].polyfill = q);
        }
      }
      function pe(A, x, q) {
        P(G_(A, x, q));
      }
      function Se() {
        !RE(B, m) || B[Ns](tn(o, function() {
          _ = !!o[Ov], s = o[Lv], !_ && !t && (pe(XMLHttpRequest, "open", {
            ns: d,
            req: function(A, x, q, H) {
              if (!_) {
                var W = A[wa], le = Zt(W, m);
                !Ie(W, q) && ke(W, le, !0) && ((!le || !le.xhrMonitoringState[kv]) && (le = F(W, x, q, H)), Z(W, le));
              }
            },
            hkErr: ua(B, 15, sa + ".open" + zt)
          }), pe(XMLHttpRequest, "send", {
            ns: d,
            req: function(A, x) {
              if (!_) {
                var q = A[wa], H = Zt(q, m);
                ke(q, H) && !H.xhrMonitoringState[Uv] && (Pe("xhr", H), H[ft] = ws(), B[Cl](H, void 0, void 0, q), H.xhrMonitoringState[Uv] = !0);
              }
            },
            hkErr: ua(B, 17, sa + zt)
          }), pe(XMLHttpRequest, "abort", {
            ns: d,
            req: function(A) {
              if (!_) {
                var x = A[wa], q = Zt(x, m);
                ke(x, q) && !q.xhrMonitoringState[Yv] && (q[bo] = 1, q.xhrMonitoringState[Yv] = !0);
              }
            },
            hkErr: ua(B, 13, sa + ".abort" + zt)
          }), pe(XMLHttpRequest, "setRequestHeader", {
            ns: d,
            req: function(A, x, q) {
              if (!_) {
                var H = A[wa], W = Zt(H, m);
                W && ke(H, W) && (dE(H, x, q), s && V(x) && W && (W[qn][x] = q));
              }
            },
            hkErr: ua(B, 71, sa + ".setRequestHeader" + zt)
          }), t = !0);
        }));
      }
      function Ie(A, x, q) {
        var H = !1, W = ((he(x) ? x : (x || {}).url || "") || "")[Ht]();
        if (se(N, function(Ee) {
          var w = Ee;
          he(Ee) && (w = new RegExp(Ee)), H || (H = w.test(W));
        }), H)
          return H;
        var le = $t(W, "?"), de = $t(W, "#");
        return (le === -1 || de !== -1 && de < le) && (le = de), le !== -1 && (W = W.substring(0, le)), z(A) ? z(x) || (H = (typeof x == "object" ? x[lt] === !0 : !1) || (q ? q[lt] === !0 : !1)) : H = A[lt] === !0 || W[lt] === !0, !H && W && Vs(W) && (H = !0), H ? C[W] || (C[W] = 1) : C[W] && (H = !0), H;
      }
      function ke(A, x, q) {
        var H = !0, W = t;
        return z(A) || (H = q === !0 || !z(x)), W && H;
      }
      function Qe() {
        var A = null;
        return B[ai] && B[ai].getTraceCtx && (A = B[ai].getTraceCtx(!1)), !A && l && l.telemetryTrace && (A = Af(l.telemetryTrace)), A;
      }
      function F(A, x, q, H) {
        var W, le = Qe(), de = le && le[xv]() || _r(), Ee = gr(_r(), 0, 16), w = A[Pr] = A[Pr] || { xh: [], i: {} }, b = w.i = w.i || {}, G = b[m] = b[m] || new mR(de, Ee, B[Ma](), (W = B.core) === null || W === void 0 ? void 0 : W.getTraceCtx());
        return G[Zn] = le && le[Bv](), G[hr] = x, G[ui] = q, G.xhrMonitoringState[kv] = !0, G[qn] = {}, G.async = H, G[Gv] = u, G;
      }
      function Z(A, x) {
        x.xhrMonitoringState[_D] = qi(A, "readystatechange", function() {
          var q;
          try {
            A && A.readyState === 4 && ke(A, x) && ce(A);
          } catch (W) {
            var H = ae(W);
            (!H || $t(H[Ht](), "c00c023f") === -1) && Pa(B, 16, sa + " 'readystatechange' event handler" + zt, (q = {}, q[ER] = Xs(A, m), q[ba] = H, q));
          }
        }, d);
      }
      function ge(A) {
        try {
          var x = A.responseType;
          if (x === "" || x === "text")
            return A[wR];
        } catch (q) {
        }
        return null;
      }
      function ce(A) {
        var x = Zt(A, m);
        x[_a] = ws(), x[si] = A[si];
        function q(H, W) {
          var le = W || {};
          le.ajaxDiagnosticsMessage = Xs(A, m), H && (le.exception = ae(H)), Bi(B, 14, IR + "ajax call" + TR, le);
        }
        be("xmlhttprequest", x, function() {
          try {
            var H = x[Vv]("Ajax", s, function() {
              var w, b = (w = {
                statusText: A[ot]
              }, w[lo] = null, w[$v] = Re(A), w.type = A.responseType, w[wR] = ge(A), w.response = A[ED], w);
              if (D) {
                var G = A[_R]();
                if (G) {
                  var K = An(G).split(/[\r\n]+/), re = {};
                  se(K, function(ee) {
                    var ve = ee.split(": "), De = ve.shift(), He = ve.join(": ");
                    V(De) && (re[De] = He);
                  }), b[lo] = re;
                }
              }
              return b;
            }), W = void 0;
            try {
              O && (W = O({ status: A[si], xhr: A }));
            } catch (w) {
              Bi(B, 104, NR);
            }
            if (H) {
              W !== void 0 && (H[ht] = Fn(Fn({}, H.properties), W));
              var le = x[Hv]();
              On(k, B[ai], x, H, null, le);
            } else
              q(null, {
                requestSentTime: x[ft],
                responseFinishedTime: x[_a]
              });
          } finally {
            try {
              var de = A[Pr] || { i: {} }, Ee = de.i || {};
              Ee[m] && (Ee[m] = null);
            } catch (w) {
            }
          }
        }, function(H) {
          q(H, null);
        });
      }
      function Re(A) {
        var x;
        try {
          var q = A[_R]();
          if (q !== null) {
            var H = $t(q[Ht](), Ye[8]);
            if (H !== -1) {
              var W = A.getResponseHeader(Ye[0]);
              return iR(W);
            }
          }
        } catch (le) {
          Bi(B, 18, yR, (x = {}, x[ER] = Xs(A, m), x[ba] = ae(le), x));
        }
      }
      function Pe(A, x) {
        if (x[ui] && v && f) {
          var q = Zi();
          if (q && _e(q.mark)) {
            bR++;
            var H = v + A + "#" + bR;
            q.mark(H);
            var W = q.getEntriesByName(H);
            W && W[Hi] === 1 && (x[ku] = W[0]);
          }
        }
      }
      function be(A, x, q, H) {
        var W = x[ku], le = Zi(), de = te, Ee = I, w = x[ui], b = 0;
        (function G() {
          try {
            if (le && W) {
              b++;
              for (var K = null, re = le.getEntries(), ee = re[Hi] - 1; ee >= 0; ee--) {
                var ve = re[ee];
                if (ve) {
                  if (ve.entryType === "resource")
                    ve.initiatorType === A && ($t(ve[Qt], w) !== -1 || $t(w, ve[Qt]) !== -1) && (K = ve);
                  else if (ve.entryType === "mark" && ve[Qt] === W[Qt]) {
                    x[zv] = K;
                    break;
                  }
                  if (ve[vt] < W[vt] - 1e3)
                    break;
                }
              }
            }
            !W || x[zv] || b >= de || x.async === !1 ? (W && _e(le.clearMarks) && le.clearMarks(W[Qt]), x.perfAttempts = b, q()) : Di(G, Ee);
          } catch (De) {
            H(De);
          }
        })();
      }
      function Ve(A, x) {
        var q, H = Qe(), W = H && H[xv]() || _r(), le = gr(_r(), 0, 16), de = new mR(W, le, B[Ma](), (q = B.core) === null || q === void 0 ? void 0 : q.getTraceCtx());
        de[Zn] = H && H[Bv](), de[ft] = ws(), de[Gv] = u;
        var Ee;
        if (A instanceof Request ? Ee = (A || {}).url || "" : Ee = A, Ee === "") {
          var w = $i();
          w && w.href && (Ee = Ed(w.href, "#")[0]);
        }
        de[ui] = Ee;
        var b = "GET";
        x && x[hr] ? b = x[hr] : A && A instanceof Request && (b = A[hr]), de[hr] = b;
        var G = {};
        if (s) {
          var K = new Headers((x ? x[Jr] : 0) || (A instanceof Request ? A[Jr] || {} : {}));
          K.forEach(function(re, ee) {
            V(ee) && (G[ee] = re);
          });
        }
        return de[qn] = G, Pe(at, de), de;
      }
      function Ge(A) {
        var x = "";
        try {
          z(A) || (typeof A == "string" ? x += "(url: '".concat(A, "')") : x += "(url: '".concat(A.url, "')"));
        } catch (q) {
          Pa(B, 15, "Failed to grab failed fetch diagnostics message", { exception: ae(q) });
        }
        return x;
      }
      function Cn(A, x, q, H, W, le, de) {
        if (!W)
          return;
        function Ee(w, b, G) {
          var K = G || {};
          K.fetchDiagnosticsMessage = Ge(q), b && (K.exception = ae(b)), Bi(B, w, IR + "fetch call" + TR, K);
        }
        W[_a] = ws(), W[si] = x, be(at, W, function() {
          var w = W[Vv]("Fetch", s, le), b;
          try {
            O && (b = O({ status: x, request: q, response: H }));
          } catch (K) {
            Bi(B, 104, NR);
          }
          if (w) {
            b !== void 0 && (w[ht] = Fn(Fn({}, w.properties), b));
            var G = W[Hv]();
            On(k, B[ai], W, w, null, G);
          } else
            Ee(14, null, {
              requestSentTime: W[ft],
              responseFinishedTime: W[_a]
            });
        }, function(w) {
          Ee(18, w, null);
        });
      }
      function Dn(A) {
        var x;
        if (A && A[Jr])
          try {
            var q = A[Jr].get(Ye[0]);
            return iR(q);
          } catch (H) {
            Bi(B, 18, yR, (x = {
              fetchDiagnosticsMessage: Ge(A)
            }, x[ba] = ae(H), x));
          }
      }
      function On(A, x, q, H, W, le) {
        var de, Ee = !0, w = A[Hi];
        if (w > 0) {
          var b = (de = {
            item: H
          }, de[ht] = W, de.sysProperties = le, de.context = q ? q[Ia] : null, de.aborted = q ? !!q[bo] : !1, de);
          Ee = TD(x, A, b, "initializer");
        }
        Ee && B[hR](H, W, le);
      }
    }), i;
  }
  return n.prototype.processTelemetry = function(i, r) {
    this.processNext(i, r);
  }, n.prototype.addDependencyInitializer = function(i) {
    return null;
  }, n.identifier = "AjaxDependencyPlugin", n;
}(Tt), _E = function() {
  function e() {
  }
  return e;
}(), EE = function() {
  function e() {
    this.id = "browser", this.deviceClass = "Browser";
  }
  return e;
}(), mE = "3.0.6", SE = function() {
  function e(n, i) {
    var r = this, t = tn(n, function() {
      var a = n.sdkExtension;
      r.sdkVersion = (a ? a + "_" : "") + "javascript:" + mE;
    });
    i && i.add(t);
  }
  return e;
}(), TE = function() {
  function e() {
  }
  return e;
}(), Uu = "sessionManager", Yu = "update", qs = "isUserCookieSet", xu = "isNewUser", _l = "getTraceCtx", jv = "telemetryTrace", yD = "applySessionContext", ND = "applyApplicationContext", ID = "applyDeviceContext", bD = "applyOperationContext", MD = "applyUserContext", PD = "applyOperatingSystemContxt", AD = "applyLocationContext", FD = "applyInternalContext", st = "accountId", Js = "getSessionId", Gf = "namePrefix", yE = "sessionCookiePostfix", LD = "userCookiePostfix", Bu = "idLength", Vf = "getNewId", Gu = "length", eo = "automaticSession", no = "authenticatedId", ca = "acquisitionDate", bs = "renewalDate", Aa = "join", la = "cookieSeparator", El = "authUserCookieName", NE = "ai_session", IE = 864e5, bE = 18e5, ME = 6e4, OD = function() {
  function e() {
  }
  return e;
}(), PE = function() {
  function e(n, i, r) {
    var t = this, a, o, s = St(i), u = Zu(i), c, l;
    We(e, t, function(g) {
      n || (n = {});
      var R = tn(n, function(_) {
        c = n.sessionExpirationMs || IE, l = n.sessionRenewalMs || bE;
        var E = n.sessionCookiePostfix || n[Gf] || "";
        a = NE + E;
      });
      r && r.add(R), g[eo] = new OD(), g[Yu] = function() {
        var _ = Ni(), E = !1, N = g[eo];
        if (N.id || (E = !v(N)), !E && c > 0) {
          var O = _ - N[ca], d = _ - N[bs];
          E = O < 0 || d < 0, E = E || O > c, E = E || d > l;
        }
        E ? p(_) : (!o || _ - o > ME) && D(N, _);
      }, g.backup = function() {
        var _ = g[eo];
        C(_.id, _[ca], _[bs]);
      };
      function v(_, E) {
        var N = !1, O = u.get(a);
        if (O && _e(O.split))
          N = f(_, O);
        else {
          var d = bC(s, a);
          d && (N = f(_, d));
        }
        return N || !!_.id;
      }
      function f(_, E) {
        var N = !1, O = ", session will be reset", d = E.split("|");
        if (d[Gu] >= 2)
          try {
            var m = +d[1] || 0, y = +d[2] || 0;
            isNaN(m) || m <= 0 ? Q(s, 2, 27, "AI session acquisition date is 0" + O) : isNaN(y) || y <= 0 ? Q(s, 2, 27, "AI session renewal date is 0" + O) : d[0] && (_.id = d[0], _[ca] = m, _[bs] = y, N = !0);
          } catch (Y) {
            Q(s, 1, 9, "Error parsing ai_session value [" + (E || "") + "]" + O + " - " + Ue(Y), { exception: ae(Y) });
          }
        return N;
      }
      function p(_) {
        var E = n[Vf] || Df;
        g.automaticSession.id = E(n[Bu] || 22), g[eo][ca] = _, D(g[eo], _), rc() || Q(s, 2, 0, "Browser does not support local storage. Session durations will be inaccurate.");
      }
      function D(_, E) {
        var N = _[ca];
        _[bs] = E;
        var O = l, d = N + c - E, m = [_.id, N, E], y = 0;
        d < O ? y = d / 1e3 : y = O / 1e3;
        var Y = n.cookieDomain || null;
        u.set(a, m[Aa]("|"), c > 0 ? y : null, Y), o = E;
      }
      function C(_, E, N) {
        MC(s, a, [_, E, N][Aa]("|"));
      }
    });
  }
  return e.__ieDyn = 1, e;
}(), AE = function() {
  function e(n, i, r, t) {
    var a = this;
    a.traceID = n || _r(), a.parentID = i;
    var o = $i();
    !r && o && o.pathname && (r = o.pathname), a.name = fn(t, r);
  }
  return e;
}();
function PR(e) {
  return !(typeof e != "string" || !e || e.match(/,|;|=| |\|/));
}
var FE = function() {
  function e(n, i, r) {
    this.isNewUser = !1, this.isUserCookieSet = !1;
    var t = St(i), a = Zu(i), o;
    We(e, this, function(s) {
      xe(s, "config", {
        g: function() {
          return n;
        }
      });
      var u = tn(n, function() {
        var R = n[LD] || "";
        o = e.userCookieName + R;
        var v = a.get(o);
        if (v) {
          s[xu] = !1;
          var f = v.split(e[la]);
          f[Gu] > 0 && (s.id = f[0], s[qs] = !!s.id);
        }
        if (!s.id) {
          s.id = c();
          var p = l(s.id);
          g(p[Aa](e[la]));
          var D = (n[Gf] || "") + "ai_session";
          i0(t, D);
        }
        s[st] = n[st] || void 0;
        var C = a.get(e[El]);
        if (C) {
          C = decodeURI(C);
          var _ = C.split(e[la]);
          _[0] && (s[no] = _[0]), _[Gu] > 1 && _[1] && (s[st] = _[1]);
        }
      });
      r && r.add(u);
      function c() {
        var R = n || {}, v = R[Vf] || Df, f = v(R[Bu] ? n[Bu] : 22);
        return f;
      }
      function l(R) {
        var v = Fo(new Date());
        s.accountAcquisitionDate = v, s[xu] = !0;
        var f = [R, v];
        return f;
      }
      function g(R) {
        var v = 31536e3;
        s[qs] = a.set(o, R, v);
      }
      s.setAuthenticatedUserContext = function(R, v, f) {
        f === void 0 && (f = !1);
        var p = !PR(R) || v && !PR(v);
        if (p) {
          Q(t, 2, 60, "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", !0);
          return;
        }
        s[no] = R;
        var D = s[no];
        v && (s[st] = v, D = [s[no], s.accountId][Aa](e[la])), f && a.set(e[El], encodeURI(D));
      }, s.clearAuthenticatedUserContext = function() {
        s[no] = null, s[st] = null, a.del(e[El]);
      }, s[Yu] = function(R) {
        if (s.id !== R || !s[qs]) {
          var v = R || c(), f = l(v);
          g(f[Aa](e[la]));
        }
      };
    });
  }
  return e.cookieSeparator = "|", e.userCookieName = "ai_user", e.authUserCookieName = "ai_authUser", e;
}(), Ms = "ext", Ps = "tags";
function jt(e, n) {
  e && e[n] && Ar(e[n])[Gu] === 0 && delete e[n];
}
function AR() {
  return null;
}
var LE = function() {
  function e(n, i, r, t) {
    var a = this, o = n.logger;
    We(e, this, function(s) {
      if (s.appId = AR, s[Js] = AR, s.application = new _E(), s.internal = new SE(i, t), Ku()) {
        s[Uu] = new PE(i, n, t), s.device = new EE(), s.location = new TE(), s.user = new FE(i, n, t);
        var u = void 0, c = void 0, l;
        r && (u = r.getTraceId(), c = r.getSpanId(), l = r.getName()), s[jv] = new AE(u, c, l, o), s.session = new OD();
      }
      s[Js] = function() {
        var g = s.session, R = null;
        if (g && he(g.id))
          R = g.id;
        else {
          var v = (s[Uu] || {})[eo];
          R = v && he(v.id) ? v.id : null;
        }
        return R;
      }, s[yD] = function(g, R) {
        je(bn(g.ext, zn.AppExt), "sesId", s[Js](), he);
      }, s[PD] = function(g, R) {
        je(g.ext, zn.OSExt, s.os);
      }, s[ND] = function(g, R) {
        var v = s.application;
        if (v) {
          var f = bn(g, Ps);
          je(f, Xe.applicationVersion, v.ver, he), je(f, Xe.applicationBuild, v.build, he);
        }
      }, s[ID] = function(g, R) {
        var v = s.device;
        if (v) {
          var f = bn(bn(g, Ms), zn.DeviceExt);
          je(f, "localId", v.id, he), je(f, "ip", v.ip, he), je(f, "model", v.model, he), je(f, "deviceClass", v.deviceClass, he);
        }
      }, s[FD] = function(g, R) {
        var v = s.internal;
        if (v) {
          var f = bn(g, Ps);
          je(f, Xe.internalAgentVersion, v.agentVersion, he), je(f, Xe.internalSdkVersion, fn(o, v.sdkVersion, 64), he), (g.baseType === Va.dataType || g.baseType === Mr.dataType) && (je(f, Xe.internalSnippet, v.snippetVer, he), je(f, Xe.internalSdkSrc, v.sdkSrc, he));
        }
      }, s[AD] = function(g, R) {
        var v = a.location;
        v && je(bn(g, Ps, []), Xe.locationIp, v.ip, he);
      }, s[bD] = function(g, R) {
        var v = s[jv];
        if (v) {
          var f = bn(bn(g, Ms), zn.TraceExt, { traceID: void 0, parentID: void 0 });
          je(f, "traceID", v.traceID, he, z), je(f, "name", v.name, he, z), je(f, "parentID", v.parentID, he, z);
        }
      }, s.applyWebContext = function(g, R) {
        var v = a.web;
        v && je(bn(g, Ms), zn.WebExt, v);
      }, s[MD] = function(g, R) {
        var v = s.user;
        if (v) {
          var f = bn(g, Ps, []);
          je(f, Xe.userAccountId, v[st], he);
          var p = bn(bn(g, Ms), zn.UserExt);
          je(p, "id", v.id, he), je(p, "authId", v[no], he);
        }
      }, s.cleanUp = function(g, R) {
        var v = g.ext;
        v && (jt(v, zn.DeviceExt), jt(v, zn.UserExt), jt(v, zn.WebExt), jt(v, zn.OSExt), jt(v, zn.AppExt), jt(v, zn.TraceExt));
      };
    });
  }
  return e.__ieDyn = 1, e;
}(), En, ml, Kt = null, OE = ir((En = {}, En[st] = Kt, En.sessionRenewalMs = 30 * 60 * 1e3, En.samplingPercentage = 100, En.sessionExpirationMs = 24 * 60 * 60 * 1e3, En.cookieDomain = Kt, En.sdkExtension = Kt, En.isBrowserLinkTrackingEnabled = !1, En.appId = Kt, En[Js] = Kt, En[Gf] = ml, En[yE] = ml, En[LD] = ml, En[Bu] = 22, En[Vf] = Kt, En)), kE = function(e) {
  Fi(n, e);
  function n() {
    var i = e.call(this) || this;
    i.priority = 110, i.identifier = tc;
    var r, t, a, o;
    return We(n, i, function(s, u) {
      c(), xe(s, "context", {
        g: function() {
          return o;
        }
      }), s.initialize = function(R, v, f, p) {
        u.initialize(R, v, f, p), l(R);
      }, s.processTelemetry = function(R, v) {
        if (!z(R)) {
          v = s._getTelCtx(v), R.name === Mr.envelopeType && v.diagLog().resetInternalMessageCount();
          var f = o || {};
          f.session && typeof o.session.id != "string" && f[Uu] && f[Uu][Yu]();
          var p = f.user;
          if (p && !p[qs] && p[Yu](f.user.id), g(R, v), p && p[xu]) {
            p[xu] = !1;
            var D = new Va(72, (Ai() || {}).userAgent || "");
            Zw(v.diagLog(), 1, D);
          }
          s.processNext(R, v);
        }
      }, s._doTeardown = function(R, v) {
        var f = (R || {}).core();
        if (f && f[_l]) {
          var p = f[_l](!1);
          p === t && f.setTraceCtx(a);
        }
        c();
      };
      function c() {
        r = null, t = null, a = null, o = null;
      }
      function l(R) {
        var v = s.identifier, f = s.core;
        s._addHook(tn(R, function() {
          var p = fi(null, R, f);
          R.storagePrefix && Of(R.storagePrefix), r = p.getExtCfg(v, OE), s._extConfig = r;
        })), a = f[_l](!1), o = new LE(f, r, a, s._unloadHooks), t = Af(s.context[jv], a), f.setTraceCtx(t), s.context.appId = function() {
          var p = f.getPlugin(kC);
          return p ? p.plugin._appId : null;
        };
      }
      function g(R, v) {
        bn(R, "tags", []), bn(R, "ext", {});
        var f = s.context;
        f[yD](R, v), f[ND](R, v), f[ID](R, v), f[bD](R, v), f[MD](R, v), f[PD](R, v), f.applyWebContext(R, v), f[AD](R, v), f[FD](R, v), f.cleanUp(R, v);
      }
    }), i;
  }
  return n.__ieDyn = 1, n;
}(Tt);
const UE = kE;
var kD = "AuthenticatedUserContext", Go = "track", Kv = "snippet", YE = "getCookieMgr", xE = "startTrackPage", BE = "stopTrackPage", Sl = "flush", GE = "startTrackEvent", VE = "stopTrackEvent", HE = "addTelemetryInitializer", FR = "pollInternalLogs", Tl = "getPlugin", yl = "evtNamespace", zE = Go + "Event", $E = Go + "Trace", jE = Go + "Metric", KE = Go + "PageView", WE = Go + "Exception", XE = Go + "DependencyData", qE = "set" + kD, JE = "clear" + kD, Nl = "version", Zr = "queue", Qs = "connectionString", Wv = "endpointUrl", Xv = "instrumentationKey", va = "onunloadFlush", Xn = "context", LR = "addHousekeepingBeforeUnload", Il = "sendMessage", QE = "updateSnippetDefinitions", lr, fa, Wt, ga, OR = [
  Kv,
  "dependencies",
  "properties",
  "_snippetVersion",
  "appInsightsNew",
  "getSKUDefaults"
], UD = "iKeyUsage", YD = "CdnUsage", xD = "SdkLoaderVer", bl = void 0, ZE = {
  samplingRate: 100,
  maxSendNumber: 1
}, em = {
  monthInterval: 3,
  daysOfMonth: [28]
}, As = {
  disabled: !0,
  limit: dr(ZE),
  interval: dr(em)
}, nm = (lr = {}, lr[Qs] = bl, lr[Wv] = bl, lr[Xv] = bl, lr.diagnosticLogInterval = _u(im, 1e4), lr.featureOptIn = (fa = {}, fa[UD] = { mode: 2 }, fa[YD] = { mode: 2 }, fa[xD] = { mode: 2 }, fa), lr.throttleMgrCfg = dr((Wt = {}, Wt[109] = dr(As), Wt[106] = dr(As), Wt[111] = dr(As), Wt[110] = dr(As), Wt)), lr);
function im(e) {
  return e && e > 0;
}
var rm = function() {
  function e(n) {
    var i = this, r, t, a, o, s, u, c, l, g, R, v, f, p, D;
    We(e, this, function(C) {
      N(), xe(C, "config", {
        g: function() {
          return l;
        }
      }), se(["pluginVersionStringArr", "pluginVersionString"], function(m) {
        xe(C, m, {
          g: function() {
            return c ? c[m] : null;
          }
        });
      }), o = "" + (n.sv || n[Nl] || ""), n[Zr] = n[Zr] || [], n[Nl] = n[Nl] || 2;
      var _ = ri(n.config || {}, nm);
      l = _.cfg, g = new L0(), xe(C, "appInsights", {
        g: function() {
          return g;
        }
      }), t = new UE(), r = new wE(), a = new lE(), c = new N_(), xe(C, "core", {
        g: function() {
          return c;
        }
      }), d(tn(_, function() {
        if (l[Qs]) {
          var m = u0(l[Qs]), y = m.ingestionendpoint;
          l[Wv] = y ? y + ya : l[Wv], l[Xv] = m.instrumentationkey || l[Xv];
        }
      })), C[Kv] = n, C[Sl] = function(m, y) {
        m === void 0 && (m = !0);
        var Y;
        return Tu(c, function() {
          return "AISKU.flush";
        }, function() {
          m && !y && (Y = Or(function(te) {
            y = te;
          }));
          var k = 1, J = function() {
            k--, k === 0 && y();
          };
          se(c.getChannels(), function(te) {
            te && (k++, te[Sl](m, J));
          }), J();
        }, null, m), Y;
      }, C[va] = function(m) {
        m === void 0 && (m = !0), se(c.getChannels(), function(y) {
          y[va] ? y[va]() : y[Sl](m);
        });
      }, C.loadAppInsights = function(m, y, Y) {
        m === void 0 && (m = !1), m && Rh("Legacy Mode is no longer supported");
        function k(J) {
          if (J) {
            var te = "";
            z(o) || (te += o), C[Xn] && C[Xn].internal && (C[Xn].internal.snippetVer = te || "-"), Te(C, function(I, T) {
              he(I) && !_e(T) && I && I[0] !== "_" && Nn(OR, I) === -1 && J[I] !== T && (J[I] = T);
            });
          }
        }
        return Tu(C.core, function() {
          return "AISKU.loadAppInsights";
        }, function() {
          c.initialize(l, [a, t, r, g, R], y, Y), xe(C, "context", {
            g: function() {
              return t[Xn];
            }
          }), v || (v = new o0(c));
          var J = tm();
          J && C[Xn] && (C[Xn].internal.sdkSrc = J), k(C[Kv]), C.emptyQueue(), C[FR](), C[LR](C), d(tn(_, function() {
            var te = !1;
            l.throttleMgrCfg[109] && (te = !l.throttleMgrCfg[109].disabled), !v.isReady() && l.extensionConfig && l.extensionConfig[R.identifier] && te && v.onReadyState(!0);
            var I;
            !f && !l[Qs] && Mc(UD, l) && (I = v[Il](106, "See Instrumentation key support at aka.ms/IkeyMigrate"), f = !0), !p && C[Xn].internal.sdkSrc && C[Xn].internal.sdkSrc.indexOf("az416426") != -1 && Mc(YD, l) && (I = v[Il](110, "See Cdn support notice at aka.ms/JsActiveCdn"), p = !0), !D && parseInt(o) < 6 && Mc(xD, l) && (I = v[Il](111, "An updated Sdk Loader is available, see aka.ms/SnippetVer"), D = !0);
          }));
        }), C;
      }, C[QE] = function(m) {
        uw(m, C, function(y) {
          return y && Nn(OR, y) === -1;
        });
      }, C.emptyQueue = function() {
        try {
          if (Me(C.snippet[Zr])) {
            for (var m = C.snippet[Zr].length, y = 0; y < m; y++) {
              var Y = C.snippet[Zr][y];
              Y();
            }
            C.snippet[Zr] = void 0, delete C.snippet[Zr];
          }
        } catch (J) {
          var k = {};
          J && _e(J.toString) && (k.exception = J.toString());
        }
      }, C[LR] = function(m) {
        if (Ku() || fd()) {
          var y = function() {
            if (m[va](!1), _e(C.core[Tl])) {
              var k = i.core[Tl](tc);
              if (k) {
                var J = k.plugin;
                J && J[Xn] && J[Xn]._sessionManager && J[Xn]._sessionManager.backup();
              }
            }
          }, Y = !1;
          u || (u = xr(s, c[yl] && c[yl]())), d(tn(l, function(k) {
            var J = k.cfg, te = m.appInsights, I = fi(null, J, te.core), T = I.getExtCfg(te.identifier || kf);
            O();
            var j = J.disablePageUnloadEvents;
            T.disableFlushOnBeforeUnload || (U_(y, j, u) && (Y = !0), fv(y, j, u) && (Y = !0), !Y && !ww() && Q(c.logger, 1, 19, "Could not add handler for beforeunload and pagehide")), !Y && !T.disableFlushOnUnload && fv(y, j, u);
          }));
        }
      }, C.getSender = function() {
        return a;
      }, C.unload = function(m, y, Y) {
        var k = !1, J;
        m && !y && (J = Or(function(I) {
          y = I;
        }));
        function te(I) {
          k || (k = !0, N(), y && y(I));
        }
        return C[va](m), O(), c.unload && c.unload(m, te, Y), J;
      }, so(C, g, [
        YE,
        zE,
        KE,
        "trackPageViewPerformance",
        WE,
        "_onerror",
        $E,
        jE,
        xE,
        BE,
        GE,
        VE
      ]), so(C, E, [
        XE,
        "addDependencyListener",
        "addDependencyInitializer"
      ]), so(C, c, [
        HE,
        FR,
        "stopPollingInternalLogs",
        Tl,
        "addPlugin",
        yl,
        "addUnloadCb",
        "getTraceCtx",
        "updateCfg",
        "onCfgChange"
      ]), so(C, function() {
        var m = t[Xn];
        return m ? m.user : null;
      }, [
        qE,
        JE
      ]);
      function E() {
        return r;
      }
      function N() {
        s = ii("AISKU"), u = null, r = null, t = null, a = null, o = null, v = null, f = !1, p = !1, D = !1, R = new V0();
      }
      function O() {
        u && (Y_(null, u), x_(null, u));
      }
      function d(m) {
        c.addUnloadHook(m);
      }
    });
  }
  return e.prototype.addDependencyInitializer = function(n) {
    return null;
  }, e;
}();
function tm() {
  if (ga)
    return ga;
  var e = null, n = !1, i = [
    "://js.monitor.azure.com/",
    "://az416426.vo.msecnd.net/"
  ];
  try {
    var r = (document || {}).currentScript;
    r && (e = r.src);
  } catch (o) {
  }
  if (e) {
    try {
      var t = e.toLowerCase();
      if (t) {
        var a = "";
        se(i, function(o, s) {
          if (Gn(t, o) !== -1)
            return a = "cdn" + (s + 1), Gn(t, "/scripts/") === -1 && (Gn(t, "/next/") !== -1 ? a += "-next" : Gn(t, "/beta/") !== -1 && (a += "-beta")), ga = a + (n ? ".mod" : ""), -1;
        });
      }
    } catch (o) {
    }
    ga = e;
  }
  return ga;
}
var om = ir({
  history: { blkVal: !0, v: void 0 }
}), am = function(e) {
  Fi(n, e);
  function n() {
    var i = e.call(this) || this;
    i.priority = 185, i.identifier = "ReactPlugin";
    var r, t, a, o, s;
    return We(n, i, function(u, c) {
      l(), u.initialize = function(v, f, p, D) {
        e.prototype.initialize.call(i, v, f, p, D), u._addHook(tn(v, function(C) {
          var _, E = u._getTelCtx();
          if (t = E.getExtCfg(i.identifier, om), r = (_ = f.getPlugin(kf)) === null || _ === void 0 ? void 0 : _.plugin, _e(a) && (a(), a = null), t.history && (R(t.history), !s)) {
            var N = {
              uri: t.history.location.pathname
            };
            u.trackPageView(N), s = !0;
          }
        }));
      }, u.getCookieMgr = function() {
        return Zu(u.core);
      }, u.getAppInsights = g, u.processTelemetry = function(v, f) {
        u.processNext(v, f);
      }, u._doTeardown = function(v, f, p) {
        _e(a) && a(), o && clearTimeout(o), l();
      }, so(u, g, [
        "trackMetric",
        "trackPageView",
        "trackEvent",
        "trackException",
        "trackTrace"
      ]);
      function l() {
        r = null, t = null, a = null, o = null, s = !1;
      }
      function g() {
        return r || Q(u.diagLog(), 1, 64, "Analytics plugin is not available, React plugin telemetry will not be sent: "), r;
      }
      function R(v) {
        var f = function(p) {
          var D = null;
          "location" in p ? D = p.location : D = p, o = setTimeout(function() {
            o = null;
            var C = { uri: D.pathname };
            u.trackPageView(C);
          }, 500);
        };
        a = v.listen(f);
      }
      th(u, "_extensionConfig", function() {
        return t;
      });
    }), i;
  }
  return n.__ieDyn = 1, n;
}(Tt);
const sm = am;
class um {
  constructor(n, i) {
    zf(this, "appInsight");
    const r = new sm();
    this.appInsight = new rm({
      config: {
        connectionString: n,
        instrumentationKey: i,
        extensions: [r],
        maxBatchInterval: 0,
        isStorageUseDisabled: !0
      }
    }), this.appInsight.loadAppInsights();
  }
  trackCustomEvent(n, i) {
    this.appInsight.trackEvent({
      name: n
    }, i);
  }
  flushEvent() {
    this.appInsight.flush();
  }
}
function cm(e, n, i, r, t, a) {
  var u, c;
  const o = {
    countOfIssueIds: ((u = i == null ? void 0 : i.issueCount) == null ? void 0 : u.toString()) || "",
    countOfIssueIdLinks: ((c = i == null ? void 0 : i.linkedIssueCount) == null ? void 0 : c.toString()) || "",
    countOfIssueIdLinksClicked: (r == null ? void 0 : r.toString()) || "",
    issueLinksClicked: t == null ? void 0 : t.toString()
  }, s = {
    ...n,
    ...o
  };
  e && e.trackCustomEvent("SyncReportOpenedEvent", s), a == null || a();
}
function lm(e, n, i, r) {
  const a = {
    ...i,
    ...{
      issueId: n
    }
  };
  e && e.trackCustomEvent("IssueArticleOpenedEvent", a), r == null || r(n || "");
}
const Gr = X.createContext(void 0), Cm = ({
  data: e,
  workflowMapping: n = Up,
  children: i,
  className: r,
  applicationInsightConnectionString: t,
  applicationInsightInstrumentationKey: a,
  SyncReportOpenedEventProps: o,
  issueArticleOpenEventProps: s
}) => {
  const [u, c] = X.useState("problems"), [l, g] = X.useState(), [R, v] = X.useState("All"), [f, p] = X.useState([]), [D, C] = X.useState(""), _ = Vo(!0), E = Vo(!1), N = Vo(), O = Vo(0);
  let d = 0, m = 0;
  const y = Vo();
  X.useEffect(() => (window.addEventListener("unload", () => Y()), () => {
    var J;
    window.removeEventListener("unload", () => Y()), (J = y.current) == null || J.flushEvent();
  })), oc(() => () => {
    Y();
  }, [e]), oc(() => {
    (t || a) && (y.current = new um(t, a));
  }, []), X.useEffect(() => {
    if (!n)
      return;
    const J = Array.from(new Set(Object.values(n).flatMap((te) => Object.values(te).flatMap((I) => I))));
    p([...J, "Unorganized"]);
  }, [n]), oc(() => {
    var J;
    (J = e == null ? void 0 : e.filerecords) == null || J.map((te) => {
      d = d + te.auditrecords.length, te.auditrecords.map((I) => {
        const T = I.auditinfo.issueid;
        qv(T) && (m += 1);
      });
    }), N.current = {
      issueCount: d,
      linkedIssueCount: m
    };
  }, [e]);
  const Y = $f(() => {
    e != null && _.current && (t || a) && (_.current = !1, cm(y.current, o == null ? void 0 : o.syncReportOpenTelemetry, N.current, O.current, E.current, o == null ? void 0 : o.onSyncReportOpenEventPerform));
  }, [e]), k = $f((J) => {
    O.current += 1, E.current = !0, lm(y.current, J, s == null ? void 0 : s.issueArticleOpenTelemetry, s == null ? void 0 : s.onIssueArticleOpenEventPerform);
  }, []);
  return /* @__PURE__ */ U(QD, {
    theme: "inherit",
    children: /* @__PURE__ */ U(Gr.Provider, {
      value: {
        reportData: e,
        workflowMapping: n,
        currentTable: u,
        setCurrentTable: c,
        currentAuditInfo: l,
        setCurrentAuditInfo: g,
        focusedIssue: R,
        setFocusedIssue: v,
        focusedWorkflows: f,
        setFocusedWorkflows: p,
        activeRow: D,
        setActiveRow: C,
        onIssueArticleOpened: k
      },
      children: /* @__PURE__ */ U("div", {
        className: nr("isr-report-main", r),
        children: i != null ? i : /* @__PURE__ */ ye(Sr, {
          children: [/* @__PURE__ */ ye(kp, {
            children: [/* @__PURE__ */ U(hp, {}), /* @__PURE__ */ U(Op, {})]
          }), /* @__PURE__ */ U(mp, {}), /* @__PURE__ */ ye(Fp, {
            children: [/* @__PURE__ */ U(ln, {
              as: "span",
              children: "Issues found by severity"
            }), /* @__PURE__ */ U(yp, {})]
          }), /* @__PURE__ */ U(bp, {
            children: /* @__PURE__ */ U(Ip, {})
          }), /* @__PURE__ */ ye(Ap, {
            children: [/* @__PURE__ */ U(pp, {}), /* @__PURE__ */ U(Pp, {})]
          })]
        })
      })
    })
  });
};
export {
  pp as ProblemsTable,
  Cm as Report,
  yp as ReportBanner,
  Gr as ReportContext,
  Op as ReportDebugIds,
  Fp as ReportHeaderBannerWrapper,
  Pp as ReportInfoPanel,
  Ap as ReportInfoPanelWrapper,
  Ip as ReportTableSelect,
  bp as ReportTableSelectWrapper,
  mp as ReportTimestamp,
  hp as ReportTitle,
  kp as ReportTitleWrapper,
  HR as ReportType
};
